import vila1 from "@/assets/vila-1.jpg";
import vila2 from "@/assets/vila-2.jpg";
import vila3 from "@/assets/vila-3.jpg";
import vila4 from "@/assets/vila-4.jpg";
import vila5 from "@/assets/vila-5.jpg";
import vila6 from "@/assets/vila-6.jpg";
import vila7 from "@/assets/vila-7.jpg";
import vila8 from "@/assets/vila-8.jpg";
import vila9 from "@/assets/vila-9.jpg";
import vila10 from "@/assets/vila-10.jpg";
import vila11 from "@/assets/vila-11.jpg";
import vila12 from "@/assets/vila-12.jpg";
import vila13 from "@/assets/vila-13.jpg";
import vila14 from "@/assets/vila-14.jpg";
import vila15 from "@/assets/vila-15.jpg";
import vila16 from "@/assets/vila-16.jpg";
import vila17 from "@/assets/vila-17.jpg";
import vila18 from "@/assets/vila-18.jpg";
import vila19 from "@/assets/vila-19.jpg";
import vila20 from "@/assets/vila-20.jpg";
import vila21 from "@/assets/vila-21.jpg";
import vila22 from "@/assets/vila-22.jpg";
import vila23 from "@/assets/vila-23.jpg";
import vila24 from "@/assets/vila-24.jpg";
import vila25 from "@/assets/vila-25.jpg";
import vila26 from "@/assets/vila-26.jpg";
import vila27 from "@/assets/vila-27.jpg";
import vila28 from "@/assets/vila-28.jpg";
import vila29 from "@/assets/vila-29.jpg";
import vila30 from "@/assets/vila-30.jpg";
import vila31 from "@/assets/vila-31.jpg";
import vila32 from "@/assets/vila-32.jpg";
import vila33 from "@/assets/vila-33.jpg";
import vila34 from "@/assets/vila-34.jpg";
import vila35 from "@/assets/vila-35.jpg";
import vila36 from "@/assets/vila-36.jpg";
import vila37 from "@/assets/vila-37.jpg";
import vila38 from "@/assets/vila-38.jpg";
import vila39 from "@/assets/vila-39.jpg";
import floorplan1np3d from "@/assets/floorplan-1np-3d.jpg";
import floorplan2np3d from "@/assets/floorplan-2np-3d.jpg";
import floorplan1pp3d from "@/assets/floorplan-1pp-3d.jpg";
import floorplan1np2d from "@/assets/floorplan-1np-2d.jpg";
import floorplan2np2d from "@/assets/floorplan-2np-2d.jpg";
import floorplan1pp2d from "@/assets/floorplan-1pp-2d.jpg";
import uhonice1 from "@/assets/uhonice-1.jpg";
import { uhoniceImages, uhoniceFloorPlans } from "@/assets/uhonice";
import kv1 from "@/assets/kv-1.jpg";
import { kvImages, kvFloorPlans } from "@/assets/kv";
import satalice1 from "@/assets/satalice-1.jpg";
import { sataliceImages, sataliceFloorPlans } from "@/assets/satalice";
import brnik1 from "@/assets/brnik-1.jpg";
import { brnikImages, brnikFloorPlans } from "@/assets/brnik";
import { brnik2Images, brnik2FloorPlans } from "@/assets/brnik2";
import { brnik3Images, brnik3FloorPlans } from "@/assets/brnik3";
import bohnice1 from "@/assets/bohnice-1.jpg";
import { bohniceImages, bohniceFloorPlans } from "@/assets/bohnice";
import rataje1 from "@/assets/rataje-1.jpg";
import { ratajeImages } from "@/assets/rataje";
import pozden1img from "@/assets/pozden1-1.jpg";
import { pozden1Images, pozden1FloorPlans } from "@/assets/pozden1";
import pozden3img from "@/assets/pozden3-1.jpg";
import pozden2img from "@/assets/pozden2-1.jpg";
import { pozden2Images, pozden2FloorPlans } from "@/assets/pozden2";
import { pozden3Images, pozden3FloorPlans } from "@/assets/pozden3";
import { uhrinesImages, uhrinesFloorPlans } from "@/assets/uhrineves";
import { esteponaImages, esteponaFloorPlans } from "@/assets/estepona";
import { estepona2Images, estepona2FloorPlans } from "@/assets/estepona2";
import { drevnikyImages } from "@/assets/drevniky";
import { herinkImages, herinkFloorPlans } from "@/assets/herink";
import { petrovImages } from "@/assets/petrov";
import { srdovImages, srdovFloorPlans } from "@/assets/srdov";
import { baliImages } from "@/assets/bali";
import { hovorcoviceImages, hovorcoviceFloorPlans } from "@/assets/hovorcovice";
import { vlkanciceImages } from "@/assets/vlkancice";
import { kerskoImages, kerskoFloorPlans } from "@/assets/kersko";
import { nechaniceImages, nechaniceFloorPlans } from "@/assets/nechanice";
import { spindlImages, spindlFloorPlans } from "@/assets/spindl";
import { opolanyImages, opolanyFloorPlans } from "@/assets/opolany";
import { kolovraty2Images, kolovraty2FloorPlans } from "@/assets/kolovraty2";
import { soukalImages, soukalFloorPlans } from "@/assets/soukalova";
import { nachobotImages, nachobotFloorPlans } from "@/assets/nachobot";
import { zdibyImages } from "@/assets/zdiby";
import { brezanyImages } from "@/assets/brezany";
import { rotenskaImages } from "@/assets/rotenska";
import { drnovskaImages } from "@/assets/drnovska";
import { dobrejoviceImages } from "@/assets/dobrejovice";
import { jelenceImages } from "@/assets/jelence";
import { chotecImages, chotecFloorPlans } from "@/assets/chotec";
import { ukubinuImages, ukubinuFloorPlans } from "@/assets/ukubinu";
import ukubinu1 from "@/assets/ukubinu/IMG_9013-1.jpg";
import { mirotinImages, mirotinFloorPlans } from "@/assets/mirotin";
import mirotin1 from "@/assets/mirotin/216A6598-HDR-1.jpg";
import { jelencePozemekImages } from "@/assets/jelence-pozemek";
import { rabyneImages } from "@/assets/rabyne";
import { odolenaVodaImages } from "@/assets/odolena-voda";
import jelencePozemekThumb from "@/assets/jelence-pozemek/DJI_0860-HDR-Edit-1.jpg";
import { tocnaImages } from "@/assets/tocna";
import { jizbiceImages } from "@/assets/jizbice";
import { uhrineves2Images, uhrineves2FloorPlans } from "@/assets/uhrineves2";
import { podoliImages, podoliFloorPlans } from "@/assets/podoli";
import { uhrineves3Images, uhrineves3FloorPlans } from "@/assets/uhrineves3";
import { uhrineves4Images, uhrineves4FloorPlans } from "@/assets/uhrineves4";
import { kolovratyTymImages, kolovratyTymFloorPlans } from "@/assets/kolovraty-tymianova";
import { kolovratyMirovaImages, kolovratyMirovaFloorPlans } from "@/assets/kolovraty-mirova";
import { strasniceImages } from "@/assets/strasnice";
import { strasnicePozemekImages } from "@/assets/strasnice-pozemek";
import { ujezdLesyImages, ujezdLesyFloorPlans } from "@/assets/ujezd-lesy";
import { sestajoviceImages, sestajoviceFloorPlans } from "@/assets/sestajovice";
import { boleslavImages, boleslavFloorPlans } from "@/assets/boleslav";
import { bechoviceImages, bechoviceFloorPlans } from "@/assets/bechovice";
import { kolovratyRicanumImages, kolovratyRicanumFloorPlans } from "@/assets/kolovraty-ricanum";
import { mnichoviceImages, mnichoviceFloorPlans } from "@/assets/mnichovice";
import { mnichoviceBytImages, mnichoviceBytFloorPlans } from "@/assets/mnichovice-byt";
import { mnichoviceMezonetImages, mnichoviceMezonetFloorPlans } from "@/assets/mnichovice-mezonet";
import { zlicinBytImages, zlicinBytFloorPlans } from "@/assets/zlicin-byt";
import { sazavaChataImages, sazavaChataFloorPlans } from "@/assets/sazava-chata";
import { kladnoBytImages, kladnoBytFloorPlans } from "@/assets/kladno-byt";
import { pruhonicePozemekImages } from "@/assets/pruhonice-pozemek";
import { liberecBytImages, liberecBytFloorPlans } from "@/assets/liberec-byt";
import { strizkovBytImages, strizkovBytFloorPlans } from "@/assets/strizkov-byt";
import { unhostImages } from "@/assets/unhost";
import { klecanyImages, klecanyFloorPlans } from "@/assets/klecany";
import { lounyImages, lounyFloorPlans } from "@/assets/louny";

import { stranciceImages, stranciceFloorPlans } from "@/assets/strancice";
import { stodulkyImages } from "@/assets/stodulky";
import { branikPraha4Images, branikPraha4FloorPlans } from "@/assets/branik-praha4";
import { branikPozemekImages, branikPozemekFloorPlans } from "@/assets/branik-pozemek";
import { chotoviceImages, chotoviceFloorPlans } from "@/assets/chotovice";
import { kamykImages, kamykFloorPlans } from "@/assets/kamyk";
import { mecholupyImages, mecholupyFloorPlans } from "@/assets/dolni-mecholupy";
import { slapyImages } from "@/assets/slapy";
import { sobehrdyPozemekImages } from "@/assets/sobehrdy-pozemek";
import { jenstejnImages, jenstejnFloorPlans } from "@/assets/jenstejn";
import { jenstejnA02Images, jenstejnA02FloorPlans } from "@/assets/jenstejn-a02";
import { brezanyDumImages, brezanyDumFloorPlans } from "@/assets/brezany-dum";
import { busDumImages, busDumFloorPlans } from "@/assets/bus-dum";
import { stodulkyBytImages, stodulkyBytFloorPlans } from "@/assets/stodulky-byt";
import { brevnov_byt_48Images, brevnov_byt_48FloorPlans } from "@/assets/brevnov-byt-48";
import { brevnov_obchodImages, brevnov_obchodFloorPlans } from "@/assets/brevnov-obchod";
import { brevnov_byt_60Images, brevnov_byt_60FloorPlans } from "@/assets/brevnov-byt-60";
import { vinohrady_byt_115Images, vinohrady_byt_115FloorPlans } from "@/assets/vinohrady-byt-115";
import { nusle_obchodImages, nusle_obchodFloorPlans } from "@/assets/nusle-obchod";
import { vinohrady_byt_83Images, vinohrady_byt_83FloorPlans } from "@/assets/vinohrady-byt-83";
import { hradecKraloveGocarovaBytImages, hradecKraloveGocarovaBytFloorPlans } from "@/assets/hradec-kralove-gocarova-byt";






const CDN = "https://frantisekbabcicky.cz/wp-content/uploads";

export interface FloorPlan {
  image: string;
  label: string;
}

export interface PropertyVideo {
  youtubeId: string;
  title: string;
  thumbnail?: string;
}

export interface Property {
  id: number;
  slug: string;
  image: string;
  images: string[];
  floorPlans?: FloorPlan[];
  videos?: PropertyVideo[];
  title: string;
  location: string;
  price: string;
  priceNote?: string;
  size: string;
  landSize?: string;
  landSizeLabel?: string;
  parking?: string;
  disposition?: string;
  sold: boolean;
  soldAt?: string;
  reserved?: boolean;
  /** Show price even when sold/reserved */
  showPrice?: boolean;
  features: string[];
  type: string;
  yearBuilt?: string;
  description: string[];
  zakázka?: string;
  mapCoords?: { lat: number; lng: number };
  mapZoom?: number;
  mapUrl?: string;
  matterportUrl?: string;
  utilities?: string;
  hidden?: boolean;
  auction?: {
    endDate: string;
    openHouse?: string;
    participateUrl?: string;
    showDocuments?: boolean;
  };
}

export const properties: Property[] = [
  {
    id: 147,
    slug: "byt-1-kk-praha-9-strizkov-zaksinska",
    image: strizkovBytImages[0],
    images: strizkovBytImages,
    floorPlans: strizkovBytFloorPlans,
    videos: [{ youtubeId: "skePF0cdgu0", title: "Video-prohlídka" }],
    title: "Byt 1+kk na Střížkově – balkon do zeleně, metro nedaleko. Pro vlastní bydlení i investici.",
    location: "Zakšínská, Praha 9 – Střížkov",
    price: "5 900 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "27 m²",
    disposition: "1+kk",
    yearBuilt: "2014",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP13690",
    mapCoords: { lat: 50.1310277778, lng: 14.4923611111 },
    auction: {
      endDate: "2026-11-11T18:00:00Z",
      openHouse: "neděle 8. 11. 2026 – konkrétní čas po domluvě",
      participateUrl: "https://www.remax-czech.cz/reality/detail/451397/prodej-bytu-1-kk-v-osobnim-vlastnictvi-27-m2-praha-9-strizkov#auction_box",
      showDocuments: false,
    },
    description: [
      "Přijďte se podívat na den otevřených dveří v neděli 8. 11. 2026. Nemovitost bude prodána formou realitní aukce RE/MAX, nejlepší nabídce, přičemž majitel si vyhrazuje právo vybrat budoucího kupujícího dle vlastních kritérií. Pro rezervaci konkrétního času prohlídky mě prosím kontaktujte telefonicky nebo e-mailem.",
      "Příjemné zázemí pro život v Praze i praktická volba pro dlouhodobý pronájem. Na adrese Zakšínská 609/13, Praha 9 – Střížkov, nabízím k prodeji světlý byt v osobním vlastnictví o podlahové ploše 26,5 m².",
      "Obývací pokoj s kuchyňským koutem má přibližně 20 m². Navazuje na něj balkon o výměře 3,1 m² s prostorem pro malé posezení a výhledem do upravené zeleně mezi domy. Dispozici doplňuje předsíň o ploše 2,4 m² a koupelna se sprchovým koutem a WC o velikosti 4,1 m². Interiér působí čistě a útulně, jednoduché uspořádání umožňuje zařídit si ho podle vlastních potřeb.",
      "Byt se nachází v 1. nadzemním podlaží sedmipodlažního domu z roku 2014 s výtahem. Energetická náročnost budovy je ve třídě C – úsporná. Podle informací k 13. 10. 2026 nemá SVJ úvěr na dům a ve fondu oprav disponuje přibližně 1,66 milionu Kč.",
      "Ke stanici metra C Střížkov počítejte orientačně s 10 minutami chůze. V okolí najdete potraviny, restaurace i Polikliniku Prosek s lékárnou. Na procházku nebo běh láká nedaleký park Přátelství se soustavou vodních ploch, kaskádami a fontánou. Další možnosti nákupů a zábavy nabízí OC Letňany s multikinem.",
      "Měsíční předpis plateb platný od 1. 10. 2026 činí 4 598 Kč. Zahrnuje zálohu na vytápění 733 Kč, teplou vodu 1 820 Kč, studenou vodu 931 Kč, příspěvek do fondu oprav 265 Kč a správu domu s ostatními službami celkem 849 Kč. Spotřeba elektřiny v bytě v této částce zahrnuta není; konečné náklady na teplo a vodu závisejí na skutečné spotřebě.",
      "Pro více informací a domluvení prohlídky mě kontaktujte. Rád vám byt osobně představím.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 146,
    slug: "byt-2-1-liberec-mlynska",
    image: liberecBytImages[0],
    images: liberecBytImages,
    floorPlans: liberecBytFloorPlans,
    videos: [{ youtubeId: "4Rk-UoWXx8Q", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=Hy1R5EWgn5f&vr=0&play=1&search=0&mt=1&title=0",
    title: "Byt 2+1 s lodžií, 54 m² blízko centra Liberce – s potenciálem 3+kk",
    location: "Mlýnská, Liberec – Perštýn",
    price: "4 490 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "54 m²",
    disposition: "2+1",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Byt",
    zakázka: "ID 205-NP13661",
    mapCoords: { lat: 50.7643230, lng: 15.0621503 },
    description: [
      "Ráno na tramvaj pár kroků, na nákup pěšky a centrum města na dosah. Byt na adrese Mlýnská 264/27, Liberec IV – Perštýn nabízí praktickou polohu, prostorné pokoje a možnost vytvořit si bydlení podle vlastních představ. Zajímavý je také pro zájemce o investici a budoucí pronájem.",
      "Byt v osobním vlastnictví se nachází ve 3. nadzemním podlaží cihlového domu a má podlahovou plochu 54,40 m². Navíc nabízí lodžii o přibližné výměře 2 m² orientovanou do dvora. K bytu patří také půdní kóje o orientační výměře cca 4 m². Interiéru dodávají charakter dřevěné parkety a velká okna. Současný stav nabízí prostor pro modernizaci a vlastní nápady.",
      "Dispozice je nyní 2+1. Prostorná kuchyň však nabízí možnost spojit vaření, jídelní kout i obývací část v jedné místnosti. Zbývající dva pokoje pak mohou sloužit jako ložnice a dětský pokoj nebo pracovna. Přiložený návrh 3+kk ukazuje, jak by takové uspořádání mohlo vypadat.",
      "Byt tvoří pokoj o výměře 17,2 m², ložnice 15,2 m², kuchyň s možností obývací části 14,8 m², předsíň 3,1 m² a koupelna s vanou a WC 3,74 m². Výměry jednotlivých místností vycházejí z orientačního půdorysu, celková podlahová plocha z předpisu úhrad.",
      "Každodenní život tu zvládnete i bez auta. Tramvajová zastávka je přímo u domu, v docházkové vzdálenosti najdete Lidl, terminál MHD Fügnerova i obchodní centrum Forum s Tescem, lékárnou, restauracemi, kavárnami a kinem. V okolí se nachází také ZŠ Oblačná.",
      "Měsíční předpis SVJ činí 1 747 Kč pro jednu osobu; nejde o celkové náklady na bydlení. Ohřev vody zajišťuje elektrický bojler. Plynoměr je demontovaný a případné obnovení plynového vytápění vyžaduje ověření technického stavu.",
      "Hledáte vlastní bydlení blízko centra, které si upravíte po svém, nebo byt pro budoucí pronájem? Zavolejte mi a domluvíme si prohlídku.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 144,
    slug: "byt-3-1-kladno-vrapice-vrapicka",
    image: kladnoBytImages[0],
    images: kladnoBytImages,
    floorPlans: kladnoBytFloorPlans,
    videos: [{ youtubeId: "KcIoPYFBy0E", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=G8mTUd3qZwC&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prostorný byt 3+1, 109,6 m² po rekonstrukci se společnou zahradou, Kladno – Vrapice",
    location: "Vrapická, Kladno – Vrapice",
    price: "11 500 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "110 m²",
    landSize: "1 332 m²",
    landSizeLabel: "Společná zahrada",
    parking: "2 parkovací místa",
    disposition: "3+1",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP13551",
    mapCoords: { lat: 50.1643889, lng: 14.1526389 },
    description: [
      "Téměř čtyřmetrové stropy, dubové parkety a světlý mramor. Byt, který zaujme už při prvním vstupu. A za domem společná zahrada, kde můžete posedět, grilovat nebo otevřít branku a vyrazit rovnou do lesa.",
      "Nabízím k prodeji byt 3+1 v osobním vlastnictví v ulici Vrapická 33 v Kladně‑Vrapicích. Nachází se v prvním nadzemním podlaží historického zděného domu a podle prohlášení vlastníka má podlahovou plochu 109,6 m². Prošel kompletní rekonstrukcí, která spojila charakter staršího domu s pohodlím současného bydlení.",
      "Tady stojí za pozornost i samotné materiály. Dubové parkety skládané do stromečku doplňují podlahy ze světlého mramoru s výraznou kresbou. Velká špaletová okna a stropy vysoké přibližně 3,90 metru dávají místnostem vzdušnost. O tepelný komfort se stará podlahové topení, vstup do bytu zajišťují bezpečnostní dveře.",
      "Z předsíně o ploše 9,18 m² vstoupíte do obývacího pokoje s výměrou 26,80 m². Má dost místa pro velkou sedačku, knihovnu i pohodlné křeslo u okna.",
      "Samostatná kuchyň s jídelnou nabízí 21,60 m². Vejde se sem velký jídelní stůl a příprava rozvodů počítá i s kuchyňským ostrůvkem. Linka zatím není osazená, takže si její uspořádání, materiály i spotřebiče můžete vybrat podle sebe.",
      "Z kuchyně se vstupuje do dvou dalších pokojů. Větší má 17,26 m² a můžete ho využít jako hlavní ložnici. Druhý pokoj o ploše 11,94 m² dobře poslouží jako dětský pokoj, pracovna nebo další ložnice.",
      "Koupelna s vanou a toaletou má 4,72 m². Praktickým doplněním je druhé, samostatné WC o výměře 1,66 m². Navazující chodba má 1,72 m². Nad částí bytu se nachází technický prostor o orientační ploše 8,56 m², přístupný po skládacích schůdcích, ve kterém je umístěný také zásobník teplé vody.",
      "Uvedené plochy jednotlivých místností vycházejí z půdorysu a jsou orientační. Celková podlahová plocha bytu podle prohlášení vlastníka činí 109,6 m².",
      "Bydlení tady pokračuje i za dveřmi bytu. V zadní části domu je uzavřený společný dvůr se zahradou, místem pro posezení, grilování a dětské hry. Z tohoto prostoru vede přímý vstup do lesa. Na procházku tak můžete vyrazit rovnou od domu. V areálu je také možnost venkovního parkování za vjezdovou bránou na dálkové ovládání.",
      "V docházkové vzdálenosti je vlaková zastávka Kladno‑Vrapice, spojení po Kladně zajišťuje také autobusová linka 604. Obchody, školy a další služby jsou dostupné v ostatních částech města. Autem se směrem na Prahu napojíte na dálnici D7.",
      "Pokud máte rádi vysoké stropy, poctivé materiály a oceníte zahradu i les hned u domu, tenhle byt stojí za osobní prohlídku. Zavolejte mi a domluvíme si termín.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 143,
    slug: "chata-sazava-u-reky",
    image: sazavaChataImages[0],
    images: sazavaChataImages,
    floorPlans: sazavaChataFloorPlans,
    videos: [{ youtubeId: "fFOO1-9jPxs", title: "Video-prohlídka" }],
    title: "Chata 100 m² přímo u řeky s vlastním pozemkem 1 196 m², Sázava",
    location: "Sázava, okres Benešov",
    price: "10 500 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "100 m²",
    landSize: "1 196 m²",
    disposition: "5+",
    parking: "2 parkovací místa před pozemkem",
    utilities: "Vlastní kopaná studna, jímka, elektřina 230/400 V, internet",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Chata",
    zakázka: "ID 205-NP13599",
    mapCoords: { lat: 49.8648333, lng: 14.9220278 },
    description: [
      "Místo pro společné víkendy, návštěvy přátel i delší pobyty. Nabízím k prodeji chatu se třemi podlažími a vlastním pozemkem o celkové výměře 1 196 m². Pozemek přímo sousedí s řekou Sázavou, ke které se dostanete přes zahradu.",
      "V hlavním podlaží najdete obývací pokoj s kuchyňským koutem o výměře 23,6 m² a ložnici o ploše 16,7 m². Dispozici doplňuje předsíň 4,5 m², koupelna 1,8 m² a samostatné WC 1,6 m².",
      "Horní podlaží nabízí další ložnici o výměře 22 m², pokoj 10,8 m² a chodbu se schodištěm 10,2 m². Díky odděleným pokojům má své místo rodina i případné návštěvy.",
      "Ve spodním podlaží je pokoj o ploše 23,4 m², dílna 8,8 m² a sklep 13,4 m². Chata tak poskytuje také praktické zázemí pro nářadí, vybavení a koníčky. Součet orientačních ploch místností ve všech třech podlažích činí 136,8 m² včetně dílny a sklepa.",
      "Vytápění zajišťuje krbová vložka a infrapanely. Chata má plastová okna a zateplení o tloušťce 12 cm. Voda je přivedena z vlastní kopané studny hluboké přibližně 9 metrů, odpadní vody jsou svedeny do jímky. Ohřev vody zajišťuje bojler o objemu 120 litrů.",
      "Zavedena je jednofázová i třífázová elektřina s nízkým tarifem, běžně označovaným jako noční proud. K dispozici je internet, satelitní televize a kamerový dohled. Při současném způsobu užívání uvádí majitelka měsíční provozní náklady přibližně 5 000 Kč včetně svozu odpadu.",
      "Parkovat lze před pozemkem, přibližně 20 metrů od něj. Podle majitelky se přístupová cesta udržuje také v zimě. V blízkosti je vlakové spojení a dálnice D1 je podle jejích informací vzdálena přibližně 10 kilometrů.",
      "Běžné nákupy vyřídíte přímo v Sázavě, kde jsou obchody s potravinami, restaurace a kavárny. Na výlet můžete vyrazit k Sázavskému klášteru, na naučnou stezku Votočnice nebo do okolních lesů. Posázaví nabízí také možnosti cyklistiky a vodáckých výletů. Dalším cílem může být hrad Český Šternberk nebo Rataje nad Sázavou.",
      "Chata má také zajímavý investiční potenciál pro rekreační pronájem. Po dořešení přístavby a ověření podmínek tohoto využití lze uvažovat o týdenních pobytech v hlavní sezoně i kratších víkendových pronájmech. Poloha přímo u řeky, několik samostatných pokojů a možnosti výletů v okolí jsou dobrým základem pro nabídku rodinných dovolených. Vlastní rekreaci tak můžete spojit s možností příjmu v termínech, kdy chatu sami nevyužíváte.",
      "Přiložené půdorysy zachycují současné uspořádání chaty včetně přístavby, která dosud není promítnuta v katastru nemovitostí. Majitelka nyní řeší potřebné kroky k jejímu zápisu. Rozsah stavby proto zatím neodpovídá katastrální evidenci. Uvedené výměry místností jsou orientační. Aktuální stav vyřizování a další postup zájemcům podrobně vysvětlím.",
      "Pro více informací nebo domluvení prohlídky mě kontaktujte. Rád vás chatou provedu.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 142,
    slug: "byt-4-kk-praha-5-zlicin-sazovicka",
    image: zlicinBytImages[0],
    images: zlicinBytImages,
    floorPlans: zlicinBytFloorPlans,
    videos: [{ youtubeId: "rblHlEK1Y70", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=SCSNzMUmrHM&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prostorný byt 4+kk, 116 m² s terasou 61,7 m² a dvěma garážovými stáními, Praha 5 – Zličín",
    location: "Sazovická, Praha 5 – Zličín",
    price: "17 950 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "116 m²",
    parking: "2 garážová stání",
    disposition: "4+kk",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP13614",
    mapCoords: { lat: 50.0563056, lng: 14.2813889 },
    description: [
      "Nabízíme k prodeji prostorný byt 4+kk o podlahové ploše 116 m² s výjimečnou terasou o velikosti 61,7 m² v ulici Sazovická, Praha-Zličín. Byt se nachází v 5. nadzemním podlaží a nabízí příjemnou kombinaci velkorysého vnitřního prostoru, nadstandardního venkovního prostoru a praktického zázemí pro každodenní život. Kolaudace bytu proběhla v červenci 2018.",
      "Hlavní obytnou část tvoří prostorný obývací pokoj s kuchyňským koutem o velikosti 36,5 m², na který navazuje velká terasa. Dále jsou zde tři samostatné pokoje o velikostech 19,3 m², 12,7 m² a 12,7 m², dvě koupelny s WC, komora a předsíň. Komfort bydlení zvyšuje klimatizace instalovaná v každém pokoji.",
      "Největším benefitem bytu je bezpochyby terasa o velikosti 61,7 m². Je vybavena moderní bioklimatickou pergolou a nabízí dostatek prostoru pro pohodlné venkovní posezení, odpočinek, grilování i pěstování zeleně. Díky otevřenému výhledu do okolí se terasa stává skutečným prodloužením obytného prostoru a příjemným místem pro trávení volného času.",
      "K bytu náleží také sklep o velikosti 3 m² a dvě garážová parkovací stání. Jedno z nich je samostatně uzavřené a nabízí dostatek prostoru pro pracovní zázemí a zároveň pro uložení nářadí či dalšího vybavení.",
      "Lokalita Praha-Zličín nabízí výbornou kombinaci městského komfortu a možnosti trávit volný čas v zeleni. Rodiny s dětmi ocení základní a mateřskou školu přímo v rámci sídliště, přibližně 300 metrů od domu. V okolí se nachází také fotbalové hřiště a nový atletický ovál. Několik dětských hřišť a Park Na Prameništi poskytují další možnosti pro odpočinek a volnočasové aktivity.",
      "Výbornou dostupnost zajišťuje autobusová zastávka Nový Zličín vzdálená přibližně 100 metrů od domu. Stanice metra je dostupná přibližně 700 metrů pěšky. Pro každodenní nákupy jsou v docházkové vzdálenosti větší potraviny, přibližně 150 metrů od domu. Další možnosti nákupů, služeb i volnočasových aktivit nabízejí obchodní centra Metropole Zličín a HomePark Zličín.",
      "Velkou výhodou je také rychlé napojení na Pražský okruh a Rozvadovskou spojku, díky kterému je Zličín dobře dostupný autem.",
      "Měsíční náklady na bydlení pro tři osoby činí přibližně 9 650 Kč a zahrnují zálohy na teplou a studenou vodu, vytápění, příspěvek do fondu oprav a další služby spojené s užíváním bytu. Zálohy na elektřinu jsou aktuálně stanoveny na 2 000 Kč měsíčně.",
      "Byt je vhodný pro ty, kteří hledají prostorné bydlení s mimořádně velkou terasou, klimatizací ve všech pokojích, dvěma garážovými stáními a nadstandardním úložným a pracovním zázemím.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 141,
    slug: "mezonetovy-byt-3-1-mnichovice-bezrucova",
    image: mnichoviceMezonetImages[0],
    images: mnichoviceMezonetImages,
    floorPlans: mnichoviceMezonetFloorPlans,
    title: "Prostorný mezonetový byt 3+1, 78,9 m² s podílem na zahradě a polovinou dvougaráže, Mnichovice – Bezručova",
    location: "Bezručova, Mnichovice",
    price: "9 700 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "78,9 m²",
    landSize: "80 m²",
    landSizeLabel: "Zahrada (podíl)",
    parking: "Polovina dvougaráže",
    disposition: "3+1",
    sold: false,
    reserved: false,
    features: ["Exkluzivně"],
    type: "Byt",
    zakázka: "ID 205-NP13610",
    mapCoords: { lat: 49.9338056, lng: 14.7118889 },
    description: [
      "Nabízíme k prodeji prostorný mezonetový byt 3+1 o celkové ploše 78,9 m² v ulici Bezručova v Mnichovicích. Byt se nachází ve 2. a 3. nadzemním podlaží domu a nabízí praktické dvoupodlažní uspořádání, dostatek prostoru pro pohodlné rodinné bydlení a příjemné zázemí v podobě zahrady a dvougaráže.",
      "V dolní úrovni bytu se nachází samostatné WC, prostorná kuchyně o velikosti 15,2 m² a obývací pokoj o velikosti 22,6 m², ze kterého vede schodiště do horního podlaží.",
      "Horní patro tvoří ložnice o velikosti 22,9 m², další pokoj o velikosti 12,2 m², samostatné WC a koupelna o velikosti 5 m² s rohovou vanou.",
      "Mezonetové uspořádání příjemně odděluje denní a klidovou část bytu. V dolní části tak vzniká prostorné zázemí pro společné trávení času, zatímco horní patro nabízí dostatek soukromí pro celou rodinu.",
      "K bytu náleží také podíl na zahradě za domem. Ta nabízí příjemné zázemí pro odpočinek a trávení volného času. K dispozici je upravený travnatý prostor, terasa s venkovním posezením a zděný gril, který vybízí k letnímu posezení s rodinou nebo přáteli.",
      "Součástí nabídky je také polovina prostorné dvougaráže v přízemí domu, která poskytuje praktické zázemí pro parkování i uložení dalších věcí.",
      "Dům prošel v roce 2008 kompletní přestavbou a rekonstrukcí včetně zateplení fasády a výměny oken. Byt má vlastní plynový kotel a samostatné měření energií. K dispozici je také centrální vysavač.",
      "Mnichovice jsou vyhledávanou lokalitou s výbornou dostupností do Prahy a kompletní občanskou vybaveností. Přímo v místě se nachází mateřská i základní škola, obchody, služby a další potřebná občanská vybavenost. Základní škola je od domu vzdálena jen několik minut chůze.",
      "Výborná je také dopravní dostupnost. Vlakové spojení umožňuje cestu do centra Prahy přibližně za 33 minut, autem se do Prahy dostanete zhruba za 20 minut.",
      "Tento mezonetový byt nabízí pohodlné rodinné bydlení s velkorysou dispozicí, prostorným obývacím pokojem, podílem na zahradě a polovinou dvougaráže, a to v dobře dostupné lokalitě s rychlým spojením do Prahy.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 140,
    slug: "byt-3-1-mnichovice-bezrucova",
    image: mnichoviceBytImages[0],
    images: mnichoviceBytImages,
    floorPlans: mnichoviceBytFloorPlans,
    title: "Prostorný mezonetový byt 3+1, 80 m² s balkonem, podílem na zahradě a polovinou dvougaráže, Mnichovice – Bezručova",
    location: "Bezručova, Mnichovice",
    price: "9 950 000 Kč",
    size: "80 m²",
    landSize: "80 m²",
    landSizeLabel: "Zahrada (podíl)",
    parking: "Polovina dvougaráže",
    disposition: "3+1",
    sold: false,
    reserved: false,
    features: ["Exkluzivně"],
    type: "Byt",
    zakázka: "ID 205-NP13611",
    mapCoords: { lat: 49.9338056, lng: 14.7118889 },
    description: [
      "Nabízíme k prodeji prostorný mezonetový byt 3+1 o celkové ploše 84,1 m² včetně balkonu v ulici Bezručova v Mnichovicích. Byt se nachází ve 2. a 3. nadzemním podlaží domu a nabízí praktické dvoupodlažní uspořádání, dostatek prostoru pro pohodlné rodinné bydlení a balkon s výhledem do zahrady.",
      "V dolní úrovni bytu se nachází hlavní chodba, samostatné WC, prostorná kuchyně o velikosti 15,1 m² a obývací pokoj o velikosti 20,6 m², ze kterého je vstup na balkon o velikosti 4,3 m² s výhledem do zahrady. Z obývacího pokoje vede schodiště do horního podlaží.",
      "Horní patro tvoří ložnice o velikosti 18,4 m², další pokoj o velikosti 12,4 m², chodba, samostatné WC a koupelna o velikosti 5 m² s rohovou vanou.",
      "Mezonetové uspořádání příjemně odděluje denní a klidovou část bytu. V dolní části tak vzniká prostorné zázemí pro společné trávení času, zatímco horní patro nabízí dostatek soukromí pro celou rodinu.",
      "K bytu náleží také podíl na zahradě za domem. Ta nabízí příjemné zázemí pro odpočinek a trávení volného času. K dispozici je upravený travnatý prostor, terasa s venkovním posezením a zděný gril, který vybízí k letnímu posezení s rodinou nebo přáteli.",
      "Součástí nabídky je také polovina prostorné dvougaráže v přízemí domu, která poskytuje praktické zázemí pro parkování i uložení dalších věcí.",
      "Dům prošel v roce 2008 kompletní přestavbou a rekonstrukcí včetně zateplení fasády a výměny oken. Byt má vlastní plynový kotel a samostatné měření energií. K dispozici je také centrální vysavač.",
      "Mnichovice jsou vyhledávanou lokalitou s výbornou dostupností do Prahy a kompletní občanskou vybaveností. Přímo v místě se nachází mateřská i základní škola, obchody, služby a další potřebná občanská vybavenost. Základní škola je od domu vzdálena jen několik minut chůze.",
      "Výborná je také dopravní dostupnost. Vlakové spojení umožňuje cestu do centra Prahy přibližně za 33 minut, autem se do Prahy dostanete zhruba za 20 minut.",
      "Tento mezonetový byt nabízí pohodlné rodinné bydlení s velkorysou dispozicí, balkonem, podílem na zahradě a polovinou dvougaráže, a to v dobře dostupné lokalitě s rychlým spojením do Prahy.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 139,
    slug: "byt-1-1-hradec-kralove-gocarova-trida",
    image: hradecKraloveGocarovaBytImages[0],
    images: hradecKraloveGocarovaBytImages,
    floorPlans: hradecKraloveGocarovaBytFloorPlans,
    videos: [{ youtubeId: "tMsp0u6bmjI", title: "Video-prohlídka" }],
    title: "Byt 1+1, 36 m² se dvěma lodžiemi a sklepem, Hradec Králové – Pražské Předměstí",
    location: "Gočárova třída, Hradec Králové – Pražské Předměstí",
    price: "4 260 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "36 m²",
    disposition: "1+1",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP13465",
    mapCoords: { lat: 50.2141, lng: 15.8107 },
    mapZoom: 16,
    description: [
      "Nabízíme k prodeji byt v osobním vlastnictví o dispozici 1+1 a výměře 36 m², který se nachází ve 3. nadzemním podlaží cihlového bytového domu na Gočárově třídě v Hradci Králové – Pražském Předměstí.",
      "Byt je v původním stavu a je určen k rekonstrukci, což novému majiteli nabízí možnost vytvořit si bydlení přesně podle svých představ. Dispozice bytu nabízí prostorný pokoj, samostatnou kuchyň, koupelnu, WC, předsíň a praktickou šatnu.",
      "K bytu náleží sklep a hned dvě lodžie o celkové ploše 4,25 m², které příjemně rozšiřují obytný prostor. Byt je vhodný jak pro vlastní bydlení, tak jako investiční příležitost. V domě není výtah.",
      "Velkou předností je samotná lokalita. Gočárova třída se nachází v širším centru Hradce Králové a nabízí výbornou dostupnost občanské vybavenosti i městské infrastruktury. V okolí najdete obchody, restaurace, služby, školy i další možnosti každodenního vyžití.",
      "V pěší vzdálenosti je vlakové i autobusové nádraží a centrum Hradce Králové je snadno dostupné pěšky, městskou hromadnou dopravou i autem.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 131,
    slug: "byt-3-kk-praha-3-vinohrady-115m2",
    image: vinohrady_byt_115Images[0],
    images: vinohrady_byt_115Images,
    floorPlans: vinohrady_byt_115FloorPlans,
    title: "Elegantní byt 3+kk, 115,1 m² ve 4. NP rezidence po luxusní rekonstrukci, Praha 3 – Vinohrady",
    location: "Vinohradská, Praha 3 – Vinohrady",
    price: "22 431 000 Kč",
    priceNote: "vč. DPH, poplatků, provize a právního servisu",
    size: "115 m²",
    disposition: "3+kk",
    sold: false,
    reserved: false,
    features: [],
    type: "Byt",
    zakázka: "ID 205-NP13487",
    mapCoords: { lat: 50.0776, lng: 14.4536 },
    description: [
      "Byt o dispozici 3+kk a podlahové ploše 115,1 m² nabízí velkorysý prostor, který si vás získá už při prvním kroku. Nachází se ve 4. podlaží reprezentativního domu po luxusní rekonstrukci a je připraven k dokončení ve standardu fit out – nové parkety, omítky, interiérové i vstupní dveře a kompletní nové rozvody vám dávají ideální základ pro vytvoření domova přesně podle vašich představ.",
      "Velký obývací prostor s přípravou na kuchyňský kout je srdcem bytu – prosvětlený, vzdušný a stvořený pro společná setkání. Dvě ložnice nabízejí soukromí a klid, nechybí koupelna, samostatné WC ani dostatek úložného prostoru. Samozřejmostí je praktická sklepní kóje. Celý dům spojuje noblesu historické architektury s moderním komfortem. Reprezentativní vstupní prostory zdobí dřevo, mramor, kartáčovaný bronz i sklo. Nechybí recepce, sauna ani vnitroblok se zahradou – dokonalé místo pro chvíle klidu uprostřed města.",
      "Vinohrady jsou synonymem pro životní styl, který spojuje eleganci a energii města. Čekají vás tu kavárny s výběrovou kávou, bistra s avokádovým toastem i vinárny, kde znáte jménem nejen sommeliéra, ale i sousedy. Přilehlé parky s dechberoucími výhledy lákají k odpočinku i sportu, farmářské trhy k setkávání a místní divadla a galerie k inspiraci. Podle časopisu Time Out patří Vinohrady mezi nejvíce „cool“ čtvrti na světě. Tady prostě chcete žít.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 132,
    slug: "byt-3-kk-praha-3-vinohrady-83m2",
    image: vinohrady_byt_83Images[0],
    images: vinohrady_byt_83Images,
    floorPlans: vinohrady_byt_83FloorPlans,
    title: "Elegantní byt 3+kk, 83,3 m² se dvěma terasami v 7. NP, Praha 3 – Vinohrady",
    location: "Vinohradská, Praha 3 – Vinohrady",
    price: "21 356 000 Kč",
    priceNote: "vč. DPH, poplatků, provize a právního servisu",
    size: "83 m²",
    disposition: "3+kk",
    sold: false,
    reserved: false,
    features: [],
    type: "Byt",
    zakázka: "ID 205-NP13488",
    mapCoords: { lat: 50.0776, lng: 14.4536 },
    description: [
      "Byt o dispozici 3+kk a podlahové ploše 83,3 m² nabízí velkorysý prostor, který si vás získá už při prvním kroku. Nachází se v 7. podlaží reprezentativního domu po luxusní rekonstrukci a je připraven k dokončení ve standardu fit out – nové parkety, omítky, interiérové i vstupní dveře a kompletní nové rozvody vám dávají ideální základ pro vytvoření domova přesně podle vašich představ.",
      "Velký obývací prostor s přípravou na kuchyňský kout je srdcem bytu – prosvětlený, vzdušný a stvořený pro společná setkání. Dvě ložnice nabízejí soukromí a klid, nechybí koupelna, samostatné WC ani dostatek úložného prostoru. K bytu jsou také dvě terasy 14 m² a 11,4 m². Samozřejmostí je praktická sklepní kóje. Celý dům spojuje noblesu historické architektury s moderním komfortem. Reprezentativní vstupní prostory zdobí dřevo, mramor, kartáčovaný bronz i sklo. Nechybí recepce, sauna ani vnitroblok se zahradou – dokonalé místo pro chvíle klidu uprostřed města.",
      "Vinohrady jsou synonymem pro životní styl, který spojuje eleganci a energii města. Čekají vás tu kavárny s výběrovou kávou, bistra s avokádovým toastem i vinárny, kde znáte jménem nejen sommeliéra, ale i sousedy. Přilehlé parky s dechberoucími výhledy lákají k odpočinku i sportu, farmářské trhy k setkávání a místní divadla a galerie k inspiraci. Podle časopisu Time Out patří Vinohrady mezi nejvíce „cool“ čtvrti na světě. Tady prostě chcete žít.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 134,
    slug: "byt-2-kk-praha-6-brevnov-pod-drinopolem-60m2",
    image: brevnov_byt_60Images[0],
    images: brevnov_byt_60Images,
    floorPlans: brevnov_byt_60FloorPlans,
    title: "Moderní plně vybavený byt 2+kk, 60,3 m² se sklepem, Praha 6 – Břevnov",
    location: "Pod Drinopolem, Praha 6 – Břevnov",
    price: "10 996 000 Kč",
    priceNote: "vč. DPH, poplatků, provize a právního servisu",
    size: "60 m²",
    disposition: "2+kk",
    sold: false,
    reserved: false,
    features: [],
    type: "Byt",
    zakázka: "ID 205-NP13483",
    mapCoords: { lat: 50.0847, lng: 14.3813 },
    description: [
      "Kompletně vybavený byt o dispozici 2+kk je součástí rezidenčního projektu Pod Drinopolem, který vzniká kompletní rekonstrukcí bytového domu v jedné z nejklidnějších částí Prahy 6. Lokalita uprostřed vilové čtvrti nabízí kombinaci zeleně, soukromí a výborné dostupnosti do centra. Součástí domu je soukromá sauna a posilovna.",
      "Půdorys bytu v 1. podlaží a o a podlahové ploše 60,3 m² zahrnuje obývací pokoj, kuchyni, ložnici, vstupní chodbu, koupelnu se sprchovým koutem a samostatnou toaletou. K jednotce náleží také sklepní kóje. Byt se prodává kompletně vybavený nábytkem na míru a po dokončení rekonstrukce domu je vhodný k okamžitému nastěhování.",
      "Dům prochází celkovou rekonstrukcí, jejíž součástí je nový výtah, vstupní portály s bezpečnostními dveřmi a kvalitně provedené společné prostory s keramickou dlažbou a dřevěnými prvky. Obyvatelům bude k dispozici relaxační zóna se saunou a fitness, kolárna, prádelna a upravený vnitroblok s klidovou částí a posezením. Rezidence se nachází v tiché ulici Pod Drinopolem, obklopené zelení a rezidenční zástavbou. V docházkové vzdálenosti je veškerá občanská vybavenost včetně obchodů, kaváren, škol i zastávek MHD. Lokalita nabízí pohodové zázemí s rychlým spojením do centra i na letiště.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 135,
    slug: "byt-2-kk-praha-6-brevnov-pod-drinopolem-48m2",
    image: brevnov_byt_48Images[0],
    images: brevnov_byt_48Images,
    floorPlans: brevnov_byt_48FloorPlans,
    title: "Moderní byt 2+kk, 48 m² s balkonem a sklepem, Praha 6 – Břevnov",
    location: "Pod Drinopolem, Praha 6 – Břevnov",
    price: "9 491 000 Kč",
    priceNote: "vč. DPH, poplatků, provize a právního servisu",
    size: "48 m²",
    disposition: "2+kk",
    sold: false,
    reserved: false,
    features: [],
    type: "Byt",
    zakázka: "ID 205-NP13484",
    mapCoords: { lat: 50.0847, lng: 14.3813 },
    description: [
      "Byt o dispozici 2+kk je součástí rezidenčního projektu Pod Drinopolem, který vzniká kompletní rekonstrukcí bytového domu v jedné z nejklidnějších částí Prahy 6. Lokalita uprostřed vilové čtvrti nabízí kombinaci zeleně, soukromí a výborné dostupnosti do centra. Součástí domu je soukromá sauna a posilovna.",
      "Půdorys bytu v 1. podlaží a o a podlahové ploše 48 m² zahrnuje obývací pokoj s přípravou na kuchyni, ložnici, vstupní chodbu, praktickou komoru, koupelnu se sprchovým koutem a samostatnou toaletou. K jednotce náleží také sklepní kóje. Byt bude dokončen v provedení fit out – včetně hotové koupelny, podlah, dveří a kompletních rozvodů. Veškeré vybavení odpovídá současným standardům moderního bydlení.",
      "Dům prochází celkovou rekonstrukcí, jejíž součástí je nový výtah, vstupní portály s bezpečnostními dveřmi a kvalitně provedené společné prostory s keramickou dlažbou a dřevěnými prvky. Obyvatelům bude k dispozici relaxační zóna se saunou a fitness, kolárna, prádelna a upravený vnitroblok s klidovou částí a posezením. Rezidence se nachází v tiché ulici Pod Drinopolem, obklopené zelení a rezidenční zástavbou. V docházkové vzdálenosti je veškerá občanská vybavenost včetně obchodů, kaváren, škol i zastávek MHD. Lokalita nabízí pohodové zázemí s rychlým spojením do centra i na letiště.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 137,
    slug: "obchodni-prostory-praha-4-nusle-maroldka",
    image: nusle_obchodImages[0],
    images: nusle_obchodImages,
    floorPlans: nusle_obchodFloorPlans,
    title: "Reprezentativní nebytová jednotka 69,3 m² s variabilním využitím, Rezidence Maroldka, Praha 4 – Nusle",
    location: "Maroldova, Praha 4 – Nusle",
    price: "8 562 000 Kč",
    priceNote: "vč. DPH, poplatků, provize a právního servisu",
    size: "69 m²",
    sold: false,
    reserved: false,
    features: [],
    type: "Komerční prostor",
    zakázka: "ID 205-NP13485",
    mapCoords: { lat: 50.0603, lng: 14.4353 },
    description: [
      "Nebytový prostor s přímým vstupem z ulice v přízemí novostavby Rezidence Maroldka nabízí kvalitní zázemí pro podnikání v rozvíjející se části pražských Nuslí. Klidná adresa s pohodlnou dostupností pro klienty vytváří vhodné podmínky zejména pro provozy zaměřené na služby, zdravotnictví či individuální péči – například terapeutická centra, poradenské služby nebo estetické studio.",
      "Jednotka č. 12 o celkové ploše 69,3 m² (včetně sklepa 1,8 m²) se nachází v přízemí domu. Prosvětlený prostor s výlohou orientovanou do ulice nabízí flexibilní využití a dobrou viditelnost. Dispozice i velikost jednotky jsou vhodné jak pro klientský provoz, tak pro kombinaci zázemí a kontaktní části.",
      "Jednotka bude předána ve stavu shell & core, což umožňuje její přizpůsobení konkrétním požadavkům budoucího majitele.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 138,
    slug: "obchodni-prostory-praha-6-brevnov-pod-drinopolem",
    image: brevnov_obchodImages[0],
    images: brevnov_obchodImages,
    floorPlans: brevnov_obchodFloorPlans,
    title: "Reprezentativní komerční prostory 73,5 m² s výlohou, Praha 6 – Břevnov",
    location: "Pod Drinopolem, Praha 6 – Břevnov",
    price: "7 172 000 Kč",
    priceNote: "vč. DPH, poplatků, provize a právního servisu",
    size: "74 m²",
    sold: false,
    reserved: false,
    features: [],
    type: "Komerční prostor",
    zakázka: "ID 205-NP13482",
    mapCoords: { lat: 50.0847, lng: 14.3813 },
    description: [
      "Komerční prostor o velikosti 73,5 m² je součástí nového rezidenčního projektu Pod Drinopolem, který přináší prémiové bydlení v kompletně zrekonstruovaném domě. Lokalita Břevnova nabízí ideální kombinaci městské dostupnosti a rezidenční hustoty – v okolí se nachází zastávka tramvaje Drinopol, stanice metra Hradčanská je dostupná do 8 minut.",
      "Jednotka se nachází v přízemí a je orientována do ulice Pod Drinopolem s vysokou pěší frekvencí. Nabízí samostatný vstup z ulice, výlohu a prostor v provedení Shell & Core s možností úprav dle potřeb budoucího provozu. Je vhodná jako kancelář, showroom, klientské místo, provozovna služeb nebo obchodní jednotka.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 124,
    slug: "mezonet-praha-10-dolni-mecholupy-na-navsi",
    image: mecholupyImages[0],
    images: mecholupyImages,
    floorPlans: mecholupyFloorPlans,
    matterportUrl: "https://my.matterport.com/show/?m=C8S6gwsANkD&vr=0&play=1&search=0&mt=1&title=0",
    title: "Designový mezonet 4+kk s vybavením na míru, terasou a balkónem - Praha 10 – Dolní Měcholupy",
    location: "Na Návsi, Praha 10 – Dolní Měcholupy",
    price: "18 990 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "138 m²",
    disposition: "4+kk",
    parking: "1 parkovací stání",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Byt",
    zakázka: "ID 205-NP13284",
    mapCoords: { lat: 50.0563, lng: 14.5613 },
    videos: [{ youtubeId: "JdsK3aTueIQ", title: "Video-prohlídka" }],
    description: [
      "Nabízíme k prodeji výjimečný, designově řešený mezonetový byt 4+kk o podlahové ploše 138 m², který se nachází ve 2. a 3. NP bytového domu U Jezírka, v ulici Na Návsi, Praha 10 – Dolní Měcholupy.",
      "Byt zaujme velmi vkusným provedením, kde je znát důraz na kvalitu, detail a promyšlené využití prostoru. Vybavení bylo vyrobeno na míru – od kuchyně a vestavěných úložných prostor přes vybavení jednotlivých pokojů a koupelen až po televizní stěnu v obývacím prostoru. Použité materiály, barevnost i jednotlivé prvky spolu dobře ladí a podtrhují moderní design celého bytu.",
      "Ve 2. NP se nachází tři samostatné ložnice, šatna, dvě koupelny, samostatné WC a terasa o velikosti 11 m². Toto podlaží tvoří klidovou část bytu a jednotlivé pokoje poskytují dostatek pohodlí i soukromí všem členům domácnosti.",
      "Ve 3. NP najdete velkorysý obytný prostor propojený s kuchyní a jídelní částí o výměře 45,5 m², komoru, spíž, samostatné WC a balkón o velikosti 10,3 m². Právě horní podlaží je místem, kde může rodina trávit čas společně, ať už při každodenním rodinném životě nebo při setkávání s přáteli. Otevřená dispozice, dostatek světla a přímé propojení s balkónem dodávají této části bytu příjemnou vzdušnost.",
      "V celém bytě jsou dubové dřevěné podlahy, velkoformátová dlažba, venkovní elektrické rolety a klimatizace ve všech místnostech. Koupelny jsou vybaveny sanitou značky Villeroy & Boch. Dostatek denního světla zajišťují také světlovody, které přivádějí přirozené světlo i do dalších částí bytu. Velké množství vestavěných úložných prostor je praktickým prvkem, který zároveň nenarušuje čistý vzhled jednotlivých místností. Celkový dojem doplňuje pečlivě zvolená kombinace dřeva, světlých povrchů a výraznějších designových prvků, díky nimž byt působí moderně, ale zároveň útulně.",
      "Praktické zázemí bytu doplňuje sklep o velikosti 3,7 m² v 1. PP a jedno parkovací stání (možnost přikoupení druhého stání za 750.000,-Kč), které zajišťuje pohodlné parkování přímo v domě. Vytápění bytu je řešeno centrálním plynovým kotlem pro celý dům.",
      "Měsíční zálohy na služby činí 11.111 Kč + 1x 482 Kč za gar. stání a záloha na elektřinu 1.500 Kč měsíčně. Loňské vyúčtování s přeplatkem cca 21.000 Kč.",
      "Dolní Měcholupy nabízí klidné rezidenční prostředí s potřebnou občanskou vybaveností a dobrou dostupností. V místě je MŠ i ZŠ, během chvíle dojedete k OC Štěrboholy či Retail Parku Hornoměcholupská, kde jsou kompletní obchody i služby. Výhodou je vlakové spojení, kterým se na pražské Hlavní nádraží dostanete za 15 minut, stejně jako dobré napojení na hlavní pražské tahy.",
      "Tento mezonet není pouze prostorným bytem. Je to promyšlený a designově dotažený domov, kde se podařilo spojit nadstandardní provedení s praktickým rodinným bydlením. Pokud hledáte právě toto, stojí tento byt rozhodně za osobní prohlídku.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 127,
    slug: "novostavba-domu-5kk-novy-jenstejn-a02",
    image: jenstejnA02Images[0],
    images: jenstejnA02Images,
    floorPlans: jenstejnA02FloorPlans,
    videos: [{ youtubeId: "ODG2dMK5Ipk", title: "Video-prohlídka" }],
    title: "Novostavba rodinného domu 5+kk s velkou zahradou a terasou, Nový Jenštejn – A02",
    location: "Jenštejn, okres Praha-východ",
    price: "17 068 027 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "120 m²",
    landSize: "474 m²",
    disposition: "5+kk",
    parking: "2 parkovací stání",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Dům",
    zakázka: "ID 205-NP13334",
    mapCoords: { lat: 50.1394, lng: 14.6169 },
    description: [
      "Některé domy se vybírají podle počtu místností. Jiné podle toho, jak se v nich bude skutečně žít. Dům A02 nabízí obojí – dostatek prostoru uvnitř a větší zahradu, na které se vejde dlouhý letní večer, dětské dobrodružství i klidná ranní káva.",
      "Samostatně stojící rodinný dům se sedlovou střechou má dispozici 5+kk, čistou podlahovou plochu 119,8 m² a pozemek o velikosti 474 m². Zahrada nabízí přibližně 346 m², na obytnou část navazuje terasa o velikosti 20 m². K domu náleží také dvě parkovací stání na vlastním pozemku.",
      "Srdcem přízemí je obytný prostor s přípravou pro kuchyňský kout o velikosti 35 m². Přímé propojení s terasou a zahradou umožňuje přenést společný život přirozeně ven. Na stejném podlaží se nachází také samostatný pokoj o velikosti 9,9 m² – ideální jako domácí pracovna, pokoj pro návštěvy nebo ložnice pro člena rodiny, který nechce využívat schody. Přízemí dále nabízí koupelnu, šatnu, předsíň a praktický sklad.",
      "Horní patro je navrženo jako soukromá rodinná zóna. Jsou zde tři samostatné pokoje o velikosti 12,3 m², 13,9 m² a 14,4 m², prostorná koupelna a další šatna. Dispozice poskytuje soukromí dětem i rodičům a zároveň dostatek úložného prostoru i v podkroví, které nabízí další využití.",
      "Dům je navržen v energetické třídě B. Ve standardu jsou plastová okna s izolačními trojskly, příprava pro venkovní žaluzie, vinylové podlahy, velkoformátová keramická dlažba, vybavené koupelny a kvalitní interiérové dveře. Vytápění zajišťuje plynový kotel s radiátory, doplněný druhým zdrojem v podobě krbových kamen. Připraveno je optické připojení a datové zásuvky ve všech obytných místnostech.",
      "Zahrada bude oplocená a předána se založeným trávníkem. Zahradní techniku, kola nebo venkovní nábytek pohodlně uložíte v samostatném zahradním skladu.",
      "Projekt vzniká v klidné rezidenční části Jenštejna. Mateřská škola je přímo v sousedství a děti z Jenštejna mohou využívat Svazkovou školu Panská pole v Přezleticích včetně školního autobusu. Linky PID zajišťují spojení ke stanicím metra Letňany a Černý Most i k nádraží v Satalicích. Širší nabídku obchodů a služeb najdete v Letňanech a na Černém Mostě.",
      "Jenštejn nabízí také dětská hřiště, tenisové kurty, restaurace, rybníky, zeleň a atmosféru obce s vlastním hradem. Sportovní centrum v Radonicích, park Amerika a golf ve Mstěticích rozšiřují možnosti pro volný čas.",
      "Předpokládané dokončení: únor 2027.",
      "Dům A02 je vhodný pro rodinu, která chce žít blízko Prahy, ale po návratu domů mít vlastní prostor, zahradu a klid.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 126,
    slug: "novostavba-domu-5kk-novy-jenstejn-a01",
    image: jenstejnImages[0],
    images: jenstejnImages,
    floorPlans: jenstejnFloorPlans,
    videos: [{ youtubeId: "ODG2dMK5Ipk", title: "Video-prohlídka" }],
    title: "Novostavba rodinného domu 5+kk se zahradou a terasou, Nový Jenštejn – A01",
    location: "Jenštejn, okres Praha-východ",
    price: "16 946 932 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "120 m²",
    landSize: "451 m²",
    disposition: "5+kk",
    parking: "2 parkovací stání",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Dům",
    zakázka: "ID 205-NP13333",
    mapCoords: { lat: 50.1394, lng: 14.6169 },
    description: [
      "Tady nemusíte volit mezi klidným rodinným bydlením a dobrou dostupností Prahy. Dům A01 v projektu Nový Jenštejn spojuje obojí – moderní architekturu, vlastní zahradu a promyšlenou dispozici, která funguje v běžném rodinném životě.",
      "Samostatně stojící dvoupodlažní dům se sedlovou střechou nabízí dispozici 5+kk a čistou podlahovou plochu 119,8 m². Stojí na pozemku o velikosti 451 m², jeho součástí je zahrada o ploše přibližně 316 m², terasa 20 m² a dvě parkovací stání na vlastním pozemku.",
      "Přízemí patří společnému životu. Obytný prostor s přípravou pro kuchyňský kout má příjemných 35 m² a přímo navazuje na terasu a zahradu. Nechybí samostatný pokoj o velikosti 9,9 m², který může sloužit jako pracovna, pokoj pro hosty nebo čtvrtá ložnice. Praktické zázemí doplňuje koupelna, šatna, předsíň a sklad.",
      "V patře se nachází klidová část domu se třemi samostatnými pokoji o velikosti 12,3 m², 13,9 m² a 14,4 m². Dále je zde druhá koupelna, šatna a centrální chodba. Každý člen rodiny tak získá vlastní prostor, aniž by dům působil zbytečně rozlehle nebo náročně na údržbu.",
      "Standard domu zahrnuje plastová okna s izolačními trojskly, přípravu pro venkovní žaluzie, vinylové podlahy, keramickou dlažbu, vybavené koupelny a odolné interiérové dveře. Vytápění zajišťuje plynový kotel s radiátory, počítáno je také s krbovými kamny jako druhým zdrojem tepla. Samozřejmostí je optické připojení a datové zásuvky ve všech obytných místnostech. Dům splňuje energetickou třídu B.",
      "Zahrada bude oplocená a upravená se založeným trávníkem. Součástí je rovněž praktický zahradní sklad.",
      "Mateřská škola se nachází v sousedství projektu. Základní vzdělání zajišťuje moderní Svazková škola Panská pole v Přezleticích, kam děti dopravuje školní autobus. Autobusové linky PID nabízejí spojení ke stanicím metra Letňany a Černý Most i k vlakové stanici Satalice. V Jenštejně najdete poštu, restaurace, dětské hřiště a tenisové kurty. Okolí nabízí rybníky, zeleň, sportovní areál v Radonicích i golfové hřiště ve Mstěticích.",
      "Předpokládané dokončení: únor 2027.",
      "Pokud hledáte dům, který nabídne dostatek prostoru, ale nezahltí vás zbytečnými metry, A01 stojí za osobní setkání. Rád vám představím projekt, standardy i možnosti financování.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 130,
    slug: "byt-3-1-praha-5-stodulky-habova",
    image: stodulkyBytImages[0],
    images: stodulkyBytImages,
    floorPlans: stodulkyBytFloorPlans,
    matterportUrl: "https://my.matterport.com/show/?m=G3uj1sfATpC&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prostorný byt 3+1 se zasklenou lodžií a sklepem, 70 m², 100 m od metra B Stodůlky, Praha 5",
    location: "Hábova, Praha 5 – Stodůlky",
    price: "8 450 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "70 m²",
    disposition: "3+1",
    sold: true,
    soldAt: "2026-10-20",
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Byt",
    zakázka: "ID 205-NP13357",
    mapCoords: { lat: 50.0459, lng: 14.3363 },
    videos: [{ youtubeId: "e81uIVwBda0", title: "Video-prohlídka" }],
    description: [
      "Nabízíme k prodeji byt 3+1 o celkové ploše 77,92 m² na adrese Hábova 1566/12, 155 00 Praha 13 – Stodůlky. Podlahová plocha bytu činí 69,78 m², k bytu dále náleží zasklená lodžie o výměře 6,84 m² a sklep o velikosti 1,30 m² v suterénu domu.",
      "Byt je v původním stavu před rekonstrukcí a nabízí tak skvělou příležitost vytvořit si bydlení přesně podle vlastních představ. Dispozice 3+1 poskytuje dostatek prostoru pro pohodlné rodinné bydlení a nabízí tři samostatné pokoje, prostornou kuchyň, předsíň, koupelnu, samostatné WC a praktickou komoru přímo v bytě.",
      "Kuchyň má výměru 12,58 m², obytný prostor 18,34 m² a další dva pokoje 12,02 m² a 12,59 m². Předsíň má 9,10 m², koupelna 2,88 m², samostatné WC 0,99 m² a komora 1,28 m². Příjemným bonusem je zasklená lodžie o velikosti 6,84 m², na kterou je vstup z obytného prostoru, a která nabízí další prostor pro posezení či odpočinek.",
      "Měsíční náklady činí 5 272 Kč včetně fondu oprav a záloh na služby SVJ + zálohy na elektřinu ve výši 850 Kč. Plynová přípojka byla odpojena.",
      "Panelový dům prošel revitalizací, je zateplený a má plastová okna. V domě je výtah, byt se nachází v 6. podlaží z celkových 8. Energetická náročnost budovy: B – velmi úsporná.",
      "Velkou předností je výborná poloha. Stanice metra B Stodůlky je vzdálena přibližně 100 metrů od domu, takže každodenní cesta do centra Prahy i dalších částí města je rychlá a pohodlná. Ve stejné vzdálenosti je i zastávka autobusů.",
      "Stodůlky nabízí kompletní občanskou vybavenost – v okolí jsou obchody, služby, restaurace, školy i školky. Pro odpočinek a volný čas je v dosahu Centrální park, další zelené plochy a také Prokopské a Dalejské údolí. Výhodou je rovněž dobrá dostupnost autem a snadné napojení na Pražský okruh a hlavní dopravní tahy.",
      "Tento byt je zajímavou příležitostí pro ty, kteří hledají prostorné 3+1 s lodžií v lokalitě s výbornou dostupností, ale zároveň chtějí mít možnost vytvořit si nové bydlení zcela podle svého vkusu a potřeb.",
      "Pro bližší informace si neváhejte domluvit prohlídku.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {

    id: 129,
    slug: "novostavba-domu-6-2xkk-bus-slapy",
    image: busDumImages[0],
    images: busDumImages,
    floorPlans: busDumFloorPlans,
    videos: [{ youtubeId: "EQrVpr4Uu9o", title: "Video-prohlídka" }],
    title: "Novostavba rodinného domu 6+2x kk, 178 m², pozemek 901 m² – Buš u Slapské přehrady",
    location: "Buš, okres Praha-západ",
    price: "9 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "178 m²",
    landSize: "901 m²",
    disposition: "6+2x kk",
    parking: "2 parkovací stání",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Dům",
    zakázka: "ID 205-NP13346",
    yearBuilt: "2024",
    mapCoords: { lat: 49.8283, lng: 14.3517 },
    description: [
      "Nabízíme k prodeji novostavbu rodinného domu o dispozici 6+2x kk a celkové užitné ploše 178 m², která byla zkolaudována v roce 2024, na adrese Buš 172.",
      "Dům je rozdělen na dvě samostatné jednotky – každé podlaží má vlastní vstup a terasu, díky čemuž je ideální jak pro dvougenerační bydlení, tak i pro kombinaci rodinného domu a investičního pronájmu.",
      "Objekt se nachází na mírně svažitém pozemku o výměře 901 m² v klidné obci Buš nedaleko Slapské přehrady. Díky své poloze nabízí krásné výhledy do okolní krajiny.",
      "Provozní náklady do 5.000,- Kč (voda + elektřina).",
      "Velkou předností domu jsou velkoformátová okna v obou obytných patrech, která přivádějí do interiéru dostatek denního světla a opticky ještě více zvětšují hlavní obytné prostory. Z každého z těchto prostor je navíc přímý vstup na vlastní terasu o velikosti 13 m².",
      "V přízemí domu se nachází prostorný obývací pokoj s kuchyňským koutem 33,72 m², dále dva samostatné pokoje 13,40 m² a 11,64 m², koupelna 3,44 m², samostatné WC 2,18 m², chodba 5,43 m² a zádveří 1,89 m². V patře je k dispozici druhá obytná jednotka, která zahrnuje obývací pokoj s kuchyňským koutem 34,20 m², dva pokoje o velikosti 14,25 m² a 13,20 m², velkorysou koupelnu s vanou, toaletou a bidetem 12,35 m², technickou místnost 7,9 m², šatnu 3,92 m², sklad 10,77 m², chodbu se schodištěm 6,78 m² a vstupní chodbu 3,99 m². V šatně jsou připraveny rozvody vody i kanalizace – možnost přestavby na další koupelnu se sprchovým koutem či samostatnou toaletu.",
      "Patro domu je z velké části připraveno k nastěhování. Zbývá dokončit spodní část domu a fasádu, což dává novému majiteli možnost dokončit si vybavení podle svých potřeb a zvoleného standardu.",
      "V dolní části pozemku byla provedena terénní úprava a zpevnění betonovou podezdívkou – ideální příprava pro vířivou vanu.",
      "Dům je napojen na obecní vodovod i kanalizaci a má asfaltovou příjezdovou komunikaci. Vytápění je řešeno elektrickým kotlem. Konstrukce domu je cihlová (cihly s izolační vatou) a díky své dispozici poskytuje velkou variabilitu využití. Energetická náročnost budovy: B – velmi úsporná.",
      "Obec Buš se nachází jen 3,5 km od Slapské přehrady a 2,5 km od Golf Parku Slapy. Najdete zde základní občanskou vybavenost, jako je restaurace, obchod, obecní úřad, tenisové kurty nebo fotbalové hřiště. Okolní příroda nabízí široké možnosti volnočasového vyžití – od turistiky a cykloturistiky přes rybaření a vodní sporty až po jachting.",
      "Výborná dopravní dostupnost do Prahy pak dělá z této nemovitosti skvělou volbu jak pro trvalé bydlení, tak i pro rekreační účely.",
      "Dům je ihned volný. Pro více informací nebo domluvení prohlídky nás neváhejte kontaktovat.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {

    id: 125,
    slug: "pozemek-sobehrdy-phov",
    image: sobehrdyPozemekImages[0],
    images: sobehrdyPozemekImages,
    videos: [{ youtubeId: "gxzFMxk1kh4", title: "Video-prohlídka" }],
    title: "Prodej pozemku k bydlení 2 744 m², Soběhrdy – Phov",
    location: "Phov, Soběhrdy, okres Benešov",
    price: "5 900 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "2 744 m²",
    landSize: "2 744 m²",
    disposition: "pozemek pro bydlení",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Pozemek",
    zakázka: "ID 205-NP13276",
    mapCoords: { lat: 49.8408, lng: 14.7256 },
    description: [
      "Prostor pro rodinný dům, zahradu i ovocný sad — a k tomu otevřený výhled do krajiny. Na okraji Phova, místní části Soběhrd, nabízíme pozemek o celkové výměře 2 744 m². Mírně svažitý terén, příjezd ze stávající komunikace a sousedství volné krajiny vytvářejí příjemné místo pro ty, kteří hledají klidné bydlení a dostatek prostoru kolem domu.",
      "## Možnosti využití podle územního plánu",
      "Pozemek je podle územního plánu rozdělen do několika funkčních ploch. Východní část je zařazena do plochy BV – venkovské bydlení a územní plán zde připouští rodinný dům. Střední část tvoří plocha ZZ – zahrady a sady a západní část plocha AT – trvalé kultury, vhodná zejména pro sad a pěstování.",
      "Předběžná informace stavebního úřadu uvádí pro plochu BV maximální intenzitu zastavění 30 %, minimálně 50 % zeleně, nejvýše jedno nadzemní podlaží s obytným podkrovím a maximální výšku stavby 8 metrů. Počítá také se šikmou střechou a minimální výměrou stavebního pozemku 600 m² pro rodinný dům. V ploše ZZ musí zeleň tvořit nejméně 80 % plochy. Uvedené regulativy se vztahují ke konkrétnímu stavebnímu záměru a nenahrazují jeho posouzení stavebním úřadem.",
      "Pro lokalitu Z.PH2 stavební úřad uvádí kapacitu nejvýše jednoho rodinného domu v severní části a dvou rodinných domů v jižní části. Pozemek nelze rozdělit na více stavebních pozemků. Podrobnou územně plánovací dokumentaci a předběžnou informaci stavebního úřadu poskytneme zájemcům k nahlédnutí.",
      "## Sítě a odpadní vody",
      "Přípojky elektřiny a obecního vodovodu jsou podle dostupných podkladů zavedeny přímo na pozemek. Veřejná splašková kanalizace v Phově není, proto je třeba počítat s individuálním řešením odpadních vod, například domovní čistírnou nebo bezodtokovou jímkou. Konkrétní řešení podléhá posouzení příslušných orgánů.",
      "## Obec a okolí",
      "Phov nabízí především klid a blízkost přírody. Základní služby, restauraci, knihovnu a sportovní zázemí najdete v Soběhrdech. Mateřská a základní škola jsou v nedaleké Petroupimi, další školy a služby v Čerčanech. Přibližně 9 km vzdálený Benešov nabízí širší občanskou vybavenost včetně obchodů, lékařů, nemocnice a škol.",
      "Autobusové spojení směrem na Benešov zajišťuje z okolních zastávek linka PID 796. Nejbližší železniční spojení je v Mrači nebo v Čerčanech. V okolí najdete Farmapark Soběhrdy i řadu možností pro pěší výlety, cyklistiku a každodenní pobyt v přírodě.",
      "Pozemek osloví zájemce, kteří hledají venkovskou atmosféru, velkou zahradu a skutečný prostor kolem domu.",
      "Pro více informací, zaslání podkladů nebo sjednání osobní prohlídky mě neváhejte kontaktovat.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {

    id: 122,
    slug: "pozemek-chata-slapy-lahoz",
    image: slapyImages[0],
    images: slapyImages,
    title: "Pozemek 447 m² s kompletním projektem a stavebním povolením, Slapy – Na Čihátku, oblast Lahoz",
    location: "Slapy – Na Čihátku (Lahoz), okres Praha-západ",
    price: "4 300 000 Kč",
    priceNote: "vč. provize a právních služeb; prodej formou RE/MAX aukce",
    size: "48 m²",
    landSize: "447 m²",
    parking: "2 parkovací místa",
    sold: false,
    reserved: false,
    hidden: true,
    features: ["Exkluzivně", "Aukce", "Video-prohlídka"],
    type: "Chata",
    zakázka: "ID 205-NP13209",
    mapCoords: { lat: 49.8155, lng: 14.4028 },
    videos: [{ youtubeId: "I7MVYOylyCU", title: "Video-prohlídka" }],
    auction: {
      endDate: "2026-08-15",
      openHouse: "14. a 15. srpna 2026",
    },
    description: [
      "Prohlídky nemovitosti se uskuteční ve dnech 14. a 15. srpna 2026. Pro rezervaci konkrétního času mě prosím kontaktujte telefonicky nebo e-mailem.",
      "Nemovitost bude prodávána formou RE/MAX Aukce, tedy transparentním způsobem, při kterém mají zájemci možnost předložit svou nabídku. Nemovitost získá zájemce s nejlepší nabídkou.",
      "Nabízíme k prodeji atraktivní pozemek o celkové výměře 447 m² v oblíbené rekreační lokalitě Slapy – Na Čihátku, oblast Lahoz. Významnou předností této nabídky je poloha přibližně 7 minut chůze od pláže Slapské přehrady.",
      "Součástí prodeje je stavební parcela o výměře 58 m² se stávající stavbou pro rodinnou rekreaci č. ev. 126 a navazující rekreační pozemek o výměře 389 m². Stávající chata je určena k odstranění.",
      "Zásadní výhodou nabídky je kompletně připravený projekt nové rekreační chaty. Součástí kupní ceny je kompletní projektová dokumentace, pravomocné stavební povolení, veškeré podklady potřebné k realizaci stavby a podrobný soupis navržených materiálů. Nový majitel tak získá nejen pozemek ve vyhledávané lokalitě, ale také připravený záměr výstavby bez nutnosti absolvovat celý proces projektování a povolování od začátku.",
      "Pozemek se nachází v klidné rekreační oblasti obklopené zelení. K pláži Slapské přehrady dojdete přibližně za 7 minut. V okolí se nacházejí restaurace, přístaviště, možnosti kotvení lodí v zátoce Lahoz, Golf Park Slapy, turistické trasy a cyklostezky. Lokalita nabízí ideální podmínky pro koupání, rybaření, paddleboard, vodní sporty, cyklistiku i klidný odpočinek v přírodě.",
      "V obci Slapy je k dispozici obchod, pošta, mateřská a základní škola, zdravotní středisko i další běžné služby. Výhodou je také dobrá dostupnost do Prahy, autem přibližně 35 minut. Ze Slap je zajištěno autobusové spojení PID směrem na pražské Smíchovské nádraží.",
      "Jedná se o výjimečnou příležitost pro zájemce, který hledá vlastní místo u vody a současně chce ušetřit čas i náklady spojené s přípravou nové stavby. Pozemek, kompletní projekt nové chaty, podrobný soupis materiálů a pravomocné stavební povolení tvoří připravený celek, na který může nový majitel plynule navázat.",
      "Pozemky v této lokalitě a v pěší dostupnosti od pláže se v nabídce objevují pouze výjimečně.",
      "Pro více informací, zaslání kompletní dokumentace nebo sjednání osobní prohlídky mě neváhejte kontaktovat.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 121,
    slug: "byt-praha-4-kamyk-pisnicka",
    image: kamykImages[0],
    images: kamykImages,
    floorPlans: kamykFloorPlans,
    matterportUrl: "https://my.matterport.com/show/?m=iquaiixaeTW&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej bytu 1+kk 29 m² s lodžií, komorou a sklepem, Praha 4 – Kamýk, ul. Písnická",
    location: "Písnická 754/48, Praha 12 – Kamýk",
    price: "5 900 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "29 m²",
    disposition: "1+kk",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Byt",
    zakázka: "ID 205-NP13177",
    mapCoords: { lat: 50.0234, lng: 14.4297 },
    videos: [{ youtubeId: "8W9ODaVT7CI", title: "Video-prohlídka" }],
    description: [
      "Ať už hledáte své první bydlení nebo investiční příležitost, tento byt může být tou správnou volbou. Nabízíme byt v osobním vlastnictví o dispozici 1+kk s celkovou plochou 37,2 m², který se nachází v 9. nadzemním podlaží panelového domu v oblíbené části Prahy 12 – Kamýk. Součástí bytu je komora v mezipatře, lodžie o výměře 7,3 m², která poskytuje příjemný venkovní prostor, a sklepní kóje o velikosti 1,3 m² pro praktické uložení věcí.",
      "Dominantou bytu je obytný pokoj s kuchyňským koutem, na který navazuje předsíň, koupelna s toaletou. Příjemným rozšířením obytné části je prostorná lodžie, ideální pro ranní kávu nebo odpočinek po práci. K bytu náleží také sklepní kóje.",
      "Další výhodou jsou nízké měsíční náklady na bydlení. Zálohy včetně příspěvku do fondu oprav činí 1.650 Kč měsíčně pro jednu osobu, přičemž spotřeba elektřiny se hradí samostatně.",
      "Kamýk je oblíbená rezidenční čtvrť, která nabízí příjemné bydlení s dostatkem zeleně a kompletní občanskou vybaveností. V okolí najdete supermarkety, restaurace, kavárny, lékárnu i zdravotnická zařízení, takže vše potřebné budete mít na dosah.",
      "Výbornou dopravní dostupnost zajišťují pravidelné autobusové linky s návazností na stanici metra C Kačerov, odkud se pohodlně dostanete do centra Prahy i dalších částí města.",
      "Pro odpočinek i aktivní trávení volného času jsou v blízkosti Modřanská rokle, Kamýcký les a cyklostezky podél Vltavy. Lokalita tak spojuje výhody městského bydlení s blízkostí přírody.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 120,
    slug: "dum-chotovice",
    image: chotoviceImages[0],
    images: chotoviceImages,
    floorPlans: chotoviceFloorPlans,
    matterportUrl: "https://my.matterport.com/show/?m=GJLedH9QLZD&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej rodinného domu 3+1 s garáží a dílnami u Žehuňského rybníka, Choťovice",
    location: "Choťovice · okres Kolín",
    price: "6 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "73 m²",
    landSize: "537 m²",
    disposition: "3+1",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Dům",
    videos: [{ youtubeId: "QP0drWdEidE", title: "Video-prohlídka" }],
    zakázka: "ID 205-NP13166",
    mapCoords: { lat: 50.1367, lng: 15.3661 },
    description: [
      "Voda za zahradou, klid přírody a zázemí pro každodenní život. K tomu garáž, tři skladové či dílenské prostory a půda s možností dalšího využití. Takové spojení nabízí zděný rodinný dům v Choťovicích.",
      "Pozemek přímo navazuje na břeh Žehuňského rybníka. Vodní hladinu a okolní přírodu tak máte doslova za zahradou. Právě výjimečné prostředí dává tomuto místu atmosféru, kterou běžné bydlení nabídnout nemůže.",
      "Nemovitost stojí na pozemcích o celkové výměře 537 m². Kromě obytné části nabízí samostatnou garáž, tři praktické skladové nebo dílenské prostory, udírnu a půdu s možností dalšího využití.",
      "Dům má dispozici 3+1. Obývací pokoj má 19,80 m², kuchyně 16,09 m², ložnice 14,30 m² a další pokoj 13,84 m². Předsíň má 3,95 m², koupelna 3,36 m² a samostatné WC 2,21 m². Obytná část má dle orientačního půdorysu celkem 73,55 m².",
      "K domu dále patří tři skladové nebo dílenské prostory o výměrách 8,83 m², 5,42 m² a 5,42 m², udírna o ploše 8,38 m² a samostatná garáž o výměře 24,65 m². Součet všech ploch uvedených v půdorysu činí přibližně 126 m² včetně garáže a vedlejších prostor.",
      "Dům je cihlový a v letech 2000 až 2006 prošel rekonstrukcí. Má sedlovou střechu s betonovou krytinou. Vytápění je řešeno kombinací akumulačních kamen, krbu a klimatizačních jednotek s funkcí vytápění.",
      "Nemovitost je napojena na veřejný vodovod, kanalizaci a elektřinu 230/400 V. Na pozemku se nachází také vlastní studna. Prostorná půda nabízí další rezervu pro budoucí využití podle technických a stavebněprávních možností.",
      "Choťovice leží v klidné krajině u Žehuňského rybníka, mezi Poděbrady, Kolínem a Chlumcem nad Cidlinou. Výhodou je dobré napojení na dálnici D11, po které se pohodlně dostanete směrem na Prahu i Hradec Králové.",
      "Autobusová linka č. 706 zajišťuje spojení na trase Žiželice–Kolín–Uhlířské Janovice. V sousední Žehuni lze přestoupit na linku č. 543 do Poděbrad. Nejbližší vlaková stanice se nachází v Dobšicích–Libněvsi.",
      "Přímo v Choťovicích najdete restauraci a hotel Na Farmě a zásilkový box. Potraviny, pošta a základní občanská vybavenost jsou dostupné v sousední Žehuni, další služby potom v Poděbradech a Kolíně.",
      "Žehuňský rybník je chovný a není určen ke koupání ani vodním sportům. Jeho hlavní hodnotou je krásný výhled, klid a bezprostřední kontakt s přírodou.",
      "Tato nemovitost může oslovit ty, kteří hledají poctivý rodinný dům na neobyčejném místě a ocení dostatek prostoru pro práci, koníčky i každodenní život. Garáž, dílny a půda poskytují praktické zázemí, zatímco rybník a okolní krajina vytvářejí prostředí, které se hledá jen těžko.",
      "Pro více informací nebo sjednání prohlídky mě kontaktujte.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 119,
    slug: "pozemek-praha-4-branik-ohnivcova",
    image: branikPozemekImages[0],
    images: branikPozemekImages,
    floorPlans: branikPozemekFloorPlans,
    videos: [{ youtubeId: "gCaCxFsWgNY", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=mXJpdwTBQzG",
    title: "Prodej stavebního pozemku 992 m², Praha 4 – Braník, ul. Ohnivcova",
    location: "Ohnivcova 1271/27, Praha 4 – Braník",
    price: "30 141 Kč / m²",
    priceNote: "vč. provize a právních služeb",
    size: "992 m²",
    landSize: "992 m²",
    disposition: "stavební pozemek",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Pozemek",
    zakázka: "ID 205-NP13165",
    mapCoords: { lat: 50.0333, lng: 14.4197 },
    utilities: "Vodovod, kanalizace, plyn, elektřina",
    description: [
      "Nabízíme k prodeji atraktivní stavební pozemek o celkové výměře 992 m² na adrese Ohnivcova 1271/27, Praha 4 – Braník. Pozemek se nachází v klidné vilové zástavbě jedné z nejžádanějších pražských lokalit a nabízí výjimečný potenciál pro nové bydlení.",
      "Na pozemku stojí rodinný dům se dvěma samostatnými bytovými jednotkami, garáží v domě a druhou samostatnou garáží. Stávající stavbu lze využít k rekonstrukci či rozšíření, případně ji odstranit a využít potenciál pozemku pro výstavbu nového rodinného domu dle vlastních představ.",
      "Pozemek je napojen na veškeré inženýrské sítě – elektřinu, vodovod, kanalizaci i plyn. Díky své velikosti poskytuje dostatek prostoru nejen pro stavbu domu, ale také pro zahradu, odpočinkovou zónu nebo další zázemí.",
      "Velkou předností je samotná lokalita. Braník nabízí klidné rezidenční bydlení obklopené zelení a zároveň výbornou dostupnost do centra Prahy. V docházkové vzdálenosti se nachází zastávky MHD, školy, školky, obchody, restaurace i další občanská vybavenost. Milovníci sportu a přírody ocení blízkost cyklostezky podél Vltavy, Žlutých lázní, Branických skal nebo lesoparku Dobeška.",
      "Tato nabídka je ideální pro zájemce, kteří hledají výjimečný pozemek ve vyhledávané lokalitě s možností vytvořit si bydlení přesně podle svých představ.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 118,
    slug: "dum-praha-4-branik-ohnivcova",
    image: branikPraha4Images[0],
    images: branikPraha4Images,
    floorPlans: branikPraha4FloorPlans,
    videos: [{ youtubeId: "gCaCxFsWgNY", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=mXJpdwTBQzG",
    title: "Prodej rodinného domu 209 m² se dvěma bytovými jednotkami a zahradou, Praha 4 – Braník, ul. Ohnivcova",
    location: "Ohnivcova 1271/27, Praha 4 – Braník",
    price: "29 900 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "209 m²",
    landSize: "992 m²",
    disposition: "5+",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Dům",
    zakázka: "ID 205-NP13151",
    mapCoords: { lat: 50.0333, lng: 14.4197 },
    description: [
      "Nabízíme k prodeji prostorný rodinný dům se dvěma samostatnými bytovými jednotkami, situovaný v klidné vilové zástavbě pražského Braníku, na adrese Ohnivcova 1271/27. Nemovitost stojí na krásném pozemku o celkové výměře 992 m², z něhož 871 m² tvoří udržovaná zahrada se vzrostlou zelení a stromy poskytující dostatek soukromí pro odpočinek i rodinné chvíle. Součástí pozemku je také samostatně stojící garáž.",
      "Dům je rozdělen do tří podlaží a nabízí ideální řešení pro vícegenerační bydlení či spojení vlastního bydlení s pronájmem.",
      "Hlavní vstup do domu je ze zadní části zahrady. Na vstupní chodbu navazuje společné schodiště, které propojuje suterén i obě bytové jednotky v nadzemních podlažích. Díky tomu jsou jednotlivá podlaží snadno přístupná a zároveň si zachovávají dostatek soukromí.",
      "V suterénu se nachází prostorná garáž o výměře 17 m², prádelna, sprcha a několik skladových prostor. Celková plocha tohoto podlaží činí přibližně 65 m², což poskytuje dostatek místa pro uskladnění sezónních věcí, sportovního vybavení i zřízení dílny.",
      "První nadzemní podlaží nabízí bytovou jednotku o dispozici 3+kk s podlahovou plochou přibližně 72 m². Její součástí je prostorný obývací pokoj o výměře 20,5 m², kuchyňský kout 9,1 m², ložnice 13,1 m², pokoj 10,7 m², koupelna s rohovou vanou 4,8 m², samostatné WC, předsíň a chodba.",
      "Ve druhém nadzemním podlaží se nachází druhá samostatná bytová jednotka o dispozici 3+1 s podlahovou plochou přibližně 72 m². Dispozici tvoří obývací pokoj 20,5 m², samostatná kuchyně 9,1 m², ložnice 13,1 m², pokoj 10,7 m², koupelna se sprchovým koutem 4,9 m², samostatné WC, předsíň a chodba.",
      "Velkým benefitem této nemovitosti je krásná, udržovaná zahrada se vzrostlými stromy a množstvím zeleně, která vytváří příjemné soukromí a nabízí prostor pro relaxaci, rodinné posezení na terase, dětské hry i zahradničení. Velmi užitečný je i zahradní domek.",
      "Každá bytová jednotka má vlastní plynový kotel pro vytápění a ohřev vody. V celém domě byla vyměněna okna za plastová s izolačním dvojsklem.",
      "Braník patří dlouhodobě mezi nejvyhledávanější rezidenční lokality Prahy. Nabízí klidné bydlení ve vilové zástavbě obklopené zelení, přitom s výbornou dostupností do centra města. V docházkové vzdálenosti naleznete školy, školky, obchody, restaurace, zastávky MHD i široké možnosti sportovního a volnočasového vyžití. Oblíbené jsou zejména Žluté lázně, cyklostezka podél Vltavy, Branické skály nebo nedaleký lesopark Dobeška.",
      "Pokud hledáte prostorný rodinný dům s velkým pozemkem, dvěma samostatnými bytovými jednotkami a širokými možnostmi využití v jedné z nejatraktivnějších pražských lokalit, rád Vám tuto nemovitost osobně představím při prohlídce.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 117,
    slug: "dum-podoli-na-klaudiance",
    image: podoliImages[0],
    images: podoliImages,
    floorPlans: podoliFloorPlans,
    videos: [{ youtubeId: "shZbNPr5kB0", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=sxCWm6bEVzc&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej spoluvlastnického podílu 2/9 na prvorepublikové vile se zahradou, Na Klaudiánce, Praha 4 – Podolí",
    location: "Na Klaudiánce 256/4, 147 00 Praha 4 – Podolí",
    price: "13 900 000 Kč",
    priceNote: "vč. provize a právních služeb. Předmětem prodeje je spoluvlastnický podíl.",
    size: "200 m²",
    landSize: "1 063 m²",
    disposition: "tři bytové jednotky",
    sold: false,
    reserved: true,

    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Dům",
    yearBuilt: "1928",
    zakázka: "ID 205-NP13116",
    mapCoords: { lat: 50.0450, lng: 14.4225 },
    description: [
      "Nabízíme k prodeji spoluvlastnický podíl na rodinném domě se zahradou v ulici Na Klaudiánce, v jedné z nejvyhledávanějších rezidenčních částí Prahy 4 – Podolí.",
      "Prvorepublikový zděný dům z roku 1928 je zasazen do rozlehlého pozemku o celkové výměře 1 063 m² (zastavěná plocha 143 m² + zahrada 900 m²). Nemovitost se nachází na rohovém pozemku na konci klidné slepé ulice v okolní zástavbě samostatně stojících rodinných domů. Pozemek je napojen na veškeré inženýrské sítě a přístupný po zpevněné komunikaci.",
      "Dům nabízí přibližně 200 m² podlahové plochy a je rozdělen do tří samostatně přístupných bytových jednotek. V přízemí se nachází byt o dispozici 2+kk s podlahovou plochou 53,3 m², v prvním patře byt o dispozici 3+1 s podlahovou plochou 87,1 m² a podkroví byt o dispozici 2+1 s podlahovou plochou 75,3 m² a terasou 30 m². Součástí domu je také zázemí v podobě sklepních prostor, prádelny a dílny. Vzrostlá zahrada s množstvím zeleně a vzrostlými stromy poskytuje příjemné soukromí a podtrhuje jedinečný charakter této prvorepublikové vily.",
      "Předmětem prodeje je spoluvlastnický podíl o velikosti 2/9 na rodinném domě čp. 256 a pozemku parc. č. 863 – 900 m² zahrada, a dále spoluvlastnický podíl o velikosti 1/3 na pozemku parc. č. 862 – 143 m² zastavěná plocha a nádvoří, jehož součástí je stavba rodinného domu. Nejedná se o výlučné vlastnictví celé nemovitosti ani konkrétní bytové jednotky.",
      "Fotografie suterénu a přízemí nejsou na přání spoluvlastníků zveřejněny. Pro více informací nebo domluvení osobní prohlídky nás neváhejte kontaktovat.",
      "Nabídka představuje zajímavou investiční příležitost v lokalitě s dlouhodobě vysokou poptávkou a omezenou nabídkou obdobných nemovitostí.",
      "Podolí patří mezi tradiční a velmi vyhledávané rezidenční čtvrti Prahy 4. Ulice Na Klaudiánce nabízí klidné bydlení v prostředí vilové zástavby a množství zeleně, přičemž centrum města je snadno dostupné.",
      "V okolí se nachází kompletní občanská vybavenost včetně obchodů, služeb, škol, školek i zdravotnických zařízení. Výbornou dopravní dostupnost zajišťuje městská hromadná doprava s návazností na metro C i rychlé napojení na hlavní dopravní tahy.",
      "Milovníci aktivního odpočinku ocení blízkost cyklostezky podél Vltavy, plaveckého stadionu Podolí, Žlutých lázní i dalších možností sportovního a rekreačního vyžití.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 116,
    slug: "byt-2kk-uhrineves-oty-bubenicka",
    image: uhrineves4Images[0],
    images: uhrineves4Images,
    floorPlans: uhrineves4FloorPlans,
    videos: [{ youtubeId: "pfp6Qa7X7jo", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=3zdSzone7cX&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej bytu 2+kk s lodžií a parkovacím stáním, 47 m², Praha 10 – Uhříněves",
    location: "Oty Bubeníčka 1654/6, Praha 10 – Uhříněves",
    price: "7 990 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "47 m²",
    disposition: "2+kk",
    sold: true,
    reserved: false,
    soldAt: "2026-10-28",
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Byt",
    yearBuilt: "2019",
    zakázka: "ID 205-NP13075",
    mapCoords: { lat: 50.0316, lng: 14.6128 },
    description: [
      "Nabízíme k prodeji světlý byt o dispozici 2+kk a podlahové ploše 46,9 m² s lodžií o velikosti 3,6 m² v ulici Oty Bubeníčka 1654/6 v Praze 22 – Uhříněvsi. Byt se nachází ve 4. nadzemním podlaží moderního bytového domu s výtahem v oblíbeném rezidenčním projektu Vivus Uhříněves III. Dům byl kolaudován v roce 2019 a nabízí příjemné bydlení v klidné lokalitě s výbornou dostupností do centra Prahy.",
      "Součástí prodeje je také parkovací stání ve společných garážích v 1. podzemním podlaží domu, které zajišťuje pohodlné parkování přímo v místě bydliště.",
      "Byt nabízí prakticky řešenou dispozici s dostatkem úložných prostor. Dominantou je světlý obývací pokoj s kuchyňským koutem, na který navazuje samostatná ložnice s vestavěnou skříní a přímým vstupem na lodžii. Komfort bydlení dále zvyšuje koupelna s vanou a komora s přípojkou na pračku, která poskytuje další úložný prostor.",
      "Uhříněves patří mezi oblíbené rezidenční části Prahy, které nabízejí příjemné spojení klidného bydlení, dostatku zeleně a veškerého komfortu pro každodenní život. Lokalita je vyhledávaná zejména pro svou rodinnou atmosféru a kompletní občanskou vybavenost.",
      "Výbornou dopravní dostupnost zajišťuje vlakové spojení, díky kterému se na Hlavní nádraží dostanete přibližně za 20 minut. Samozřejmostí je také autobusové spojení na stanice metra Háje, Hostivař a Skalka a rychlé napojení na dálnici D1. V okolí naleznete obchody, restaurace, školy, školky, zdravotnická zařízení i další služby. Výhodou je také blízkost obchodní zóny v Čestlicích, nákupního centra OC Europark Štěrboholy vzdáleného přibližně 10 minut jízdy autem a centra Westfield Chodov.",
      "Milovníci aktivního odpočinku ocení blízkost Obory v Uhříněvsi, soustavy místních rybníků a dalších přírodních lokalit, které nabízejí ideální podmínky pro procházky, běh, cyklistiku i relaxaci v zeleni.",
      "Byt představuje ideální volbu pro jednotlivce či pár hledající moderní bydlení bez nutnosti dalších investic a zároveň zajímavou investiční příležitost k následnému pronájmu.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 115,
    slug: "dum-uhrineves-v-kutatech",
    image: uhrineves3Images[0],
    images: uhrineves3Images,
    floorPlans: uhrineves3FloorPlans,
    videos: [{ youtubeId: "dapJn6faIWU", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=6Vn8jiEkCuN&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej rodinného domu 3+1, 69 m², ul. V Kuťatech, Praha 10 – Uhříněves",
    location: "V Kuťatech, Praha 10 – Uhříněves",
    price: "8 290 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "69 m²",
    landSize: "150 m²",
    disposition: "3+1",
    sold: true,
    reserved: false,
    soldAt: "2026-09-18",

    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Dům",
    zakázka: "ID 205-NP13016",
    mapCoords: { lat: 50.0316, lng: 14.6128 },
    description: [
      "Vlastní dům za cenu bytu. Přesně taková nabídka se v Praze neobjevuje každý den.",
      "Nabízíme k prodeji rodinný dům o dispozici 3+1 v Praze–Uhříněvsi, v ulici V Kuťatech. Pokud hledáte bydlení v Praze a chcete víc soukromí, vlastní vstup a vlastní pozemek, tato nemovitost může být velmi zajímavou volbou.",
      "Dům stojí na pozemku o výměře 150 m² a nabízí užitnou plochu 69,10 m². Dispozice je praktická, přehledná a vhodná pro jednotlivce, pár nebo menší rodinu.",
      "Dispozice domu: obývací pokoj 19,90 m², kuchyně 11,30 m², pokoj 12,10 m², pokoj 11,20 m², koupelna 7,30 m², WC 2,20 m², zádveří 2,50 m², technická místnost / sklad 2,60 m².",
      "Srdcem domu je obývací pokoj, na který navazuje samostatná kuchyně. Dva další pokoje mohou sloužit jako ložnice, dětský pokoj, pracovna nebo pokoj pro hosty. K dispozici je koupelna, samostatné WC, zádveří a technická místnost, kterou lze využít také jako sklad.",
      "Dům je určen k částečné rekonstrukci menšího rozsahu, zejména v části koupelny a WC. Právě to ale novému majiteli dává možnost upravit si důležité části domu podle vlastního vkusu a potřeb, bez nutnosti řešit zásadní stavební zásahy.",
      "Tahákem této nabídky je jednoduchá myšlenka: vlastní dům v Praze, vlastní adresa, vlastní vstup a prostor, který si můžete postupně přizpůsobit podle sebe. Neřešíte společné prostory, výtah ani anonymní bydlení ve velkém domě. Získáte samostatnou nemovitost s jasným potenciálem.",
      "Uhříněves je vyhledávaná pražská lokalita s kompletní občanskou vybaveností. V okolí najdete školy, školky, obchody, supermarkety, lékaře, lékárny, restaurace i další služby pro každodenní život. Výhodou je také dobrá dopravní dostupnost – autobusové spojení směrem na metro Háje a vlaková stanice Praha-Uhříněves s rychlým spojením do centra Prahy i směrem na Říčany.",
      "Tato nabídka dává smysl každému, kdo chce bydlet v Praze, hledá samostatné bydlení a zároveň ocení rozumnou velikost, praktickou dispozici, vlastní pozemek a možnost postupných úprav.",
      "Pokud hledáte dům v Praze, který má potenciál a zároveň cenu srovnatelnou s pražským bytem, doporučuji osobní prohlídku. Tohle je nemovitost, kterou je potřeba vidět.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 114,
    slug: "garazove-stani-praha-5-stodulky-petrzilkova",
    image: stodulkyImages[0],
    images: stodulkyImages,
    title: "Prodej prostorného garážového stání, ul. Petržílkova, Praha 5 – Stodůlky",
    location: "Petržílkova 2583/13, Praha 5 – Stodůlky",
    price: "850 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "16 m²",
    sold: true,
    soldAt: "2026-07-30",
    reserved: false,
    features: ["Exkluzivně"],
    type: "Garáž",
    zakázka: "ID 205-NP12949",
    mapCoords: { lat: 50.0509, lng: 14.3370 },
    description: [
      "Dovoluji si Vám nabídnout k prodeji prostorné garážové stání o velikosti 16,3 m² (stání pro invalidy, rozměry 3,2 m x 5,1 m), které se nachází na adrese Petržílkova 2583/13, Praha 5 – Stodůlky. Stání je umístěno ve 3. podzemním podlaží bytového domu s výtahem.",
      "Vjezd do garáží je z ulice Petržílkova přes vrata na dálkové ovládání. Objekt je zabezpečen kamerovým systémem, což zajišťuje vyšší úroveň bezpečnosti a komfortu při parkování. Díky nadstandardním rozměrům nabízí stání pohodlné parkování i pro větší osobní automobil nebo SUV, zároveň umožňuje snadnější manipulaci při vystupování a nakládání.",
      "Velkou výhodou je atraktivní lokalita v oblíbené části Praha 5 – Stodůlky. Garážové stání se nachází v těsné blízkosti stanice metra B – Hůrka, což zajišťuje výbornou dopravní dostupnost jak do centra Prahy, tak i do dalších částí města. V okolí se nachází kompletní občanská vybavenost, obchodní centra, restaurace, kancelářské budovy i rezidenční zástavba, díky čemuž může být stání zajímavé nejen pro vlastní využití, ale také jako investiční příležitost k dalšímu pronájmu.",
      "Parkování v této lokalitě je dlouhodobě žádané, a proto představuje koupě garážového stání praktické a hodnotné řešení pro vlastní potřebu i jako stabilní investici.",
      "V případě zájmu o více informací nebo prohlídku mě neváhejte kontaktovat.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 113,
    slug: "byt-2kk-strancice-namesti-emila-kolbena",
    image: stranciceImages[0],
    images: stranciceImages,
    floorPlans: stranciceFloorPlans,
    videos: [{ youtubeId: "uh6s1svYabo", title: "Video-prohlídka" }],
    title: "Byt 2+kk s balkonem a garážovým stáním, Náměstí Emila Kolbena - Strančice",
    location: "Náměstí Emila Kolbena 460, 251 63 Strančice",
    price: "7 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "62 m²",
    parking: "1 garážové stání",
    disposition: "2+kk",
    sold: false,
    reserved: false,
    features: ["Video-prohlídka", "Exkluzivně"],
    type: "Byt",
    zakázka: "ID 205-NP12923",
    mapCoords: { lat: 49.9482851, lng: 14.6786925 },
    mapZoom: 17,
    description: [
      "Nabízíme k prodeji světlý byt o dispozici 2+kk s balkonem (možnost úpravy na 3kk), který se nachází ve 2. nadzemním podlaží (z celkových 4) moderního bytového domu na adrese Náměstí Emila Kolbena 460, Strančice.",
      "Byt představuje ideální volbu jako startovací bydlení i chytrou investici k pronájmu. K bytu je možnost zakoupit garážové stání přímo v domě, které zajišťuje komfortní parkování bez starostí. Cena 800.000 Kč.",
      "Celková podlahová plocha bytu je 62,35 m². K bytu náleží balkon o velikosti 4,7 m² a sklep 2,25 m².",
      "Dispozice bytu nabízí praktické a vzdušné uspořádání. Obývací pokoj s kuchyňským koutem o velikosti 29,45 m² má přímý vstup na balkon. Ložnice o výměře 18 m² poskytuje dostatek prostoru pro klidné zázemí. K dispozici je koupelna s vanou (5,6 m²), samostatné WC (1,25 m²) a předsíň (8 m²).",
      "Byt je velmi dobře dispozičně řešený, s dostatkem denního světla a příjemnou atmosvírou.",
      "Jedním z hlavních benefitů této nemovitosti je výborná dopravní dostupnost – vlakové nádraží je vzdálené pouhou minutu chůze a cesta na Hlavní nádraží v Praze trvá přibližně 30 minut. Výhodou je také rychlé napojení na dálnici D1, konkrétně na exit 15 (Velké Popovice / Strančice), který je vzdálený jen pár minut jízdy.",
      "Strančice jsou oblíbenou lokalitou díky kombinaci klidného bydlení a dobré dostupnosti do Prahy. V okolí se nachází krásná příroda, lesy i cyklostezky vhodné pro procházky, běh i vyjížďky na kole. Nechybí základní občanská vybavenost včetně obchodů, školy či školky, což z lokality činí příjemné místo pro každodenní život.",
      "Měsíční náklady dle evidenčního listu činí cca 2.300 Kč pro jednu osobu + elektřina byt a 350 Kč parkování.",
      "Takové kombinace parametrů a dostupnosti jsou v této lokalitě dlouhodobě velmi žádané, a proto doporučujeme osobní prohlídku.",
    ],
  },
  {
    id: 111,
    slug: "dum-louny-dalimilova",
    image: lounyImages[0],
    images: lounyImages,
    floorPlans: lounyFloorPlans,
    videos: [{ youtubeId: "RBQe3ZopFIY", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=KwacdKxm6CC&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej kanadského rodinného domu 7+1 s krytým bazénem, srubem a trojgaráží, Louny",
    location: "Dalimilova 2735, 440 01 Louny",
    price: "15 490 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "217 m²",
    landSize: "1 818 m²",
    disposition: "7+1",
    yearBuilt: "2002",
    sold: false,
    reserved: false,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Dům",
    zakázka: "ID 205-NP12906",
    mapCoords: { lat: 50.3543329, lng: 13.7867350 },
    utilities: "Elektřina, plyn, vodovod, kanalizace, vlastní vrtaná studna",
    description: [
      "V ulici Dalimilova v Lounech se nachází dům, který nabízí víc než jen bydlení. Prostor, soukromí a zázemí, které se dnes hledá jen těžko.",
      "Dřevostavba z Kanady z roku 2002 o dispozici 7+1 stojí na pozemku o velikosti 1 818 m² a nabízí celkovou podlahovou plochu 217 m², kterou doplňuje prostorná garáž o velikosti 62 m². Celé řešení domu je navržené tak, aby pohodlně fungovalo pro větší rodinu i každodenní život.",
      "Hlavní obytný prostor tvoří kuchyně s jídelnou o velikosti 39 m², na kterou navazuje obývací pokoj (23,8 m²) s krbem obloženým brazilským mramorem. Tento prostor působí přirozeně otevřeně a zároveň útulně. Přímý vstup na zastřešenou terasu propojuje interiér se zahradou a vytváří ideální místo pro trávení volného času.",
      "Dispozice domu nabízí dostatek soukromí pro každého člena domácnosti. Hlavní ložnice (21,3 m²) má vlastní koupelnu s vanou, sprchovým koutem a toaletou (16,4 m²) a navazující šatnu (6,7 m²). Další tři samostatné pokoje mají velikosti 15,6 m², 14,7 m² a 14 m², doplněné o další obytný pokoj (19,97 m²), komoru (8,1 m²) a technickou místnost (9,2 m²). Druhá koupelna s vanou má velikost 6,6 m².",
      "V celém domě je podlahové vytápění doplněné krbem s rozvodem tepla do jednotlivých místností, o hlavní vytápění se starají dva plynové kotle – samostatně pro dům a samostatně pro bazén.",
      "Velkým benefitem je krytý bazén o rozměrech cca 14 × 6 m se zastřešením a přímým vstupem z domu, díky kterému si můžete užívat koupání po celý rok.",
      "Na pozemku se nachází také samostatný kanadský srub, který představuje plnohodnotné zázemí s celoročním využitím. Objekt je napojen na elektřinu, vodu i odpady, disponuje vlastním WC. Hlavní obytný prostor je řešen jako společenská místnost s posezením, krbem a barem s výčepním zařízením, což z něj vytváří ideální místo pro setkávání s rodinou a přáteli.",
      "Součástí nemovitosti je také prostorná garáž o velikosti 62 m² a další tři parkovací místa přímo na pozemku. Součástí pozemku je také vlastní vrtaná studna. Dům je napojen na všechny inženýrské sítě – elektřinu, plyn, vodu i kanalizaci. Měsíční náklady na provoz obou staveb i bazénu se pohybují okolo 10 000 Kč.",
      "Celý pozemek nabízí dostatek soukromí a prostoru pro každodenní život, odpočinek i setkávání s přáteli.",
      "Dům se nachází v klidné rezidenční části města Louny, která nabízí příjemné bydlení s dobrou dostupností služeb. V blízkosti je kompletní občanská vybavenost včetně škol, školek, obchodů i sportovního vyžití. Výhodou je také dobrá dostupnost do Prahy, díky čemuž je lokalita zajímavá i pro každodenní dojíždění.",
      "Pokud hledáte dům, který kombinuje velkorysý prostor, vlastní bazén, další samostatnou stavbu a klidné zázemí, tato nabídka představuje výjimečnou příležitost.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 24,
    slug: "dum-hovorcovice",
    image: hovorcoviceImages[0],
    images: hovorcoviceImages,
    floorPlans: hovorcoviceFloorPlans,
    videos: [{ youtubeId: "yHYZm32dVWg", title: "Video-prohlídka" }],
    title: "Prostorný dům 4kk se zimní zahradou a bazénem, Hovorčovice",
    location: "Hovorčovice · Praha-východ",
    price: "15 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "199 m²",
    disposition: "4+kk",
    landSize: "524 m²",
    yearBuilt: "2012",
    sold: false,
    reserved: true,
    features: ["Video-prohlídka"],
    type: "Dům",
    zakázka: "ID 205-NP11758",
    mapCoords: { lat: 50.1855, lng: 14.5197 },
    description: [
      "Prostorný rodinný dům v Hovorčovicích, na adrese Březová 897. Dům kolaudovaný v roce 2012 nabízí komfortní bydlení s dostatkem prostoru na pozemku 524 m².",
      "Dominantou přízemí je obytný prostor s krbem a kamenným obložením stěny a kuchyně s ostrůvkem, navazující na zimní zahradu, dále předsíň s chodbou, toaleta a schodiště do patra – 98 m². Z prostorné garáže (18,5 m²) je vstup přímo do domu.",
      "Patro tvoří ložnice 21 m² se vstupem na lodžii, 2 pokoje (16,5 m² a 12,5 m²), koupelna s vanou a toaletou, chodba, šatna a sklad – 67 m². Půdní prostor nabízí možnost vybudování dalších místností.",
      "Vytápění plynovým kotlem a krbem s rozvodem do patra. Klimatizace v přízemí a ve dvou pokojích v patře. Na oknech venkovní žaluzie.",
      "U domu krásná udržovaná zahrada se vzrostlými keři, terasa s pergolou a posezením, bazén s novým zastřešením, skleník a vyvýšené záhony se zavlažováním. Zahradní domek a nádrž na dešťovou vodu.",
      "Hovorčovice mají základní občanskou vybavenost – MŠ, ZŠ, obchody, lékárna, pošta, hřiště a sportoviště. Výborná dopravní dostupnost – BUS 18 min na M Letňany, vlak 30 min Hlavní nádraží.",
    ],
  },
  {
    id: 109,
    slug: "pozemek-unhost-nouzov",
    image: unhostImages[0],
    images: unhostImages,
    floorPlans: [],
    videos: [
      { youtubeId: "RR-RfTq9bQA", title: "Video-prohlídka" },
    ],
    title: "Prodej stavebního pozemku 2 049 m², Unhošť – Nouzov",
    location: "Nouzov, Unhošť, okres Kladno",
    price: "13 037 787 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "2 049 m²",
    landSize: "2 049 m²",
    disposition: "stavební pozemek",
    sold: false,
    reserved: false,
    features: ["Video-prohlídka", "Exkluzivně"],
    type: "Pozemek",
    zakázka: "ID 205-NP12855",
    mapCoords: { lat: 50.0668228, lng: 14.0998072 },
    utilities: "Vodovod, kanalizace, elektřina 230/400 V",
    description: [
      "Nabízíme k prodeji pěkný stavební pozemek o rozloze 2 049 m² v obci Nouzov u Unhoště.",
      "Parcela se nachází na krásném místě na okraji obce, v bezprostřední blízkosti křivoklátských lesů. Pár sousedních pozemků je zastavěno luxusními domy a parcely jsou dostatečně rozlehlé, aby měly naprosté soukromí.",
      "Dvě stě metrů pod pozemkem teče údolím potok, na němž je Bozděchův rybník, který je vhodný i ke koupání.",
      "Na hranici pozemku jsou přivedeny všechny sítě (vodovod, kanalizace, elektřina 230/400 V), jsou zde již vybudované chodníky a zřízeno osvětlení. V minulosti bylo již vydané územní rozhodnutí na stavbu prostorného domu s bazénem.",
      "V Unhošti, která je vzdálena tři minuty, je veškerá občanská vybavenost včetně škol, školek, divadla i kina.",
      "Do Prahy se dostanete autem zhruba za 20 minut, nebo je možné jet autobusem přímo z Nouzova.",
      "Pokud někdo touží žít v krásném prostředí bezprostředně spjatém s přírodou a zároveň v dojezdové vzdálenosti do Prahy, je pro něj tento pozemek naprosto ideální.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 110,
    slug: "byt-3kk-klecany-v-honech",
    image: klecanyImages[0],
    images: klecanyImages,
    floorPlans: klecanyFloorPlans,
    videos: [{ youtubeId: "8GN5gYeWQeA", title: "Video-prohlídka" }],
    matterportUrl: "https://my.matterport.com/show/?m=pGFpxZY1tU1&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej bytu 3+kk s lodžií, komorou a parkovacím stáním 55 m², Klecany, ul. V Honech",
    location: "V Honech 690, Klecany · Praha-východ",
    price: "6 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "55 m²",
    disposition: "3+kk",
    sold: true,
    soldAt: "2026-07-30",
    reserved: false,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Byt",
    zakázka: "ID 205-NP12895",
    mapCoords: { lat: 50.1837956, lng: 14.4240097 },
    
    description: [
      "Nabízíme ke koupi velmi příjemný byt 3+kk v klidné části Klecan s výbornou dostupností do Prahy a kompletní občanskou vybaveností v blízkém okolí. Byt se nachází ve 2. nadzemním podlaží bytového domu č.p. 690 v ulici V Honech a nabízí prakticky řešenou dispozici, lodžii, komoru na patře a parkovací stání.",
      "Podlahová plocha bytu činí 54,5 m². K bytu dále náleží lodžie o výměře 6,31 m², praktická komora na patře o výměře 1,66 m² a parkovací stání č. 40. Celková užívaná plocha včetně lodžie a komory činí přibližně 62,5 m².",
      "Dispozici bytu tvoří chodba 10 m², samostatné WC 2 m², koupelna 3 m², ložnice 9 m², pokoj 19 m², obývací pokoj s kuchyňským koutem 18 m² a lodžie 6,5 m². Byt je řešený velmi prakticky, s dobrým využitím prostoru a příjemným oddělením denní a klidové části.",
      "Obývací pokoj s kuchyňským koutem tvoří přirozené centrum bytu. Další dva samostatné pokoje lze využít jako ložnici, dětský pokoj, pracovnu nebo pokoj pro hosty. Dispozice tak nabízí pohodlné bydlení pro jednotlivce, pár i menší rodinu.",
      "Kuchyňská linka je vybavena spotřebiči, konkrétně myčkou, indukční varnou deskou, troubou a lednicí s mrazákem. Byt je tak připravený k pohodlnému každodennímu užívání bez nutnosti zásadních úprav.",
      "Velkým bonusem je lodžie, která rozšiřuje obytný prostor a nabízí příjemné místo pro posezení. Na lodžii je instalovaná praktická průhledná stahovací roleta, která propouští světlo, ale zároveň pomáhá chránit před hmyzem, deštěm i nepříznivým počasím. Díky tomu lze lodžii pohodlně využívat po větší část roku.",
      "Komora na patře o výměře 1,66 m² poskytuje praktický úložný prostor přímo v blízkosti bytu. Součástí převodu je také parkovací stání č. 40, což je v této lokalitě výrazná praktická výhoda. V domě je k dispozici také kolárna.",
      "Lokalita nabízí velmi dobré zázemí pro každodenní život. V blízkosti domu se nachází obchod, pošta, bankomat a kompletní výdejní boxy doručovacích společností. V Klecanech je dále škola, školka, sportovní areál, občanská vybavenost a příjemné prostředí pro klidné bydlení. V místě působí také lokální poskytovatel vysokorychlostního internetu.",
      "Velkou předností je dopravní dostupnost do Prahy. Autobusová linka č. 371 jezdí od domu přímo ke stanici metra Kobylisy a cesta trvá přibližně 15 minut. Autem je možné se k metru dostat přibližně za 10 minut. Klecany tak nabízejí klidnější bydlení mimo rušné centrum, ale zároveň rychlé spojení do Prahy.",
      "Okolí domu potěší také milovníky přírody, cyklistiky a aktivního životního stylu. V dosahu jsou lesy, trasy směrem na Klecánky, přívoz na Roztoky a cyklostezky směrem do Troji a k pražské zoo. Lokalita tak příjemně spojuje dostupnost města, občanskou vybavenost a přírodu na dosah.",
      "Tento byt je ideální volbou pro zájemce, kteří hledají prakticky řešené bydlení 3+kk s lodžií, úložným prostorem, parkovacím stáním a rychlou dostupností do Prahy.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 108,
    slug: "dum-mnichovice-bezrucova",
    image: mnichoviceImages[0],
    images: mnichoviceImages,
    floorPlans: mnichoviceFloorPlans,
    videos: [
      { youtubeId: "a97wdRWxYh8", title: "Video-prohlídka" },
    ],
    matterportUrl: "https://my.matterport.com/show/?m=78oY8DmFt2f&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej domu se dvěma mezonetovými byty, komerčním prostorem a garážemi 220 m², Mnichovice, ul. Bezručova",
    location: "Bezručova 395, Mnichovice",
    price: "22 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "220 m²",
    landSize: "322 m²",
    disposition: "5+",
    sold: false,
    hidden: true,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Dům",
    yearBuilt: "1928",
    zakázka: "ID 205-NP12844",
    description: [
      "Příležitost, která dává smysl a na trhu se neobjevuje úplně často – investice, bydlení i podnikání v jednom.",
      "V centru Mnichovice, v ulici Bezručova, nabízím k prodeji dům, který spojuje stabilní výnos, vlastní bydlení i podnikatelskou příležitost.",
      "Původní stavba pochází z 30. let minulého století a v roce 2008 prošla kompletní přestavbou a rekonstrukcí včetně zateplení fasády a výměny oken, díky čemuž dnes funguje jako promyšlený celek se třemi samostatnými jednotkami.",
      "V přízemí se nachází komerční prostor s přímým vstupem z ulice, aktuálně využívaný jako prodejna, o celkové výměře cca 67 m². Díky své poloze a viditelnosti má stabilní provoz a vlastní zázemí včetně kuchyňky a WC.",
      "Ze zahrady je vstup do chodby se schodištěm do patra, která slouží jako vstup do obou bytů i do technické místnosti se zázemím domu, včetně umyvadel, plynových kotlů a přípojek pro pračky. Každý byt má vlastní plynový kotel, samostatné měření energií, centrální vysavač a kompletní zázemí pro pohodlné bydlení.",
      "Součástí je i prostorná garáž o velikosti 26,5 m² pro dva vozy, přičemž ke každému bytu náleží jedno parkovací stání.",
      "Velkou přidanou hodnotou je samostatná garáž naproti domu o velikosti cca 39 m², kterou lze využít i jako sklad.",
      "Horní patra tvoří dvě mezonetové bytové jednotky o dispozici 3+1, každá o velikosti cca 80 m², které jsou dispozičně téměř totožné, pouze zrcadlově otočené.",
      "První byt nabízí v dolní úrovni obytný prostor (20,6 m²), kuchyni (15,1 m²) se vstupem na balkón (4,3 m²) a výhledem do zahrady a toaletu (3,4 m²). Z obývací části vede schodiště do patra, kde se nachází ložnice (18,4 m²), pokoj (12,4 m²), chodba (3,9 m²), samostatná toaleta (1 m²) a koupelna s rohovou vanou (5 m²).",
      "Druhý byt má obdobné uspořádání – v dolní části kuchyni (15,2 m²) a obytný prostor (22,9 m²) se schodištěm do patra, kde jsou dva pokoje (22,9 m² a 12,2 m²), toaleta (1 m²) a koupelna s rohovou vanou (5 m²).",
      "Dům je částečně podsklepený, napojený na všechny inženýrské sítě a nabízí praktické technické zázemí – sklep se studnou (užitková voda) a technickou místnost.",
      "Zahrada pak působí jako příjemné soukromé zázemí domu – upravený travnatý prostor navazuje na terasu s venkovním posezením a zděným grilem, což vytváří ideální místo pro rodinná setkávání.",
      "Aktuální roční výnos z nájmu činí cca 660 000 Kč, což z této nabídky dělá zajímavou investici.",
      "Pokud hledáte dvougenerační bydlení s možností kombinace vlastního užívání a investice, nebo nemovitost, která vám bude dlouhodobě generovat stabilní příjem, pak je tato nabídka ideální právě pro vás.",
      "V místě je kompletní občanská vybavenost – mateřská i základní škola (ZŠ doslova minutu chůze), obchody a služby, širší vybavenost pak nabízí nedaleké Říčany.",
      "Dopravní dostupnost je velmi dobrá – vlakem do centra Prahy cca 33 minut, autem přibližně 20 minut.",
      "Mnichovice patří mezi dlouhodobě vyhledávané lokality díky kombinaci klidného bydlení a rychlé dostupnosti do Prahy.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 107,
    slug: "dvougeneracni-dum-k-ricanum-kolovraty",
    image: kolovratyRicanumImages[0],
    images: kolovratyRicanumImages,
    floorPlans: kolovratyRicanumFloorPlans,
    videos: [
      { youtubeId: "B4tsAiIoJkU", title: "Video-prohlídka" },
    ],
    matterportUrl: "https://my.matterport.com/show/?m=ut8xQG2Xcq1&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej dvougeneračního domu 2× 6+1 s garáží, pozemek 984 m², ul. K Říčanům, Praha 10 – Kolovraty",
    location: "K Říčanům 437/29, Praha 10 – Kolovraty",
    price: "25 900 000 Kč",
    showPrice: true,
    size: "238 m²",
    landSize: "984 m²",
    disposition: "2× 6+1",
    sold: false,
    reserved: true,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Dům",
    yearBuilt: "1980",
    zakázka: "ID 205-NP12845",
    mapCoords: { lat: 50.0138280, lng: 14.6315751 },
    mapZoom: 18,
    mapUrl: "https://mapy.com/cs/letecka?q=K%20%C5%98%C3%AD%C4%8Dan%C5%AFm%20437%2F29%2C%20Praha%2010%20Kolovraty&z=18",
    description: [
      "Dovoluji si Vám nabídnout prodej dvougeneračního rodinného domu o dispozici 2× 6+1 na adrese K Říčanům 437/29, Praha 10 – Kolovraty, na pozemku o celkové výměře 984 m².",
      "Tato nemovitost představuje ideální kombinaci velkorysého rodinného bydlení, podnikání či investičního záměru. Kolovraty jsou známé svou rodinnou atmosférou a přátelským sousedským životem, zároveň nabízejí výbornou dostupnost do centra Prahy – vlakové spojení na Hlavní nádraží trvá přibližně 23 minut.",
      "Dům byl postaven v roce 1980 a je podsklepený. Dispozičně je rozdělen na dvě samostatné bytové jednotky 6+1, každá na vlastním podlaží, což umožňuje komfortní dvougenerační bydlení nebo kombinaci bydlení a pronájmu.",
      "V 1. NP o výměře cca 126 m² se nachází prostorná bytová jednotka s obývacím pokojem s krbovými kamny, kuchyní, dalšími pěti pokoji, koupelnou se sprchovým koutem a samostatným WC.",
      "Ve 2. NP o výměře cca 112 m² je druhá plnohodnotná jednotka 6+1 s koupelnou vybavenou vanou a WC. Z tohoto podlaží je navíc přístup na balkón, který nabízí příjemný výhled do zahrady.",
      "Suterén o velikosti cca 90 m² poskytuje technické zázemí domu, skladovací prostory a navíc koupelnu se sprchovým koutem.",
      "Další výhodou je prostorné podkroví o výměře cca 108 m², které nabízí další potenciál využití – například pro vybudování třetí bytové jednotky, ateliéru nebo pracovního zázemí.",
      "Součástí nemovitosti je samostatná vedlejší stavba o zastavěné ploše 72 m², která zahrnuje dvojgaráž, dílnu a další místnosti.",
      "Dům je napojen na veškeré inženýrské sítě a na pozemku se nachází také zkolaudovaná kopaná studna s pitnou vodou.",
      "V roce 2008 proběhla částečná rekonstrukce, zahrnující výměnu oken za plastová s dvojsklem a modernizaci koupelen včetně rozvodů.",
      "Na pozemku o výměře 984 m² se nachází prostorná zahrada o velikosti 767 m², která poskytuje dostatek soukromí i prostoru pro relaxaci. Součástí je také krytá pergola s krbem, ideální pro celoroční posezení, grilování a rodinná setkání.",
      "V místě je základní občanská vybavenost – MŠ, ZŠ, pošta, lékaři, v pěší dostupnosti pak OÚ, restaurace, obchod s potravinami, knihovna, kadeřnictví, kosmetika, fitness, zubní klinika, několik hřišť, sportovní hřiště, letní koupaliště.",
      "Veškerá další občanská vybavenost včetně nákupních domů je ve 2 km vzdálených Říčanech či Uhříněvsi, obchodní zóna Čestlice – 10 minut autem.",
      "Vynikající dopravní dostupnost – vlakové nádraží 23 min. Hlavní nádraží, BUS – 17 min. metro Háje, nájezd na D1 – 10 minut.",
      "V okolí dostatek zeleně, přírody, cyklostezka a příjemným zpestřením jsou rybníky u Vodice navazující na Prknovku. Tato místa lákají ke sportu či relaxaci a jsou v docházkové vzdálenosti.",
      "Tato nemovitost je ideální volbou pro ty, kteří hledají opravdu velkorysý prostor, variabilní využití domu a zároveň chtějí bydlet v Praze, ale preferují klidné a bezpečné prostředí s výbornou dostupností.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 106,
    slug: "rodinny-dum-vyjezdova-bechovice",
    image: bechoviceImages[0],
    images: bechoviceImages,
    floorPlans: bechoviceFloorPlans,
    videos: [
      { youtubeId: "Uy_qO-ULFNI", title: "Video-prohlídka" },
    ],
    matterportUrl: "https://my.matterport.com/show/?m=d2xLbAuaLPY&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej rodinného domu 4+1 na pozemku 900 m², Praha-Běchovice",
    location: "Výjezdová 232, 190 11 Praha-Běchovice",
    price: "13 500 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "82 m²",
    landSize: "900 m²",
    disposition: "4+1",
    sold: true,
    reserved: false,
    soldAt: "2026-06-26",
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Dům",
    yearBuilt: "1952",
    zakázka: "ID 205-NP12829",
    mapCoords: { lat: 50.0815083, lng: 14.6228540 },
    mapZoom: 18,
    mapUrl: "https://mapy.com/cs/letecka?q=V%C3%BDjezdov%C3%A1%20232%2C%20Praha-B%C4%9Bchovice&z=18",
    description: [
      "Nabízíme k prodeji cihlový rodinný dům o dispozici 4+1 v klidné části Prahy-Běchovic, v ulici Výjezdová. Dům je z roku 1952 a stojí na rovinatém pozemku o celkové výměře 900 m². Z toho 775 m² tvoří zahrada a 125 m² zastavěná plocha a nádvoří.",
      "Dům je určený ke kompletní rekonstrukci, případně po ověření příslušných regulativů také k demolici a výstavbě nového rodinného domu. Velkou výhodou je především krásný, rovinatý a dobře využitelný pozemek v zavedené rezidenční lokalitě Prahy.",
      "Celková vnitřní plocha domu dle půdorysů činí cca 214 m². Hlavní obytná plocha je cca 82 m². Dům má prostorné skladové/sklepní zázemí o výměře cca 60 m², celkově pak suterén nabízí cca 72 m². K rodinnému domu náleží také garáž o ploše cca 22 m².",
      "Dispozičně je dům řešen jako 4+1, protože kuchyně je samostatná místnost. Obytnou část tvoří obývací pokoj, jídelna, samostatná kuchyně, ložnice a další pokoj.",
      "V suterénu se nachází chodba 7,5 m², šatna 1,0 m², sklad 3,0 m², sklad 18,9 m², sklad 17,6 m², chodba 3,7 m², sklad 9,6 m² a sklad 10,8 m². Celková plocha suterénu je cca 72 m².",
      "V 1. nadzemním podlaží se nachází předsíň 9,5 m², WC 1,3 m², komora 1,8 m², koupelna 3,6 m², obývací pokoj 18,8 m², jídelna 15,6 m², samostatná kuchyně 14,5 m² a chodba 6,3 m². Celková plocha tohoto podlaží je cca 71 m².",
      "Ve 2. nadzemním podlaží se nachází chodba 21,6 m², ložnice 18,5 m², pokoj 14,7 m² a půda 15,9 m². Celková plocha tohoto podlaží je cca 70 m².",
      "Dům je napojen na vodu, elektřinu a kanalizaci. Vytápění je řešeno elektrickým kotlem. Plyn není do domu aktuálně napojen, nachází se však v ulici. Elektroinstalace je v hliníku. Na pozemku se nachází také kopaná studna o hloubce cca 7 m, voda není pitná. Součástí zahrady je také skleník a dvě kůlny.",
      "Lokalita Praha-Běchovice nabízí klidné bydlení na okraji Prahy s dobrou dostupností do centra i do okolních částí města. V místě je základní škola, mateřská škola, pošta, autobusové spojení i vlaková zastávka. Výhodou je také dobrá návaznost směrem na Černý Most, Štěrboholy, Štěrboholskou radiálu a Jižní spojku.",
      "V okolí je dostatek zeleně a přírodních lokalit, mimo jiné směrem na Klánovice, Koloděje, Dubeč a Uhříněves. Lokalita je vhodná pro rodinné bydlení, procházky, cyklistiku i klidné zázemí v rámci Prahy.",
      "Nemovitost doporučujeme zájemcům, kteří hledají dům s velkým pozemkem v Praze a počítají s kompletní rekonstrukcí, případně chtějí využít potenciál pozemku pro výstavbu nového rodinného domu.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 105,
    slug: "byt-2kk-stara-boleslav-josefa-truhlare",
    image: boleslavImages[0],
    images: boleslavImages,
    floorPlans: boleslavFloorPlans,
    videos: [
      { youtubeId: "-BeQV9DxJnA", title: "Video-prohlídka" },
    ],
    matterportUrl: "https://my.matterport.com/show/?m=3d358ngAdmL&vr=0&play=1&search=0&mt=1&title=0",
    title: "Prodej moderního bytu 2+kk, balkon a 2 garážová stání, Stará Boleslav",
    location: "Josefa Truhláře 1855, 250 01 Brandýs nad Labem-Stará Boleslav",
    price: "8 900 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "64 m²",
    disposition: "2+kk",
    sold: false,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Byt",
    yearBuilt: "Novostavba",
    zakázka: "ID 205-NP13493",
    mapCoords: { lat: 50.2041048, lng: 14.6832464 },
    mapZoom: 18,
    mapUrl: "https://mapy.com/cs/letecka?q=Josefa%20Truhl%C3%A1%C5%99e%201855%2C%20Star%C3%A1%20Boleslav&z=18",
    description: [
      "Stačí se nastěhovat. Nově zařízený byt 2+kk s balkonem a dvěma garážovými stáními ve Staré Boleslavi.",
      "Nová kuchyň, kompletní vybavení a vlastní místo pro dvě auta. Tady nemusíte začínat výběrem nábytku ani sháněním řemeslníků. V ulici Josefa Truhláře ve Staré Boleslavi na vás čeká nadstandardně vybavený byt, ve kterém se můžete zabydlet hned od prvního dne.",
      "Byt má podlahovou plochu 58,2 m², k tomu náleží balkon o výměře 4,0 m² a sklepní kóje o výměře 1,6 m². Celková plocha včetně balkonu a sklepní kóje činí 63,8 m².",
      "Centrem bytu je prostorný obývací pokoj s kuchyňským koutem o výměře 28,6 m². Nabízí dostatek místa pro společné vaření, návštěvy i klidný večer na pohovce. Samostatná ložnice o výměře 12,2 m² má přímý vstup na balkon — třeba na ranní kávu nebo chvíli odpočinku před spaním. Dispozici doplňuje koupelna o výměře 4,3 m², předsíň o výměře 5,9 m² a praktická šatna o výměře 3,9 m², díky které zůstane více prostoru pro samotné bydlení.",
      "Co vidíte na fotografiích, to je součástí prodeje. Byt je kompletně a nově zařízený, takže vám odpadne zařizování i další výdaje za nábytek a vybavení. Dominantou obytné části je nová kuchyňská linka se spotřebiči. Nechybí myčka, indukční varná deska, horkovzdušná trouba, mikrovlnná trouba, lednice, mrazák ani výrobník ledu. Od první snídaně až po večer s přáteli je vše připravené.",
      "Na každodenní pohodlí se myslelo i v dalších detailech. Elektrické předokenní rolety v celém bytě lze ovládat dálkově v jednotlivých místnostech. Jsou zároveň napojené na povětrnostní čidlo, které systém chrání při silnějším větru. V bytě jsou vinylové podlahy, optický internet, ústřední dálkové vytápění a centrální dálkový ohřev vody.",
      "Dvě auta? Obě mají své místo pod střechou. K bytu náleží dvě krytá garážová stání č. 15 a 25. Garážová vrata otevřete dálkovým ovladačem i telefonem, vstup do domu je řešený přes čipový systém. Potěší také zázemí, které nebývá samozřejmostí: kolárna s myčkou na kola a samostatná kočárkárna. Po výletě tak můžete očistit a uložit kolo přímo v domě.",
      "Ulice Josefa Truhláře ve Staré Boleslavi nabízí klidné a příjemné bydlení s velmi dobrou občanskou vybaveností. V rámci města Brandýs nad Labem–Stará Boleslav jsou dostupné školy, mateřské školy, obchody, restaurace, zdravotní služby i sportoviště. Pro běžné nákupy můžete využít například Kaufland, BILLA, Lidl nebo Penny.",
      "Dobré spojení oceníte také při cestách do Prahy. Ze Staré Boleslavi jezdí příměstské autobusové linky PID mimo jiné na Černý Most, Letňany a Českomoravskou. K dispozici je také vlakové spojení ze stanice Stará Boleslav, například ve směru Lysá nad Labem, Všetaty, Mělník či Štětí a do dalších navazujících směrů.",
      "Pokud hledáte vlastní bydlení, kde už je vše připravené, tenhle byt stojí za osobní návštěvu. Kompletní zařízení, balkon, šatna a dvě garážová stání tvoří kombinaci, kterou oceníte každý den. Zajímavou možností může být také pro zájemce o koupi bytu k pronájmu.",
      "Přijďte se podívat, jak se vám tu bude bydlet. Rád vás osobně provedu.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 104,
    slug: "rodinny-dum-ve-skale-sestajovice",
    image: sestajoviceImages[0],
    images: sestajoviceImages,
    floorPlans: sestajoviceFloorPlans,
    videos: [
      { youtubeId: "tNQFAyLFrGw", title: "Video-prohlídka" },
    ],
    title: "Prodej prostorného domu 5+1 s dvojgaráží, Šestajovice",
    location: "Ve Skále 730, Šestajovice",
    price: "19 950 000 Kč",
    priceNote: "včetně právního servisu a provize",
    size: "194 m²",
    landSize: "766 m²",
    disposition: "5+1",
    sold: false,
    hidden: true,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Dům",
    yearBuilt: "2001",
    zakázka: "ID 205-NP12782",
    mapCoords: { lat: 50.1053488, lng: 14.6757475 },
    mapZoom: 15,
    mapUrl: "https://mapy.com/cs/letecka?q=Ve%20Sk%C3%A1le%20730%2C%20%C5%A0estajovice&x=14.6757475&y=50.1053488&z=18",
    matterportUrl: "https://my.matterport.com/show/?m=tsB212eKDP2&vr=0&play=1&search=0&mt=1&title=0",
    description: [
      "V klidné a vyhledávané části obce Šestajovice, na samém konci slepé ulice, nabízíme k prodeji prostorný rodinný dům na adrese Ve Skále 730, s udržovanou zahradou s naprostým soukromím. Lokalita navazující na Prahu 9 – Klánovice poskytuje příjemné bydlení v zeleni s výbornou dostupností do centra Prahy a kompletní občanskou vybaveností v dosahu.",
      "Dům o dispozici 5+1 a užitné ploše 194 m² byl postaven v roce 2001 a nabízí praktické uspořádání pro pohodlné rodinné bydlení, doplněné o prostornou zahradu a dostatek parkovacích možností.",
      "Dominantou přízemí je světlý obývací pokoj o ploše 32,9 m² s krbovými kamny a přímým vstupem na zastřešenou terasu s pergolou a zahradu. Dále zde najdete jídelnu 14,9 m², samostatnou kuchyni 10,1 m² s praktickou komorou a koupelnu s toaletou.",
      "Patra jsou propojena masivním schodištěm vedoucím do otevřeného prostoru s galerií a dřevěným zábradlím, který podtrhuje vzdušnost interiéru.",
      "V patře se nachází hlavní ložnice 18,5 m² s vlastní šatnou a koupelnou 12,8 m², dva prostorné pokoje 24,4 m² a 25,3 m², druhá koupelna a samostatná prádelna o velikosti přibližně 10 m². Komfort zvyšují dvě klimatizační jednotky.",
      "Dům dále disponuje pochozí půdou o ploše cca 64 m² vhodnou jako úložný prostor, dvojgaráží s navazující dílnou a krytým parkovacím stáním. Samozřejmostí je vjezd přímo na pozemek.",
      "Pozemek o celkové výměře 766 m² nabízí udržovanou zahradu se vzrostlými stromy a keři, která zajišťuje příjemné soukromí a klidné prostředí pro každodenní odpočinek. K dispozici je nádrž na dešťovou vodu a připravené obnovitelné zavlažování.",
      "Dům je napojen na veškeré inženýrské sítě. Vytápění a ohřev vody zajišťuje plynový kotel starý přibližně 2 roky včetně výměníku, doplněný o krbová kamna. Nemovitost je zabezpečena alarmem včetně spodních oken a k dispozici je rozvod antény, internet přes pevnou linku i elektroinstalace 230/400 V.",
      "Nespornou výhodou je blízkost Klánovického lesa, který nabízí široké možnosti pro volnočasové aktivity – procházky, sport i každodenní relaxaci v přírodě. Šestajovice patří mezi oblíbené lokality v blízkosti Prahy s výbornou dopravní dostupností na metro Černý Most i vlakové spojení z nedalekých Klánovic.",
      "Pokud hledáte klidné rodinné bydlení s dostatkem prostoru, soukromí a rychlou dostupností do Prahy, může být tento dům ideální volbou právě pro vás. Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 103,
    slug: "rodinny-dum-budcicka-ujezd-nad-lesy",
    image: ujezdLesyImages[0],
    images: ujezdLesyImages,
    floorPlans: ujezdLesyFloorPlans,
    videos: [
      { youtubeId: "NTCRp0ywgX8", title: "Video-prohlídka" },
    ],
    title: "Rodinný dům za cenu bytu v Praze, Praha 9 – Újezd nad Lesy",
    location: "Budčická, Újezd nad Lesy",
    price: "11 750 000 Kč",
    priceNote: "včetně provize a právních služeb",
    size: "113 m²",
    landSize: "329 m²",
    disposition: "5+",
    sold: false,
    reserved: true,
    features: ["Video-prohlídka", "3D Scan", "Exkluzivně"],
    type: "Dům",
    yearBuilt: "2007",
    zakázka: "ID 205-NP12746",
    mapCoords: { lat: 50.0802259, lng: 14.6476845 },
    mapUrl: "https://mapy.com/cs/letecka?source=addr&id=11469767&ds=1&x=14.6476845&y=50.0802259&z=17",
    matterportUrl: "https://my.matterport.com/show?play=1&lang=en-US&m=iokwGVMjZbr",
    description: [
      "Hledáte rodinné bydlení v Praze, které kombinuje klidné prostředí, vlastní zahradu a zároveň dobrou dostupnost do centra? V žádané lokalitě Praha 9 – Újezd nad Lesy, v ulici Budčická, nabízíme rodinný dům na pozemku o celkové výměře 329 m², se zahradou o rozloze 250 m², která obklopuje celý dům a poskytuje dostatek soukromí i prostoru pro relaxaci.",
      "Dům nabízí 4 obytné místnosti a 1 obytný prostor s kuchyňským koutem. Dispozice je praktická a umožňuje flexibilní využití například pro kombinaci bydlení a práce z domova nebo oddělení části domu pro hosty či dospívající děti.",
      "V 1. podlaží se nachází předsíň 4,05 m², chodba 7,90 m², obývací pokoj s kuchyňským koutem 13,80 m², spíž 3,00 m², šatna 4,73 m², technická místnost 2,10 m², WC 1,35 m² a ložnice 18,00 m². Celková plocha podlaží je 54,93 m².",
      "Ve 2. podlaží se nachází chodba 4,48 m², pokoj 11,30 m², obývací pokoj 20,60 m², koupelna s vanou 2,16 m², WC 1,35 m² a ložnice 18,00 m². Celková plocha podlaží je 57,89 m². Celkový součet ploch místností činí 113 m².",
      "Dům byl dokončen v roce 2007, je průběžně udržovaný a v roce 2020 zde proběhla výměna oken a vchodových dveří za izolační trojskla. Vytápění je řešeno plynovým kotlem a dům je napojen na veškeré inženýrské sítě.",
      "Lokalita nabízí kompletní občanskou vybavenost pro pohodlné rodinné bydlení – v blízkém okolí najdete obchody, restaurace, služby i zdravotní péči, vše v krátké docházkové nebo dojezdové vzdálenosti.",
      "Základní škola Polesná je vzdálena přibližně 500 m, mateřské školy Čentická a Sluníčko přibližně 400 m. Rodiny s dětmi ocení také dostatek dětských hřišť a sportovišť v okolí.",
      "Dopravní dostupnost zajišťuje autobusová zastávka Blatov ve vzdálenosti cca 200 m s linkami 163, 250, 221 a 209. Spojení na metro B Černý Most trvá přibližně 20 minut a na metro A Depo Hostivař přibližně 33 minut. Vlaková stanice Praha-Klánovice je vzdálena přibližně 1,3 km a nabízí přímé spojení na Masarykovo i Hlavní nádraží s jízdní dobou kolem 22 minut.",
      "V blízkosti se nachází Klánovický les, který nabízí široké možnosti pro procházky, běh i cyklistiku, a navazující síť cyklostezek.",
      "Tato nemovitost představuje zajímavou kombinaci ceny, prostoru a lokality v rámci Prahy a je vhodná jak pro rodinné bydlení, tak i jako investice s dlouhodobým potenciálem. Pro více informací nebo domluvení prohlídky mě neváhejte kontaktovat. Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 123,
    slug: "pozemek-praha-10-strasnice-ve-stinu",
    image: strasnicePozemekImages[0],
    images: strasnicePozemekImages,
    videos: [{ youtubeId: "k5hUCR42XR0", title: "Video-prohlídka" }],
    title: "Prodej stavebního pozemku 109 m² se stavbou, Praha 10 – Strašnice, ul. Ve stínu",
    location: "Ve stínu, Praha 10 – Strašnice",
    price: "11 490 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "109 m²",
    landSize: "109 m²",
    disposition: "stavební pozemek se stavbou",
    sold: false,
    reserved: false,
    features: ["Exkluzivně", "Video-prohlídka"],
    type: "Pozemek",
    zakázka: "ID 205-NP12678",
    mapCoords: { lat: 50.0733, lng: 14.4855 },
    description: [
      "Nabízíme k prodeji pozemek o výměře 109 m² s možností rozšíření až na 127 m² v ulici Ve Stínu na Praze 10, situovaný na rozhraní Strašnic a Vinohrad, v bezprostřední blízkosti lokality Hagibor, která v posledních letech významně proměňuje charakter této části Prahy.",
      "Na pozemku se nachází samostatně stojící stavba, ve které je v současné době provozována prodejna řeznictví a uzenářství. Předmětem této nabídky je pozemek se stávající stavbou, avšak bez provozního, technologického a dalšího vybavení prodejny. Objekt může nový vlastník nadále využívat pro obchodní či jiné podnikatelské účely, přizpůsobit jej vlastním potřebám, případně jej rekonstruovat nebo pozemek využít pro realizaci nového stavebního záměru v souladu s platnými předpisy a regulativy.",
      "Prodávaný pozemek parc. č. 2067 v katastrálním území Strašnice se nachází v zastavěném a stabilizovaném území s funkčním využitím OV – všeobecně obytné a OB – čistě obytné. V obou funkčních plochách je hlavním využitím bydlení, včetně staveb pro bydlení a bytů v nebytových domech.",
      "Lokalita Třebešín si zachovává charakter zahradního města, kde se přirozeně prolíná zástavba rodinných a bytových domů o dvou až pěti nadzemních podlažích. Případný budoucí záměr bude nutné navrhnout v souladu s požadavky územního plánu, Pražských stavebních předpisů a s ohledem na zastavěnost pozemku, výškové uspořádání i charakter okolní zástavby.",
      "Nemovitost je napojena na veškeré inženýrské sítě – vodovod, kanalizaci, elektřinu a plyn. Velkou výhodou je také výborná dopravní dostupnost. Stanice metra Strašnická je vzdálena přibližně 400 metrů a tramvajová zastávka pouhých 50 metrů od pozemku. V okolí se nachází kompletní občanská vybavenost včetně škol, školek, obchodů a služeb. Obchodní centrum Eden je dostupné během několika minut.",
      "Díky své poloze ve stabilizovaném území širšího centra Strašnic představuje tato nemovitost zajímavou příležitost pro podnikatelské využití, realizaci vlastního stavebního záměru i dlouhodobou investici.",
      "Pokud hledáte pozemek se stávající stavbou v atraktivní části Prahy a s potenciálem dalšího využití, rád Vám poskytnu bližší informace a představím Vám tuto nabídku osobně.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 102,
    slug: "obchodni-prostor-strasnice-ve-stinu",
    image: strasniceImages[0],
    images: strasniceImages,
    floorPlans: [],
    videos: [
      { youtubeId: "Q8PuzRKGO5M", title: "Video-prohlídka" },
    ],
    title: "Prodej obchodních prostor 109 m², ul. Ve stínu, Praha 10 – Strašnice",
    location: "Ve stínu, Praha 10 – Strašnice",
    price: "12 490 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "109 m²",
    disposition: "obchodní prostor",
    sold: false,
    features: ["Video-prohlídka", "Exkluzivně"],
    type: "Komerční prostor",
    yearBuilt: "cihlová stavba",
    zakázka: "ID 205-NP12669",
    mapCoords: { lat: 50.0774167, lng: 14.4937222 },
    mapUrl: "https://mapy.com/cs/letecka?q=Ve%20st%C3%ADnu&source=addr&id=9090001&x=14.4936964&y=50.0774307&z=20",
    description: [
      "Dovoluji si Vám nabídnout k prodeji samostatně stojící budovu na Praze 10, v ulici Ve stínu, na rozhraní Strašnic a Vinohrad, v blízkosti lokality Hagibor.",
      "Stavba stojí na pozemku o výměře 109 m² s možností využití až 127 m². Výhodou je také možnost výstavby dalšího podlaží s předběžným souhlasem souseda.",
      "V současné době je zde provozována prodejna potravinářského zboží – řeznictví a uzenářství s 25letou historií, kterou je možné bez dalších investic ihned provozovat.",
      "Součástí prodeje jsou dva chladicí boxy, dvě přístěnné lednice, desetimetrový chladicí pult a kompletní nerezové vybavení potřebné pro provozování řeznictví. Vstup do provozovny je řešen automatickými dveřmi na fotobuňku a celý prostor je klimatizován.",
      "Nemovitost je napojena na veškeré inženýrské sítě – vodovod, kanalizaci, elektřinu a plyn.",
      "Výborná dopravní dostupnost je samozřejmostí. Stanice metra Strašnická je vzdálena přibližně 400 m, tramvajová zastávka se nachází pouhých 50 m od nemovitosti. V místě je kompletní občanská vybavenost včetně mateřských a základních škol, obchodů a služeb. Obchodní centrum Eden je dostupné během několika minut.",
      "Pozemek parc. č. 2067 v k. ú. Strašnice se nachází v zastavěném a stabilizovaném území s funkčním využitím OV – všeobecně obytné a OB – čistě obytné. V obou funkčních plochách je hlavním využitím bydlení, včetně staveb pro bydlení a bytů v nebytových domech.",
      "Lokalita Třebešín má charakter zahradního města. V okolí se nachází rodinné a bytové domy o 2 až 5 nadzemních podlažích. Případný záměr bude muset splnit požadavky územního plánu, Pražských stavebních předpisů, požadavky na zastavěnost pozemku, výškové uspořádání a charakter okolní zástavby.",
      "Nemovitost je vhodná jak pro pokračování stávající obchodní činnosti, tak i jako investiční příležitost. Pro bližší informace kontaktujte makléře. Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 101,
    slug: "dum-kolovraty-mirova",
    image: kolovratyMirovaImages[0],
    images: kolovratyMirovaImages,
    floorPlans: kolovratyMirovaFloorPlans,
    videos: [
      { youtubeId: "9VPX3Lc24XM", title: "Video-prohlídka" },
    ],
    title: "Prodej rodinného domu 5+1 s nebytovým prostorem, pozemek 693 m², ul. Mírová, Praha 10 – Kolovraty",
    location: "ulice Mírová, Praha 10 Kolovraty",
    price: "16 600 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "139 m²",
    landSize: "693 m²",
    disposition: "5+1",
    sold: true,
    soldAt: "2026-06-25",
    reserved: false,
    features: ["Video-prohlídka", "3D Scan"],
    type: "Dům",
    yearBuilt: "rekonstrukce 2000–2001",
    zakázka: "ID 205-NP12795",
    mapCoords: { lat: 50.0093250, lng: 14.6310180 },
    mapZoom: 16,
    mapUrl: "https://mapy.com/cs/letecka?q=M%C3%ADrov%C3%A1%2050%2F95%2C%20103%2000%20Praha-Kolovraty&x=14.6310180&y=50.0093250&z=18",
    matterportUrl: "https://my.matterport.com/show/?m=X9vAKSFhTr2&vr=0&play=1&search=0&mt=1&title=0",
    description: [
      "Dovoluji si Vám nabídnout prodej rodinného domu 5+1 s nebytovým prostorem na adrese Mírová 50/95, Praha 10 – Kolovraty, na pozemku o celkové výměře 693 m².",
      "Tato nemovitost představuje ideální kombinaci rodinného bydlení a možnosti podnikání. Kolovraty jsou známé svou rodinnou atmosférou a přátelským sousedským životem, zároveň nabízejí výbornou dostupnost do centra Prahy – vlakové spojení na Hlavní nádraží trvá 23 minut.",
      "Dispozice domu zahrnuje v 1. NP vstupní chodbu se schodištěm 21,2 m², prostorný obývací pokoj 28,2 m² s krbem a udírnou, kuchyni 11,9 m², koupelnu 7,4 m², samostatné WC 2,1 m², ložnici 13,5 m² a šatnu 3,9 m². Z obytné části je přímý vstup na venkovní posezení, které je pevně zastřešené jako součást stavby a plynule propojuje interiér s dvorem a zahradou.",
      "Ve 2. NP jsou další dva pokoje 16,5 m² a 31,0 m², samostatné WC 3,4 m² a prostorný zadní pokoj v původním stavu 49,7 m², který nabízí široké možnosti využití – například jako pracovna nebo další obytný prostor.",
      "Výhodou je samostatný nebytový prostor o velikosti 37,5 m², který je ideální pro podnikání, dílnu nebo společenskou místnost. Součástí domu je také garáž 21 m² a další parkovací možnosti na pozemku.",
      "Původní stavba pochází přibližně z první poloviny 20. století a v letech 2000–2001 prošla kompletní rekonstrukcí, která zahrnovala úpravu dispozice, modernizaci interiérů, výměnu střešní krytiny a částečné zateplení. Historické, široké zdi byly zachovány. Díky tomu dnes nabízí kombinaci původního charakteru a moderního standardu bydlení.",
      "Na pozemku o výměře 693 m² se nachází udržovaná, mírně vyvýšená zahrada se vzrostlými stromy, která poskytuje dostatek soukromí, dále venkovní posezení a ohniště. Na zahradě je studna s užitkovou vodou.",
      "V místě je základní občanská vybavenost – MŠ, ZŠ, pošta, lékaři, v pěší dostupnosti pak OÚ, restaurace, obchod s potravinami, knihovna, kadeřnictví, kosmetika, fitness, zubní klinika, několik hřišť, sportovní areály a letní koupaliště.",
      "Vynikající dopravní dostupnost – vlakem 23 min. na Hlavní nádraží, BUS 17 min. na metro Háje, nájezd na D1 cca 10 minut.",
    ],
  },
  {
    id: 100,
    slug: "dum-kolovraty-tymianova",
    image: kolovratyTymImages[0],
    images: kolovratyTymImages,
    floorPlans: kolovratyTymFloorPlans,
    videos: [
      { youtubeId: "Ym36wokl1k0", title: "Video-prohlídka" },
    ],
    title: "Prodej ŘRD 6+1/T,G s pozemkem 335 m², ul. Tymiánová, Praha 10 – Kolovraty",
    location: "Tymiánová, Praha 10 – Kolovraty",
    price: "16 750 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "149 m²",
    landSize: "335 m²",
    disposition: "6+1",
    sold: true,
    soldAt: "2026-07-30",
    reserved: false,
    features: ["Video-prohlídka", "3D Scan"],
    type: "Dům",
    yearBuilt: "2000",
    zakázka: "ID 205-NP12789",
    mapCoords: { lat: 50.0160955, lng: 14.6306811 },
    matterportUrl: "https://my.matterport.com/show/?m=kqmBMn53QbC&vr=0&play=1&search=0&mt=1&title=0",
    description: [
      "Dovoluji si Vám nabídnout prodej rodinného řadového domu 6+1 na adrese Tymiánová 623/13, Praha 10 – Kolovraty, s pozemkem 335 m².",
      "Tento dům představuje ideální kombinaci klidného rodinného bydlení a výborné dostupnosti do centra Prahy. Kolovraty jsou známé svou rodinnou atmosférou a přátelským sousedským životem, což ještě více podtrhuje jejich atraktivitu pro rodiny s dětmi i pro ty, kteří hledají klidné a bezpečné bydlení.",
      "Dispozice domu zahrnuje v 1. NP prostorný obývací pokoj 32,88 m² se dvěma vstupy na zastřešenou terasu a do zahrady, dále navazující kuchyň 10,76 m², samostatnou pracovnu 10,76 m², koupelnu se sprchovým koutem a toaletou s přímým vstupem do garáže 5,37 m², vstupní předsíň 3,31 m² a garáž 18,83 m² s výstupem do zahrady, přičemž před domem je k dispozici kryté stání pro dvě auta.",
      "Ve 2. NP se nachází prostorná ložnice 27,88 m² doplněná o další 3 pokoje o velikostech 14,53 m², 11,20 m² a 11,20 m², dále koupelna 8,21 m² s vanou, sprchovým koutem a toaletou, komora 1,78 m² a chodba se schodištěm 10,45 m². Součástí domu je také praktická pochozí půda s oknem, která nabízí další úložný prostor.",
      "Dům byl postaven v roce 2000 společností Central Group a je v dobrém, průběžně udržovaném stavu. V r. 2020 byl instalován nový plynový kotel, v posledních třech letech byla vyměněna všechna okna za trojskla a v r. 2025 byla zrekonstruována koupelna ve druhém patře.",
      "V pokojích v patře jsou praktické vestavěné skříně a všechny pokoje, s výjimkou ložnice, disponují balkonovými dveřmi, díky čemuž jsou příjemně prosvětlené. V celém domě jsou plovoucí podlahy, v koupelnách, kuchyni a předsíni dlažba. Dům je napojen na veškeré inženýrské sítě, vytápění i ohřev vody zajišťuje plynový kotel. Měsíční zálohy na energie činí přibližně 8 000 Kč.",
      "Za domem se nachází udržovaná zahrada se zahradním domkem a s dětskými herními prvky včetně domu ve stromě, citlivě zakomponovaného do vzrostlého stromu.",
      "V místě je základní občanská vybavenost – MŠ, ZŠ, pošta, lékaři, v pěší dostupnosti pak obecní úřad, restaurace, obchod s potravinami, knihovna, kadeřnictví, kosmetika, fitness, zubní klinika, několik hřišť, sportovní areály a letní koupaliště.",
      "Vynikající dopravní dostupnost zajišťuje vlakové spojení na Hlavní nádraží (cca 23 minut) a autobusové spojení na metro Háje (cca 17 minut), nájezd na D1 je vzdálen přibližně 10 minut.",
    ],
  },
  {
    id: 1,
    slug: "vila-kolovraty",
    image: vila1,
    images: [vila1, vila2, vila3, vila4, vila5, vila6, vila7, vila8, vila9, vila10, vila11, vila12, vila13, vila14, vila15, vila16, vila17, vila18, vila19, vila20, vila21, vila22, vila23, vila24, vila25, vila26, vila27, vila28, vila29, vila30, vila31, vila32, vila33, vila34, vila35, vila36, vila37, vila38, vila39],
    floorPlans: [
      { image: floorplan1np3d, label: "1. NP – 3D" },
      { image: floorplan2np3d, label: "2. NP – 3D" },
      { image: floorplan1pp3d, label: "1. PP – 3D" },
      { image: floorplan1np2d, label: "1. NP – 2D" },
      { image: floorplan2np2d, label: "2. NP – 2D" },
      { image: floorplan1pp2d, label: "1. PP – 2D" },
    ],
    videos: [
      { youtubeId: "YkDicHCXMDQ", title: "Video-prohlídka interiéru" },
      { youtubeId: "xiJv38dKpRs", title: "Letecký záběr" },
    ],
    title: "Prodej nové vily s UP 358 m², výtahem, terasou a jedinečným výhledem",
    location: "Praha 10 · Kolovraty",
    price: "28 000 000 Kč",
    showPrice: true,
    size: "358 m²",
    landSize: "600 m²",
    disposition: "6+kk",
    sold: true,
    soldAt: "2026-11-03",
    reserved: false,


    features: ["Video-prohlídka"],
    type: "Vila",
    yearBuilt: "kolaudace 1/2025",
    zakázka: "ID 205-NP11606",
    mapCoords: { lat: 50.0092, lng: 14.6304 },
    description: [
      "Nabízíme k prodeji luxusní třípodlažní vilu s jedinečným výhledem, situovanou v klidné a prestižní lokalitě Prahy 10 – Kolovraty.",
      "Tento moderní dům s nadstandardním vybavením a elegantním designem nabízí vše, co si můžete přát pro komfortní a stylové bydlení.",
      "Důmyslně promyšlený půdorys nabízí celkovou užitnou plochu 358 m² rozloženou do tří podlaží a to vše na pozemku o výměře 600 m².",
      "Přízemí domu tvoří garáž pro 2 vozy, tělocvična, kinosál, technické zázemí a vstup do patra po schodišti i výtahem. Dominantou prvního patra je obytný prostor a kuchyně s ostrůvkem, z nichž je vstup na terasu 28 m². Díky velkoformátovým oknům je prostor velmi světlý a příjemný.",
      "Druhé patro tvoří 5 ložnic, 3 koupelny, šatna, výtah a chodba.",
      "Tato nemovitost splňuje nejvyšší standardy moderního bydlení a je připravena k okamžitému nastěhování.",
      "Dům je situován v samém centru obce a Kolovraty jsou známé svou rodinnou atmosférou a přátelským společenským sousedským životem. V místě je základní občanská vybavenost – Městský úřad, pošta, Knihovna s infocentrem, Mateřská a Základní škola, praktičtí lékaři pro děti i dospělé, restaurace, obchod s potravinami a letní koupaliště.",
      "Další výhodou je výborná dopravní dostupnost – zastávka autobusu směr Háje, dále vlakové zastávka směr Praha – Benešov, odjezd 4x za hodinu ve špičce, Hlavní nádraží 23 minut.",
    ],
  },
  {
    id: 5,
    slug: "dum-uhonice",
    image: uhonice1,
    images: uhoniceImages,
    floorPlans: uhoniceFloorPlans,
    videos: [
      { youtubeId: "gjDMl9FK0XM", title: "Video-prohlídka" },
    ],
    title: "Rodinný dům s UP 500 m², krytým bazénem, dvojgaráží a pozemkem 2 240 m²",
    location: "Jenečská, Praha – Úhonice",
    price: "29 950 000 Kč",
    priceNote: "za nemovitost",
    size: "500 m²",
    landSize: "2 240 m²",
    disposition: "6+1",
    sold: false,
    hidden: true,
    features: ["Video-prohlídka", "3D Scan"],
    type: "Dům",
    yearBuilt: "2000",
    zakázka: "ID 205-NP12041",
    mapCoords: { lat: 50.0467333, lng: 14.1881309 },
    matterportUrl: "https://my.matterport.com/show/?m=XjhFF3W7CBN&vr=0&play=1&search=0&mt=1&title=0",
    description: [
      "Nabízím k prodeji prostorný dům s plochou 500 m², na krásném pozemku 2 240 m², v obci Úhonice, na adrese Jenečská 21.",
      "Dům byl navržen jako individuální stavba s důrazem na vzdušnost, množství přirozeného světla a maximální propojení interiéru se zahradou.",
      "Suterén tvoří dvojgaráž 33,8 m², chodba 8,5 m², posilovna 19 m², sklad 7,5 m², technická místnost 5,6 m², WC 1,5 m² a sauna 4 m², u které je sprchový kout a umyvadlo.",
      "Přízemí tvoří prostorná hala 24 m² se vstupem na zahradu a schodištěm do mezipatra, obytný prostor s krbem a jídelnou 56 m² s velkými okny, díky kterým je celý prostor velmi světlý a kuchyně 12,8 m² s nadstandardním úložným prostorem. Dále je zde relaxační zóna 58 m² s krytým bazénem.",
      "Mezipatro tvoří chodba 18 m², 3 ložnice, 2 koupelny. Z chodby vedou 2 schodiště – první do místnosti 12 m², druhé do podkroví.",
      "Podkroví tvoří galerie 9 m² se střešními okny, pokoj 34 m², pracovna 15,5 m², koupelna se sprchovým koutem a WC 6,7 m², šatna 11,5 m² a půda s výměrou 74 m².",
      "Zahrada je vzrostlá, udržovaná a od počátku promyšleně budovaná s důrazem na soukromí. Součástí je přírodní biotop, vzrostlé stromy i ovocná zahrada a okrasné kameny.",
      "Úhonice leží několik minut jízdy od hlavního města, s rychlým napojením na dálnici D6 a autobusovým spojením na M Zličín.",
    ],
  },
  {
    id: 48,
    slug: "byt-1kk-uhrineves",
    image: uhrineves2Images[0],
    images: uhrineves2Images,
    floorPlans: uhrineves2FloorPlans,
    videos: [{ youtubeId: "N_jTO15dHN4", title: "Video-prohlídka" }],
    title: "Prodej světlého bytu 1+kk s lodžií, 32 m², Praha 10 – Uhříněves",
    location: "Praha 10 · Uhříněves",
    price: "5 700 000 Kč",
    priceNote: "za nemovitost",
    size: "32 m²",
    disposition: "1+kk",
    sold: true,
    soldAt: "2026-07-30",
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Byt",
    yearBuilt: "2019",
    zakázka: "ID 205-NP12728",
    mapCoords: { lat: 50.0316, lng: 14.6128 },
    mapZoom: 13,
    description: [
      "Světlý byt 1+kk s lodžií a sklepem na adrese Oty Bubeníčka 1639/8, Praha 10 – Uhříněves. Byt v osobním vlastnictví ve 4. NP cihlového domu s výtahem, kolaudovaného v roce 2019 v rámci projektu Vivus Uhříněves III.",
      "Byt o celkové ploše 32 m² nabízí prakticky řešený obytný prostor s plně vybaveným kuchyňským koutem 21,75 m², ze kterého je přímý vstup na lodžii 2,49 m². Dále prostorná předsíň 4,54 m² se skříní, koupelna s vanou a toaletou 4,82 m². K bytu náleží sklep 2,28 m².",
      "Velkou výhodou je možnost dlouhodobého pronájmu venkovního parkovacího stání u domu. Nemovitost je aktuálně pronajímána – okamžitý výnos bez nutnosti hledání nájemníka.",
      "Měsíční náklady činí cca 4 234 Kč + zálohy na elektřinu.",
      "V místě kompletní občanská vybavenost – MÚ, pošta, lékaři, lékárna, supermarket u domu, školy, školky. 5 min obchodní zóna Čestlice, 10 min OC Štěrboholy a OC Westfield Chodov.",
      "Výborná dopravní dostupnost – 5 min D1, vlak 20 min Hlavní nádraží, BUS Háje, Hostivař, Skalka. Ideální jako startovací bydlení nebo investice k pronájmu.",
    ],
  },
  // --- Choteč ---
  {
    id: 39,
    slug: "vila-chotec",
    image: chotecImages[0],
    images: chotecImages,
    floorPlans: chotecFloorPlans,
    videos: [
      { youtubeId: "j40nv9BFU08", title: "Video-prohlídka" },
    ],
    title: "Prostorná vila 6+kk na okraji obce Choteč, pozemek 2 681 m²",
    location: "Choteč · Český kras",
    price: "32 500 000 Kč",
    priceNote: "za nemovitost",
    size: "200 m²",
    landSize: "2 681 m²",
    disposition: "6+kk",
    sold: false,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Vila",
    zakázka: "",
    mapCoords: { lat: 49.9878, lng: 14.2853 },
    description: [
      "Exkluzivně nabízíme k prodeji výjimečný rodinný dům o dispozici 6+kk na okraji obce Choteč, která je součástí chráněné krajinné oblasti Český kras. Lokalita nabízí ideální kombinaci klidného bydlení v přírodě a velmi dobré dostupnosti do Prahy, jejíž centrum je vzdálené přibližně 20 minut a 7 min jízdy na pražský okruh, kde jedním směrem máte letiště (cca 15 min), Metropoli Zličín (cca 15 min) a druhým směrem centrum Prahy nebo pokračovat okruhem až na D1.",
      "Celková výměra pozemků činí téměř 2 700 m². Přibližně polovina pozemku bezprostředně navazuje na dům a je určena pro plnohodnotné využití jako zahrada a relaxační zázemí, zatímco druhá část má díky svému tvaru spíše doplňkový charakter. Právě tato část je ideální například pro drobný chov – nabízí prostor pro ovce, kozy, slepice nebo třeba včelaření, případně další využití dle potřeb majitele, a zároveň zajišťuje větší odstup od okolí a pocit soukromí.",
      "U domu je plánována relaxační zóna s bazénem o rozměrech 6 × 3 m s protiproudem, TČ, solanizátorem, automatickým hlídáním pH, který navazuje na terasy a zimní zahradu.",
      "Za vjezdem na pozemek bude zpevněná plocha s možností parkování 4 automobilů, z čehož dvě místa budou zastřešená.",
      "V přízemí se nachází hlavní vstup, dvougaráž, sklepní prostor s kompletní technologií domu a schodiště do obytné části domu. První nadzemní podlaží tvoří prostorná chodba a velkorysý obývací prostor s krbem a kuchyňským koutem. Odtud je přímý vstup do zimní zahrady, na terasu a dále do zahrady s bazénem. V této úrovni je dále situována ložnice, koupelna a samostatná toaleta.",
      "Ve druhém podlaží je další prostorná chodba, koupelna, samostatné WC, pracovna a ložnice. Dominantou patra je velký variabilní prostor, který lze rozdělit na další pokoje, případně ponechat jako otevřenou hernu, pracovnu či společenskou místnost. Také z tohoto podlaží je přístup do zimní zahrady a na terasu. Celková obytná plocha domu je 200 m², přičemž další významnou přidanou hodnotu tvoří uzavřená zimní zahrada o výměře cca 40 m² a venkovní terasy rozšiřující obytný prostor směrem do exteriéru.",
      "Dům je navržen s důrazem na energetickou úspornost a technologický komfort. Vytápění zajišťuje tepelné čerpadlo napojené na podlahové topení, přičemž zdrojem jsou zemní vrty. Dále je dům doplněn o fotovoltaickou elektrárnu s možností dobíjení elektromobilu. Zdrojem vody je vlastní vrtaná studna o hloubce 55 m, odpadní vody jsou řešeny prostřednictvím čističky odpadních vod. Objekt je napojen na elektrickou síť 230/400 V.",
      "Nemovitost je nabízena ve fázi shell & core, což novému majiteli umožňuje dokončit interiér přesně podle vlastních představ a zvolit si finální standardy včetně podlah, interiérových dveří, koupelen či kuchyňské linky.",
      "Jedná se o ideální nabídku pro náročné zájemce, kteří hledají kvalitní bydlení v přírodě, dostatek soukromí a zároveň možnost vytvořit si domov přesně podle svého životního stylu.",
    ],
  },
  {
    id: 7,
    slug: "dum-satalice",
    image: satalice1,
    images: sataliceImages,
    floorPlans: sataliceFloorPlans,
    videos: [
      { youtubeId: "fCpQaEwUq3c", title: "Video-prohlídka" },
    ],
    title: "Řadový rohový dům 4+kk se zahradou, bazénem a garáží – Satalice",
    location: "Praha 9 · Satalice",
    price: "21 900 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "143 m²",
    landSize: "334 m²",
    disposition: "4+kk",
    sold: false,
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "2004, kompl. reko. 2024",
    zakázka: "ID 205-NP12102",
    mapCoords: { lat: 50.1248, lng: 14.5819 },
    description: [
      "Nabízím exkluzivní rohový řadový dům 4+kk s užitnou plochou přibližně 143 m² a garáží o velikosti 21,7 m², který prošel kompletní rekonstrukcí v roce 2024. Dům se nachází v klidné části Prahy 9 – Satalice a prodává se plně zařízený, včetně nábytku na míru, vestavěných spotřebičů Miele a designových doplňků.",
      "Každý detail interiéru byl promyšlen s důrazem na funkčnost, kvalitu a styl. Dům je navržen designérem a nabízí komfortní a elegantní prostředí bez nutnosti dalších investic.",
      "V přízemí se nachází předsíň 5,2 m² s vestavěnými úložnými prostory, samostatné WC 1,4 m², prádelna 1,6 m² a spíž 0,9 m². Kuchyně 7,5 m² s linkou na míru je vybavena spotřebiči Miele a doplněna o LED podsvícení. Na kuchyň navazuje prostorný obývací pokoj 29,6 m² s přímým vstupem na terasu a zahradu. Dominantou obývací části je exkluzivní mozaiková dřevěná podlaha. Součástí přízemí je také garáž 21,7 m² s přímým vstupem do domu.",
      "V patře se nachází chodba 4,7 m², pokoj 14,5 m², druhý pokoj 17,0 m², ložnice 18,7 m² s prostornou šatnou 10,8 m² a dvě koupelny se sprchovým koutem a WC o velikosti 5,7 m² a 8,0 m². Celkem jsou v domě tři toalety.",
      "Zahrada o výměře 247 m² byla navržena architektem a tvoří soukromou oázu klidu. Je zde bazén o rozměru 5 × 3 metry se slanou vodou a tepelným čerpadlem, automatické zavlažování, zahradní domek s elektřinou a krytá pergola s posezením a grilem. Celý venkovní prostor je osvětlený a vybavený elektrickými zásuvkami.",
      "Dům je technicky i bezpečnostně nadstandardně vybaven. Má kamerový systém, alarm, klimatizaci ve všech místnostech, elektrické venkovní rolety, bezomítkové bezpečnostní dveře NEXT, podomítkové baterie, vysokorychlostní internet a všechny inženýrské sítě – plyn, elektřina, voda a kanalizace.",
      "V přízemí jsou dřevěné podlahy, v obývacím pokoji exkluzivní mozaiková dřevěná podlaha, v patře designové laminátové. Nábytek na míru s LED podsvícením, vestavěné skříně i osvětlené designové prvky dávají domu osobitý charakter. Kuchyň, obývací pokoj i ložnice byly navrženy designérem s důrazem na detail a pohodlí.",
      "Parkování je zajištěno v garáži a dalším stáním před domem.",
      "Dům se nachází v klidné a zelené části Prahy 9 – Satalice, v bezprostřední blízkosti přírodní památky Bažantnice a Satalické obory, které jsou součástí naučné stezky Vinořský park – Satalická bažantnice. Okolí nabízí ideální podmínky pro procházky, sport i relaxaci v přírodě.",
      "Výborná dopravní dostupnost: přibližně 5 minut na Černý Most, 10 minut do Letňan a 20 minut do centra Prahy. V blízkosti se nachází škola, školka, vlaková stanice, MHD i obchody.",
      "Tento exkluzivní, kompletně vybavený dům, nevyžaduje žádné investice a je připraven k okamžitému nastěhování. Spojuje nadčasový design, moderní technologie a klidné bydlení v přírodě s vynikající dostupností do centra Prahy.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 8,
    slug: "mezonet-brnik",
    image: brnik1,
    images: brnikImages,
    videos: [
      { youtubeId: "ZSJ29mCVMRI", title: "Video-prohlídka" },
    ],
    floorPlans: brnikFloorPlans,
    title: "Prodej mezonetu 3+kk o celkové podlahové ploše 114 m² v obci Brník",
    location: "Oleška · Brník",
    price: "7 290 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "114 m²",
    landSize: "49 m²",
    disposition: "3+kk",
    sold: false,
    hidden: true,
    features: ["Video-prohlídka"],
    type: "Mezonet",
    yearBuilt: "kolaudace 12/2024",
    zakázka: "ID 205-NP12188",
    mapCoords: { lat: 49.9275, lng: 14.8583 },
    description: [
      "Nabízím k prodeji rohový mezonetový byt 3+kk o celkové podlahové ploše 114 m² v obci Brník 14, Oleška.",
      "K nemovitosti patří pozemek o výměře 49 m² a předzahrádka o velikosti 15 m².",
      "Nachází se v prvním a druhém nadzemním podlaží domu, který prošel kompletní rekonstrukcí. Kolaudace proběhla v prosinci 2024.",
      "V přízemí je předsíň, koupelna se sprchovým koutem a toaletou s velkoformátovou dlažbou, kuchyně 18,15 m², obývací pokoj 17,92 m² a schodiště.",
      "V patře se nachází chodba, ložnice 15,06 m² a prostorný pokoj 26,46 m².",
      "Obec Oleška nabízí klidné bydlení s dobrou dostupností – do Říčan 10 minut, do Prahy 35–40 minut.",
    ],
  },
  {
    id: 9,
    slug: "byt-bohnice",
    image: bohnice1,
    images: bohniceImages,
    floorPlans: bohniceFloorPlans,
    videos: [
      { youtubeId: "JgdN9M3Kh_U", title: "Video-prohlídka" },
    ],
    title: "Prodej bytu 2+kk, 46,3 m², ul. Zelenohorská, Praha 8 – Bohnice",
    location: "Praha 8 · Bohnice",
    price: "5 850 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "46,3 m²",
    disposition: "2+kk",
    sold: true,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP12552",
    mapCoords: { lat: 50.1282, lng: 14.4184 },
    description: [
      "Dovoluji si Vám nabídnout prodej bytu 2+kk, 46 m² + 2 sklepní kóje, na adrese Zelenohorská 499/31, Praha 8 – Bohnice.",
      "Byt je v osobním vlastnictví a nachází se v 11.NP panelového domu s výtahem.",
      "Dispozice bytu tvoří obytný pokoj, samostatná ložnice, kuchyňský kout, koupelna, samostatné WC, předsíň a komora. K bytu náleží dvě sklepní kóje na patře.",
      "Byt je určen ke kompletní rekonstrukci. Dům je průběžně udržován – zateplení, nové dlažby, nové zábradlí.",
      "Lokalita nabízí dobrou dopravní dostupnost a plnou občanskou vybavenost. Zastávky MHD s napojením na metro Kobylisy.",
      "Byt je vhodný jak pro vlastní bydlení, tak jako investice s potenciálem dlouhodobého pronájmu.",
    ],
  },
  {
    id: 10,
    slug: "pozemek-rataje",
    image: rataje1,
    images: ratajeImages,
    videos: [
      { youtubeId: "F9MX77V4PjE", title: "Video-prohlídka" },
    ],
    title: "Stavební pozemek 1 381 m² u lesa v Ratajích nad Sázavou",
    location: "Rataje nad Sázavou",
    price: "1 519 100 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "1 381 m²",
    sold: false,
    features: ["Video-prohlídka"],
    type: "Pozemek",
    zakázka: "ID 205-NP12373",
    mapCoords: { lat: 49.8383, lng: 14.9725 },
    description: [
      "Nabízíme k prodeji pozemek o výměře 1 381 m² v obci Rataje nad Sázavou, situovaný na okraji zástavby v přímém kontaktu s lesem, v mimořádně klidné části Posázaví. Pozemek je dle platných územně plánovacích regulativů určen pro rekreační bydlení v rámci ploch chatové zástavby, což umožňuje výstavbu chaty nebo rekreačního objektu určeného k přechodnému a sezónnímu užívání. Nejedná se o pozemek pro trvalé bydlení.",
      "Lokalita nabízí výjimečné soukromí a klid, který je dnes stále vzácnější. Les bezprostředně navazuje na hranici pozemku, okolní zástavba je minimální a celé místo působí velmi harmonicky a nerušeně. Výměra pozemku poskytuje dostatek prostoru nejen pro samotnou stavbu, ale i pro zahradu, relaxační zázemí a zachování přírodního charakteru pozemku.",
      "Elektrická energie – distribuční síť se nachází ve vzdálenosti cca 200 m od pozemku. Připojení je možné řešit na základě žádosti a dle podmínek příslušného distributora. Regulativy dále umožňují řešení odpadních vod formou jímky nebo domovní čistírny odpadních vod a zásobování vodou prostřednictvím vrtané studny. Pozemek je právně čistý, bez věcných břemen, zástav či jiných omezení.",
      "Dle regulativů je možná výstavba rekreační stavby s maximálně jedním nadzemním podlažím a podkrovím, v tradičním architektonickém pojetí odpovídajícím okolní zástavbě. Lokalita není zatížena žádnou průmyslovou ani rušivou činností a je ideální pro rekreaci, odpočinek, víkendové pobyty i dlouhodobé využití jako soukromé rekreační zázemí.",
      "Tento pozemek je ideální volbou pro zájemce, kteří hledají kombinaci přírody, klidu a reálné možnosti výstavby rekreační stavby v atraktivní lokalitě Posázaví, stejně jako pro ty, kteří uvažují o dlouhodobé investici v místě s omezenou nabídkou obdobných pozemků.",
      "Pozemky s možností rekreační výstavby v takto klidném prostředí se na trhu objevují jen výjimečně. Pro více informací a domluvení prohlídky mě neváhejte kontaktovat.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 128,
    slug: "dum-6kk-panenske-brezany-u-obory",
    image: brezanyDumImages[0],
    images: brezanyDumImages,
    floorPlans: brezanyDumFloorPlans,
    matterportUrl: "https://my.matterport.com/show/?m=VY2PmuqS1xK&vr=0&play=1&search=0&mt=1&title=0",
    videos: [{ youtubeId: "ztf7g0gdYeI", title: "Video-prohlídka" }],
    title: "Rodinný dům 6+kk na svažitém pozemku 1 643 m², Panenské Břežany – U Obory, ideální pro rekonstrukci",
    location: "U Obory, Panenské Břežany, okres Praha-východ",
    price: "7 990 900 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "90 m²",
    landSize: "1 643 m²",
    disposition: "6+kk",
    parking: "Samostatná garáž",
    sold: false,
    reserved: true,
    features: ["Exkluzivně", "Video-prohlídka", "3D Scan"],
    type: "Dům",
    zakázka: "ID 205-NP12511",
    mapCoords: { lat: 50.1937, lng: 14.4283 },
    utilities: "Elektřina 230 V / 400 V, obecní vodovod, kanalizace, internet, plyn na hranici pozemku",
    description: [
      "V Panenských Břežanech, v klidné ulici U Obory, nabízíme k prodeji rodinný dům o dispozici 6+kk, umístěný na prostorném svažitém pozemku o celkové výměře 1 643 m². Dům je v původním stavu a je vhodný buď k rozsáhlé rekonstrukci nebo k demolici a následné výstavbě nového rodinného domu přesně podle představ nového majitele. Tato nemovitost představuje výjimečnou příležitost pro ty, kteří hledají velký pozemek v oblíbené lokalitě s výbornou dostupností Prahy.",
      "Stávající dvoupodlažní dům má dispozici vycházející z půdorysů: v přízemí se nachází předsíň, komora, obývací pokoj s kuchyňským koutem, další pokoj, toaleta, garáž, prostorná prádelna a další úložné prostory. V patře je umístěna chodba, koupelna, ložnice, kuchyně a balkon s výhledem do zahrady. Celková plocha dle plánů činí 177 m², včetně garáže, balkonu i vedlejších hospodářských částí. Na pozemku se nachází také samostatná garáž a technické zázemí, které mohou sloužit jako dílna nebo sklad.",
      "Nemovitost je napojena na elektřinu, obecní vodovod, kanalizaci i internet. Plyn se nachází přímo na hranici pozemku a je připraven pro budoucí připojení. Svažité terénní uspořádání nabízí možnost atraktivního architektonického řešení, například výstavby víceúrovňového domu nebo terasovité zahrady.",
      "Panenské Břežany jsou žádanou lokalitou díky příjemnému prostředí, blízkosti přírody i hlavního města. V obci se nachází mateřská a základní škola, knihovna, obecní úřad a výdejní místo pošty. Základní občanská vybavenost je doplněna službami v nedaleké Odoleně Vodě a Brandýse nad Labem. Obec je známá také svými historickými památkami, zejména kaplí sv. Anny a areálem místního zámku, které dodávají lokalitě jedinečný charakter.",
      "Dopravní dostupnost je výborná. Autobusová linka PID 373 navazuje přímo na pražskou stanici metra C Kobylisy, přičemž zastávky jsou v docházkové vzdálenosti od domu. Autem se snadno napojíte na hlavní tahy směrem na Prahu přes Zdiby. Lokalita tak spojuje klidné bydlení s výbornou dostupností města.",
      "Tato nabídka je ideální pro rodinu nebo investora, který hledá prostorný pozemek s potenciálem v atraktivní obci v blízkosti Prahy. Nemovitost je připravena k okamžitému předání.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  {
    id: 11,
    slug: "dum-pozden-1",
    image: pozden1img,
    images: pozden1Images,
    floorPlans: pozden1FloorPlans,
    videos: [
      { youtubeId: "J3YyvCIjV38", title: "Video-prohlídka" },
    ],
    title: "Prodej rodinného domu 5+kk se zahradou 289 m², Pozdeň č.p. 90",
    location: "Pozdeň · okres Kladno",
    price: "8 190 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "157 m²",
    landSize: "289 m²",
    disposition: "5+kk",
    sold: true,
    reserved: false,
    soldAt: "2026-10-28",
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "kompletní rekonstrukce",
    zakázka: "ID 205-NP12298",
    mapCoords: { lat: 50.2421, lng: 13.9415 },
    description: [
      "Nabízíme k prodeji krajní řadový rodinný dům 5+kk s užitnou plochou 156,80 m² a soukromou zahradou, který je součástí kompletně nově zrekonstruovaného objektu v obci Pozdeň. Dům je zcela nový, dosud neobývaný a připravený k okamžitému nastěhování.",
      "První nadzemní podlaží tvoří prostorný obývací pokoj s přípravou na kuchyň (45 m²), ložnice, sociální zařízení, chodby a komora.",
      "Ve druhém nadzemním podlaží se nacházejí tři pokoje, sociální zařízení, chodba a schodiště.",
      "K domu náleží soukromá zahrada o velikosti 289 m² a dvě parkovací místa přímo u domu.",
      "Dům je vybaven moderním tepelným čerpadlem vzduch/voda, podlahovým topením v celém objektu. Provozní náklady kolem 1 500–2 000 Kč měsíčně.",
      "Obec Pozdeň nabízí základní občanskou vybavenost. Do Slaného 9 km, do Kladna 16 km, do Prahy 30–35 minut.",
    ],
  },
  {
    id: 12,
    slug: "dum-pozden-3",
    image: pozden3img,
    images: pozden3Images,
    floorPlans: pozden3FloorPlans,
    videos: [
      { youtubeId: "pSDNrCeBgCM", title: "Video-prohlídka" },
    ],
    title: "Prodej rodinného domu 5+kk se zahradou 294 m², Pozdeň č.p. 90",
    location: "Pozdeň · okres Kladno",
    price: "7 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "156 m²",
    landSize: "294 m²",
    disposition: "5+kk",
    sold: true,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "kompletní rekonstrukce",
    zakázka: "ID 205-NP12313",
    mapCoords: { lat: 50.2421, lng: 13.9415 },
    description: [
      "Nabízíme k prodeji krajní řadový rodinný dům 5+kk s užitnou plochou 155,66 m² a soukromou zahradou v obci Pozdeň. Dům je zcela nový, dosud neobývaný a připravený k okamžitému nastěhování.",
      "První nadzemní podlaží tvoří obývací pokoj s přípravou na kuchyň (46,14 m²), ložnice, sociální zařízení, chodba a zádveří.",
      "Ve druhém nadzemním podlaží se nachází tři pokoje, sociální zařízení, chodba a schodiště.",
      "K domu náleží dvě oplocené zahrady o celkové výměře 294 m², vlastní vstup, vjezdová brána, dvě parkovací místa a vlastní studna.",
      "Dům je vybaven moderním tepelným čerpadlem vzduch/voda, podlahovým topením. Provozní náklady kolem 1 500–2 000 Kč měsíčně.",
    ],
  },
  {
    id: 13,
    slug: "dum-pozden-2",
    image: pozden2img,
    images: pozden2Images,
    floorPlans: pozden2FloorPlans,
    videos: [
      { youtubeId: "6j7-fMrBypY", title: "Video-prohlídka" },
    ],
    title: "Prodej rodinného domu 6+kk se zahradou 283 m², terasou a sklepem, Pozdeň č.p. 90",
    location: "Pozdeň · okres Kladno",
    price: "8 450 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "171 m²",
    landSize: "283 m²",
    disposition: "6+kk",
    sold: true,
    reserved: false,
    soldAt: "2026-09-01",
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "kompletní rekonstrukce",
    zakázka: "ID 205-NP12305",
    mapCoords: { lat: 50.2421, lng: 13.9415 },
    description: [
      "Nabízíme k prodeji dvoupodlažní středový rodinný dům o dispozici 6+kk s užitnou plochou 171,74 m², soukromou zahradou 283 m², terasou a sklepem v obci Pozdeň.",
      "V prvním nadzemním podlaží se nachází prostorný obývací pokoj s jídelnou (41,40 m²), kuchyň (13,81 m²) s přímým vstupem na terasu 11,89 m², ložnice, koupelna, chodba a zádveří.",
      "Ve druhém nadzemním podlaží se nacházejí čtyři pokoje, koupelna s přípravou na vanu, prostorná chodba a schodiště.",
      "Součástí nemovitosti je sklep v 1. podzemním podlaží o velikosti 17,37 m².",
      "Technické vybavení zahrnuje tepelné čerpadlo vzduch/voda, celoplošné podlahové vytápění. Provozní náklady přibližně 1 500–2 000 Kč měsíčně.",
      "Obec Pozdeň – MŠ 100 m, obchod 150 m, autobusová zastávka 200 m. Slaný 9 km, Kladno 16 km, Praha 30–35 minut.",
    ],
  },
  {
    id: 14,
    slug: "mezonet-brnik-2",
    image: brnik2Images[0],
    images: brnik2Images,
    floorPlans: brnik2FloorPlans,
    videos: [
      { youtubeId: "OtHERL0rric", title: "Video-prohlídka" },
    ],
    title: "Mezonetový byt 3+kk, 96 m², se zahradou 129 m² – Brník 14, Oleška",
    location: "Oleška · Brník",
    price: "6 590 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "96 m²",
    landSize: "129 m²",
    disposition: "3+kk",
    sold: true,
    soldAt: "2026-07-30",
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Mezonet",
    yearBuilt: "kolaudace 12/2024",
    zakázka: "ID 205-NP12191",
    mapCoords: { lat: 49.9275, lng: 14.8583 },
    description: [
      "Nabízím k prodeji mezonetový byt 3+kk o celkové ploše 96 m² se zahradou 129 m² v obci Brník, část Oleška.",
      "Byt se nachází uprostřed tří sousedních jednotek v domě, který prošel kompletní rekonstrukcí a byl zkolaudován koncem roku 2024.",
      "V přízemí se nachází obývací pokoj s kuchyňským koutem (26,80 m²), chodba (16,33 m²) a koupelna se sprchovým koutem a WC (4,19 m²).",
      "V patře je chodba (5,43 m²), ložnice (15,58 m²) a prostorný pokoj (23,57 m²). Jednotlivé místnosti propojuje točité schodiště.",
      "Topení zajišťuje elektrický kotel se zásobníkem na teplou vodu 80 l. Okna Velux s trojskly, bezpečnostní vstupní dveře.",
      "Obec Brník (součást Olešky) – klidná lokalita, 30 minut od Prahy, 10 minut od Říčan. ZŠ, MŠ, obchod a autobusová zastávka v místě.",
    ],
  },
  {
    id: 15,
    slug: "byt-uhrineves",
    image: uhrinesImages[0],
    images: uhrinesImages,
    floorPlans: uhrinesFloorPlans,
    videos: [
      { youtubeId: "tmX3WTvSKRg", title: "Video-prohlídka" },
    ],
    title: "Prodej bytu 3+1 + L, DV, 73,49 m², Praha 10 – Uhříněves",
    location: "V Bytovkách 839/8, Praha 10 · Uhříněves",
    price: "6 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "73,49 m²",
    disposition: "3+1",
    sold: true,
    soldAt: "2026-06-25",
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Byt",
    yearBuilt: "panelový dům, zateplený",
    zakázka: "ID 205-NP12070",
    mapCoords: { lat: 50.03073, lng: 14.59470 },
    mapZoom: 15,
    description: [
      "Byt 3+1 v družstevním vlastnictví ve 2. NP panelového domu s výtahem v klidné části Prahy 10 – Uhříněvsi, ul. V Bytovkách.",
      "Byt je v původním stavu s klasickou dispozicí – samostatná kuchyň a tři neprůchozí pokoje. Součástí je lodžie 3 m² orientovaná do klidného vnitrobloku.",
      "Dispozice: obývací pokoj 23,5 m², ložnice 18,3 m², druhá ložnice 14,1 m², kuchyně 6,4 m², chodba, předsíň, koupelna, WC. K bytu náleží sklepní kóje.",
      "Dům je zateplen, proběhla výměna plastových oken i stoupaček. Fond oprav v dobré kondici, dům není zadlužen.",
      "Měsíční náklady 5 700 Kč vč. fondu oprav + elektřina. Anuita splacena.",
      "Výborná občanská vybavenost a dopravní dostupnost – 5 min D1, vlak 20 min na Hlavní nádraží, BUS Háje/Hostivař/Skalka.",
    ],
  },
  {
    id: 16,
    slug: "mezonet-brnik-4kk",
    image: brnik3Images[0],
    images: brnik3Images,
    floorPlans: brnik3FloorPlans,
    videos: [
      { youtubeId: "2HirON_JuqI", title: "Video-prohlídka" },
    ],
    title: "Mezonetový byt 4+kk s garáží, 1+kk a zahradou 570 m² – Brník 14, Oleška",
    location: "Oleška · Brník",
    price: "12 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "192 m²",
    landSize: "570 m²",
    disposition: "4+kk + 1+kk",
    sold: false,
    hidden: true,
    features: ["Video-prohlídka"],
    type: "Mezonet",
    yearBuilt: "kompletní rekonstrukce",
    zakázka: "ID 205-NP12209",
    mapCoords: { lat: 49.9838, lng: 14.9079 },
    description: [
      "Bytová jednotka o užitné ploše 192 m² v rodinném domě č. p. 14, Brník – Oleška. K bytu patří zahrada 570 m² a garáž 43 m².",
      "Součástí je samostatná bytová jednotka 1+kk (26 m²) s vlastním vchodem – ideální pro hosty, pracovnu nebo pronájem.",
      "V přízemí: kuchyně s jídelnou (35,91 m²), technická místnost, hobby místnost (19,04 m²), koupelna, ateliér (20,91 m²). Dominantou je prosklené atrium.",
      "V patře: chodba, koupelna s vířivou vanou a bidetem, ložnice (21,06 m²), pokoj a galerie (33,25 m²). Schodiště obloženo pravým mramorem.",
      "Vytápění elektrokotlem a kotlem na dřevo. Na pozemku elektrická vjezdová brána, altán 24 m² s grilem a vířivkou.",
      "Brník – 10 min Kostelec n. Č. lesy, 20 min Říčany, 35–40 min Praha. MŠ, obchod, restaurace, od září 2025 nová ZŠ.",
    ],
  },
  {
    id: 17,
    slug: "byt-estepona",
    image: esteponaImages[0],
    images: esteponaImages,
    floorPlans: esteponaFloorPlans,
    videos: [{ youtubeId: "kWyKmBP6L2Y", title: "Video-prohlídka" }],
    title: "Nový apartmán 3kk, 71,8 m² + 30 m² terasa + zahrádka 53 m² v projektu Azahar de Estepona, Španělsko",
    location: "Estepona · Costa del Sol, Španělsko",
    price: "440 000 €",
    priceNote: "vč. provize a právních služeb",
    size: "71,8 m²",
    landSize: "83 m²",
    disposition: "3kk",
    hidden: true,
    sold: false,
    features: ["Video-prohlídka"],
    type: "Byt",
    yearBuilt: "novostavba, zkolaudováno",
    zakázka: "ID 205-NP12343",
    mapCoords: { lat: 36.4133, lng: -5.1920 },
    description: [
      "Nabízíme ke koupi prostorný moderní apartmán o dispozici 3kk v dokončeném a zkolaudovaném rezidenčním projektu Azahar de Estepona, připraveném k okamžitému nastěhování. Tento exkluzivní komplex se skládá z pouhých 61 moderních bytů rozmístěných v sedmi nízkopodlažních budovách orientovaných převážně na jih a jihozápad.",
      "Apartmán se nachází v přízemí a nabízí promyšlenou dispozici s prostorným obývacím pokojem propojeným s moderní kuchyní, dvěma samostatnými ložnicemi, dvěma koupelnami, vstupní halou a technickou místností. Hlavní obytný prostor plynule navazuje na velkorysou krytou terasu o výměře téměř 30 m² a navazující soukromou předzahrádku 53 m² k výhradnímu užívání.",
      "Měsíční provozní náklady činí přibližně 250 EUR a zahrnují zálohy na elektřinu, vodu a správu domu.",
      "Interiér je proveden ve vysokém standardu s důrazem na kvalitní materiály a nadčasový design. Podlahy tvoří leštěná porcelánová dlažba Marazzi v odstínu Work Grey. Kuchyň je vybavena vestavnými spotřebiči značky Balay, koupelny disponují sanitou Duravit Neo, umyvadly Mineralmarmo, bateriemi TRESS Class.",
      "Komplex Azahar de Estepona nabízí venkovní bazén, plně vybavenou posilovnu, pečlivě upravené společné zahrady, výtahy a bezpečné podzemní parkování. Byty jsou vybaveny centrální klimatizací a energeticky úsporným systémem ohřevu vody s třídou A+.",
      "Lokalita poskytuje rychlé napojení na dálnici AP-7, snadnou dostupnost mezinárodního letiště v Málaze i vyhlášených destinací Costa del Sol, jako jsou Marbella či Puerto Banús. Nemovitost je vhodná jak pro vlastní bydlení, tak jako investice s vysokým potenciálem krátkodobého i dlouhodobého pronájmu.",
    ],
  },
  {
    id: 18,
    slug: "byt-estepona-4kk",
    image: estepona2Images[0],
    images: estepona2Images,
    floorPlans: estepona2FloorPlans,
    videos: [{ youtubeId: "3N01bDo2ygc", title: "Video-prohlídka" }],
    title: "Nový apartmán 4kk, 93,5 m² + 40 m² terasa + zahrádka 75 m² v projektu Azahar de Estepona, Španělsko",
    location: "Estepona · Costa del Sol, Španělsko",
    price: "560 000 €",
    priceNote: "vč. provize a právních služeb",
    size: "93,5 m²",
    landSize: "115 m²",
    disposition: "4kk",
    hidden: true,
    sold: false,
    features: ["Video-prohlídka"],
    type: "Byt",
    yearBuilt: "novostavba, zkolaudováno",
    zakázka: "ID 205-NP12347",
    mapCoords: { lat: 36.4133, lng: -5.1920 },
    description: [
      "Nabízíme ke koupi prostorný moderní apartmán o dispozici 4kk v dokončeném a zkolaudovaném rezidenčním projektu Azahar de Estepona, připraveném k okamžitému nastěhování. Exkluzivní komplex tvoří pouze 61 moderních bytů rozmístěných v sedmi nízkopodlažních budovách orientovaných převážně na jih a jihozápad.",
      "Apartmán je situován v přízemí a nabízí velmi dobře řešenou dispozici s prostorným obývacím pokojem propojeným s moderní kuchyní, třemi samostatnými ložnicemi, dvěma koupelnami, vstupní halou, chodbou a technickou místností. Hlavní obytný prostor plynule navazuje na rozsáhlou krytou terasu o výměře 40 m² a navazující soukromou předzahrádku 75 m² k výhradnímu užívání.",
      "Měsíční provozní náklady činí přibližně 250 EUR a zahrnují zálohy na elektřinu, vodu a správu domu.",
      "Interiér je proveden ve vysokém standardu s důrazem na kvalitní materiály a nadčasový design. Podlahy tvoří leštěná porcelánová dlažba Marazzi v odstínu Work Grey. Kuchyň je vybavena vestavnými spotřebiči značky Balay. Koupelny disponují sanitou Duravit Neo, umyvadly Mineralmarmo, bateriemi TRESS Class.",
      "Rezidenční komplex Azahar de Estepona nabízí venkovní bazén obklopený upravenými zahradami, plně vybavenou posilovnu, společné zelené plochy navržené zahradním architektem, výtahy a bezpečné podzemní parkování. Byty jsou vybaveny centrální klimatizací a energeticky úsporným systémem ohřevu vody s třídou A+.",
      "Lokalita poskytuje rychlé napojení na dálnici AP-7, snadnou dostupnost mezinárodního letiště v Málaze i vyhlášených destinací Costa del Sol, jako jsou Marbella či Puerto Banús. Nemovitost je ideální jak pro vlastní bydlení, tak jako atraktivní investiční příležitost pro krátkodobý i dlouhodobý pronájem.",
    ],
  },
  {
    id: 19,
    slug: "pozemek-drevniky",
    image: drevnikyImages[0],
    images: drevnikyImages,
    videos: [
      { youtubeId: "4y37Cb0Uk_4", title: "Video-prohlídka" },
    ],
    title: "Slunný stavební pozemek 1 051 m² v Drevníkách",
    location: "Drevníky · okres Příbram",
    price: "5 350 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "1 051 m²",
    sold: false,
    features: ["Video-prohlídka"],
    type: "Pozemek",
    zakázka: "ID 205-NP12334",
    mapCoords: { lat: 49.7550, lng: 14.3150 },
    description: [
      "Slovo domov má své kořeny v klidu, prostoru a pocitu bezpečí – a přesně to nabízí tento slunný pozemek o výměře 1 051 m² v oblíbené lokalitě Na Výsluní v Drevníkách. Leží na okraji nové, stabilizované zástavby rodinných domů, obklopený otevřenou krajinou Brd.",
      "Díky orientaci na jih a ideálnímu tvaru pozemku můžete navrhnout moderní rodinný dům přesně podle svých představ. Obvyklý koeficient zastavěnosti 25 až 30 % umožňuje zastavěnou plochu přibližně 260 až 315 m².",
      "Součástí prodeje je také podíl na příjezdové cestě. Elektřina je přivedena přímo na hranici pozemku, voda se řeší vlastní studnou. Kanalizace se v obci nově buduje a bude dokončena ve třetím čtvrtletí roku 2027.",
      "Velkou přidanou hodnotou je poloha v těsné blízkosti Slapské přehrady, která patří mezi nejvyhledávanější rekreační oblasti ve středních Čechách. Okolní krajina Brd a Posázaví je ideální pro pěší turistiku, cyklovýlety a vodní sporty.",
      "Drevníky jsou dlouhodobě vyhledávanou obcí díky poloze mezi Brdy a Slapskou přehradou, s rychlou dostupností na Dobříš a pohodlným spojením do Prahy po dálnici D4 nebo prostřednictvím PID.",
    ],
  },
  {
    id: 20,
    slug: "dum-herink",
    image: herinkImages[0],
    images: herinkImages,
    floorPlans: herinkFloorPlans,
    videos: [
      { youtubeId: "ZLwM7SVSr3M", title: "Video-prohlídka" },
    ],
    title: "Prodej rodinného domu 4kk, pozemek 695 m², Herink, Praha-východ",
    location: "Herink · Praha-východ",
    price: "13 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "121 m²",
    landSize: "695 m²",
    disposition: "4+kk",
    sold: true,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "2008",
    zakázka: "ID 205-NP12098",
    mapCoords: { lat: 49.9672, lng: 14.5819 },
    description: [
      "Nabízíme Vám exkluzivně k prodeji rodinný dům o rozloze 121 m² a dispozici 4+kk v klidné části obce Herink. Obec je vzdálená 15 minut jízdy autem a 20 minut autobusem od Prahy, bezprostředně za Průhonicemi.",
      "Dům je situován na rohovém pozemku o velikosti 695 m² a má pouze jednoho souseda. Součástí nemovitosti je fotovoltaická elektrárna s bateriemi – průměrné měsíční náklady se pohybují kolem 4 000 Kč.",
      "Obývací pokoj s kuchyňským koutem o ploše 43,9 m² je vybaven krbovými kamny, podlahovým topením, klimatizací a velkými francouzskými okny s přímým vstupem na terasu. Dále ložnice 15,8 m² a dva další pokoje (14,0 a 14,1 m²).",
      "Celý dům je situován v jednom podlaží a bez stavebních úprav je možné jej užívat jako bezbariérový.",
      "Objekt je napojen na obecní vodovod a kanalizaci, vytápění zajišťují elektrické přímotopy, podlahové topení doplněné o krbová kamna. K dispozici nabíječka na elektroauto.",
      "V docházkové vzdálenosti je mateřská škola, obchod i restaurace. Nájezd na D1 je vzdálen 2 km, Pražský okruh je dostupný v nedaleké Jesenici.",
    ],
  },
  {
    id: 21,
    slug: "pozemky-petrov",
    image: petrovImages[0],
    images: petrovImages,
    title: "Ucelený soubor 12 stavebních pozemků v lokalitě Na Hřebenech, Petrov u Prahy",
    location: "Petrov u Prahy · Praha-západ",
    price: "2 850 Kč/m²",
    priceNote: "vč. provize a právních služeb",
    size: "15 151 m²",
    videos: [
      { youtubeId: "NyB85aL7YYc", title: "Video-prohlídka" },
    ],
    sold: false,
    features: ["Video-prohlídka"],
    type: "Pozemek",
    zakázka: "ID 205-NP11734",
    mapCoords: { lat: 49.8864, lng: 14.4337 },
    description: [
      "Nabízíme k prodeji ucelený investiční celek 12 stavebních pozemků včetně tří přístupových cest v obci Petrov u Prahy – lokalita Na Hřebenech. Jedinečná příležitost pro developerský projekt nebo střednědobou investici.",
      "Celková výměra 15 151 m² – z toho 11 071 m² stavební parcely (882–1 007 m²) a 4 080 m² komunikace a přístupové cesty. Pozemky tvoří 2. etapu výstavby rodinných domů.",
      "Územní podmínky: max. 2 NP + podkroví, max. výška hřebene 9 m, zastavitelnost hlavní stavbou do 30 %, včetně doplňkových staveb až 40 %. Funkční využití: bydlení v rodinných domech (BI).",
      "Elektřina je přivedena na hranici pozemku. Kanalizace a vodovod budou realizovány po dokončení nové ČOV Petrov – zahájení výstavby březen 2026, předpokládané dokončení květen–červen 2027.",
      "Lokalita kombinuje klid a přírodu s výborným dopravním spojením – vlaková zastávka 200 m, centrum Prahy do 30 minut přímým spojením.",
    ],
  },
  {
    id: 22,
    slug: "roubenka-srdov",
    image: srdovImages[0],
    images: srdovImages,
    floorPlans: srdovFloorPlans,
    title: "Chalupa v obci Srdov – roubenka po rekonstrukci v atraktivní lokalitě Českého středohoří",
    location: "Srdov · Litoměřice",
    price: "8 900 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "165 m²",
    disposition: "4+1",
    landSize: "2 191 m²",
    yearBuilt: "19. století",
    videos: [
      { youtubeId: "6a0qyxkJabE", title: "Video-prohlídka" },
    ],
    sold: false,
    features: ["Video-prohlídka", "3D Scan"],
    type: "Chata",
    zakázka: "ID 205-NP11980",
    mapCoords: { lat: 50.5977, lng: 14.2874 },
    matterportUrl: "https://my.matterport.com/show/?m=pQH58N7G4Wb&vr=0&play=1&search=0&mt=1&title=0",
    hidden: true,
    description: [
      "Půvabná roubenka na úpatí Českého středohoří v obci Srdov č.e. 44. Více než dvě století stará stavba prošla citlivou a postupnou rekonstrukcí, včetně výměny střešní krytiny za betonové tašky. Spojení tradičního stylu s pohodlím moderního bydlení – vhodné jak pro víkendové využití, tak pro celoroční obývání.",
      "Spodní podlaží, zasazené částečně do svahu, je postavené z kamene a pískovce – dílna, šatna, koupelna s WC, vinárna, garáž i technická místnost. Hlavní obytné patro nabízí útulný pokoj a rozlehlý obývací prostor propojený s kuchyní.",
      "Z obývacího prostoru je vstup na terasu ve stylu pavlače se schodištěm vedoucím do zahrady a dále druhá terasa orientovaná na jihovýchod (cca 25 m²) s krásným výhledem na okolní přírodu. Podkroví nabízí dvě samostatné ložnice, chodbu a toaletu.",
      "Vytápění zajišťuje kotel na pelety s radiátory, voda bude z vlastní studny (ve výstavbě), odpad sveden do septiku. Chalupa se prodává převážně včetně stylového zařízení zhotoveného na míru.",
      "K domu patří pozemek 2 191 m² s pečlivě udržovanou zahradou, okrasnými keři, vzrostlými stromy a romantickým jezírkem. K dispozici robustní pergola se zděnou základnou a zastřešený vyhřívaný bazén se slanou vodou.",
      "Srdov je malebná obec, součást vesnické památkové zóny na kraji Národní přírodní rezervace Sedlo. Úštěk 5 km, Litoměřice 15 km, Praha cca 70 km (necelá hodina jízdy).",
    ],
  },
  {
    id: 23,
    slug: "vila-bali",
    image: baliImages[0],
    images: baliImages,
    videos: [{ youtubeId: "TSm1yPTbMgs", title: "Video-prohlídka" }],
    title: "Vila na Bali – tropický ráj v designu Joshua Design",
    location: "Kedungu · Bali, Indonésie",
    price: "16 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "150 m²",
    disposition: "2+kk + apartmán",
    landSize: "1 800 m²",
    sold: false,
    features: ["Video-prohlídka"],
    type: "Vila",
    zakázka: "ID 205-NP11335",
    mapCoords: { lat: -8.5870, lng: 115.0870 },
    description: [
      "Zcela unikátní vila v Kedungu – klidné oblasti v západní části Bali, jen pár minut od legendárního chrámu Tanah Lot a surfařského pobřeží. Design pochází z dílny renomované světové značky Joshua Design.",
      "Vila se nachází v naprostém soukromí, obklopena bujnou zelení tropické zahrady o rozloze více než 1 800 m². Součástí pozemku je hlavní vila se dvěma ložnicemi a prostorným obývacím prostorem, stejně jako samostatný apartmán ideální pro hosty nebo pronájem.",
      "Prostorné interiéry, velkoformátová okna propojující interiér s přírodou, dřevěné podlahy, elegantní kuchyně s výhledem do zahrady a ložnice s přímým vstupem ven tvoří neobyčejný domov.",
      "Na pozemku se nachází bazén připomínající tropickou lagunu – zakřivené linie, stromy prorůstající přímo z vody, noční osvětlení a relaxační zóna se saunou a párou. Celý prostor je napájen přírodním pramenem.",
      "Zahrada plná palem, kapradin a tichých zákoutí. Terasa s venkovním sezením, letní kuchyně a naprosté ticho – jen šumění větru a přírody.",
      "Ideální jak pro osobní bydlení, tak jako luxusní rekreační nemovitost s výborným potenciálem k pronájmu. Lokalita si zachovává ryzí balijskou autentičnost.",
    ],
  },
  {
    id: 25,
    slug: "pozemek-vlkancice",
    image: vlkanciceImages[0],
    images: vlkanciceImages,
    videos: [
      { youtubeId: "ptlpgn_hmoU", title: "Video-prohlídka" },
    ],
    title: "Prodej pozemku 1 234 m² v obci Vlkančice – Pyskočely",
    location: "Vlkančice · Pyskočely",
    price: "1 620 Kč/m²",
    priceNote: "vč. provize a právních služeb",
    size: "1 234 m²",
    sold: false,
    features: ["Video-prohlídka", "Exkluzivně"],
    type: "Pozemek",
    zakázka: "ID 205-NP12481",
    mapCoords: { lat: 49.8815, lng: 14.8611 },
    description: [
      "Dovoluji si Vám nabídnout na prodej krásný svažitý pozemek o celkové výměře 1 234 m² v obci Vlkančice, v části Pyskočely. Tato oblíbená chatová oblast je obklopená zelení, klidem a nachází se jen pár kroků od řeky Sázavy, která je vyhledávaným místem pro vodáky, milovníky přírody i rybáře. Pozemek je tvořen spojením tří parcel a navíc získáte poloviční spoluvlastnický podíl na sousední lesní parcele (209 m²), což ještě více podtrhuje rekreační charakter tohoto místa + manipulační možnosti.",
      "Pozemek je oplocený ze tří stran, má nově vybudovanou vrtanou studnu o hloubce 16 m (vybudovanou v červnu 2023 a vystrojenou skružemi) a přípojku na třífázový elektrický proud – tedy základní komfort, který výrazně usnadní další využití.",
      "Dle územního plánu je pozemek vedený v ploše „RI – Rekreace, plochy staveb pro rodinnou rekreaci“, což znamená:",
      "• hlavní využití pro výstavbu rekreačních chat,",
      "• přípustné jsou i doplňkové stavby (skleníky, pergoly, bazény, stavby na uskladnění nářadí či plodin),",
      "• zastavěná plocha vlastním rekreačním objektem činí 25 m², případné navýšení dle projektu a schválení úřadu",
      "• podíl zastavěných a zpevněných ploch max. 25% v rámci pozemku",
      "• jedno nadzemní podlaží + podkroví,",
      "• na parcele je nutné zřídit alespoň 1 parkovací místo pro automobil,",
      "• případné přístavby stávajících objektů musí být vždy směrem od lesa.",
      "Obec Vlkančice nabízí základní občanskou vybavenost – Obecní úřad, obchod, restauraci. Veškeré širší služby naleznete v nedaleké Stříbrné Skalici či Sázavě. Dopravní dostupnost je velmi dobrá: autem se snadno napojíte na D1 i D3, cesta do Prahy trvá přibližně 30 minut, v obci funguje i autobusové spojení.",
      "Okolí nabízí nádherné výhledy do zeleně, dostatek soukromí i možnost napojit se na turistické a cyklistické stezky. Díky blízkosti řeky Sázavy je lokalita atraktivní také pro rybáře či aktivní odpočinek u vody. Přístup je zajištěn po obecní komunikaci, lokalita je celoročně dobře dostupná.",
      "Pokud hledáte místo pro vybudování vlastní chaty nebo zahradního útočiště v srdci přírody, jen kousek od Prahy, tento pozemek je ideální volbou.",
    ],
  },
  {
    id: 26,
    slug: "chata-kersko",
    image: kerskoImages[0],
    images: kerskoImages,
    floorPlans: kerskoFloorPlans,
    videos: [
      { youtubeId: "VOpE_risffE", title: "Video-prohlídka" },
    ],
    title: "Prodej chaty 3+1 na lesním pozemku 3 226 m², Hradišťko – Kersko",
    location: "Hradišťko · Kersko",
    price: "3 875 Kč/m²",
    priceNote: "vč. provize a právních služeb",
    size: "96 m²",
    landSize: "3 226 m²",
    disposition: "3+1",
    sold: false,
    features: ["Video-prohlídka"],
    type: "Chata",
    zakázka: "ID 205-NP09302",
    mapCoords: { lat: 50.1582, lng: 14.9019 },
    description: [
      "Dovoluji si Vám nabídnout prodej dřevostavby s evidenčním číslem 321 na prostorném pozemku 3 226 m² v obci Hradišťko – Kersko.",
      "Chata o velikosti 3+1 má užitnou plochu 96 m². Je tvořena prostorným obývacím pokojem 24,5 m², kuchyní 23 m², dvěma ložnicemi 11 m² a 10,5 m², koupelnou s vanou a toaletou, prostorným zádveřím a komorou.",
      "Na pozemek je přímý vjezd z hlavní silnice. Pozemek se nachází 100 m od autobusové zastávky a 200 m od chaty pana Hrabala.",
      "Vzrostlé stromy i velikost pozemku nabízí nádherné soukromí a klid.",
      "Kersko je známé svým jedinečným uspořádáním přímo na lesních pozemcích, které zajišťují dostatek soukromí na prostorných parcelách.",
      "Základní občanská vybavenost je ve 2 km vzdálené obci Semice, kompletní vybavenost v Nymburku.",
      "Dobré dopravní spojení – u pozemku autobusová zastávka, 20 minut autem do Prahy.",
    ],
  },
  {
    id: 27,
    slug: "komercni-areal-nechanice",
    image: nechaniceImages[0],
    images: nechaniceImages,
    floorPlans: nechaniceFloorPlans,
    videos: [
      { youtubeId: "w5DnhOxQET0", title: "Video-prohlídka" },
    ],
    title: "Prodej rozlehlé komerční nemovitosti v obci Nechanice",
    location: "Nechanice · Hradec Králové",
    price: "14 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "1 100 m²",
    landSize: "967 m²",
    sold: false,
    features: ["Video-prohlídka"],
    type: "Komerční objekt",
    yearBuilt: "20. léta, úprava 2001",
    zakázka: "ID 205-NP12506",
    mapCoords: { lat: 50.2388, lng: 15.6319 },
    description: [
      "Nabízíme k prodeji objekt s historií, který byl poslední desetiletí využíván jako truhlářská výroba. Nachází se přímo v centru obce Nechanice, pouhých 16 km od Hradce Králové.",
      "Rozlehlý objekt s užitnou plochou přes 1 100 m² stojí na pozemku o výměře 967 m². Budova z 20. let minulého století prošla poslední úpravou v roce 2001.",
      "Dispozice objektu je přizpůsobena provozu výroby: v přízemí se nacházela hlavní výrobní část, v patře lakovna a dílny, půda sloužila jako sklad a strojovna výtahu i centrálního odsávání.",
      "Elektřina je přivedena samostatným kabelem od transformátoru s kapacitou 3×315 A – objekt je tedy připraven i na energeticky náročný provoz. Dále je napojen na plyn, má septik s přepadem do kanalizace a využívá vlastní studnu.",
      "Současná podoba nemovitosti nabízí široké spektrum možností využití – od pokračování v řemeslné výrobě, přes skladovací či lehký průmyslový provoz, až po přestavbu na bytové jednotky nebo jiné komerční využití.",
      "Nechanice jsou plně vybavenou obcí – najdete zde základní a mateřskou školu, poštu, obchody, ordinaci lékaře. Blízkost Hradce Králové zajišťuje další rozvojový potenciál.",
    ],
  },
  {
    id: 28,
    slug: "apartman-spindleruv-mlyn",
    image: spindlImages[0],
    images: spindlImages,
    floorPlans: spindlFloorPlans,
    videos: [
      { youtubeId: "Mbg6TCPOJ6Y", title: "Video-prohlídka" },
    ],
    title: "Prodej vybaveného apartmánu 2+kk v luxusním resortu, Špindlerův Mlýn",
    location: "Špindlerův Mlýn · Krkonoše",
    price: "12 950 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "60 m²",
    disposition: "2+kk",
    sold: true,
    features: ["Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP12038",
    mapCoords: { lat: 50.7303, lng: 15.6112 },
    description: [
      "Dovoluji si Vám nabídnout ke koupi prostorný a plně vybavený apartmán 2+kk o podlahové ploše téměř 60 m², který se nachází v klidné části Špindlerova Mlýna, v docházkové vzdálenosti od centra města.",
      "Apartmán se nachází v luxusním horském apartmánovém komplexu Luční dům.",
      "Dispozičně nabízí prostorný obývací pokoj s plně vybavenou kuchyňskou linkou, barovým pultem, jídelním stolem a rozkládací pohovkou, dále ložnici se dvěma manželskými postelemi, samostatnou šatnu s vestavěnými skříněmi a koupelnu s vanou a toaletou.",
      "K bytu náleží sklepní kóje o výměře 4,5 m², vybavená sušící skříní na oblečení a obuv. Kromě garážového stání v suterénu domu je k dispozici také druhé parkovací místo přímo před budovou.",
      "Provozní náklady jsou velmi příznivé: měsíční poplatek do fondu SVJ činí cca 3 000 Kč, zálohy na elektřinu 450 Kč.",
      "Apartmán je nabízen včetně veškerého vybavení a zařízení, je ve výborném technickém stavu a připraven k okamžitému užívání.",
      "Tato nemovitost představuje ideální příležitost pro rekreační využití, trvalé bydlení či jako výhodná investice s potenciálem pro krátkodobé pronájmy.",
    ],
  },
  {
    id: 29,
    slug: "dum-opolany",
    image: opolanyImages[0],
    images: opolanyImages,
    floorPlans: opolanyFloorPlans,
    videos: [
      { youtubeId: "J2WqOLjtZsw", title: "Video-prohlídka" },
    ],
    title: "Prodej rodinného domu 4+2 po kompletní rekonstrukci – apartmánový dům, Opolany",
    location: "Opolany · Nymburk",
    price: "8 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "110 m²",
    landSize: "527 m²",
    disposition: "4+2",
    sold: true,
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "1945, reko. 2020",
    zakázka: "ID 205-NP11759",
    mapCoords: { lat: 50.1283, lng: 15.1758 },
    description: [
      "Nabízíme k prodeji kompletně zrekonstruovaný a zateplený dvoupodlažní rodinný dům se zavedeným krátkodobým i dlouhodobým pronájmem v obci Opolany, jen pár minut od Poděbrad.",
      "Nemovitost prošla v roce 2020 celkovou rekonstrukcí – nová střecha, zateplení, rozvody vody, elektřiny, odpady, podlahy, vytápění tepelným čerpadlem LG. Celková užitná plocha činí cca 110 m² + garáž 17 m².",
      "Přízemí: Dva samostatné pokoje (18 m² a 20 m²), každý s vlastní koupelnou a WC, společná kuchyňka, technická místnost a vstupní hala se schodištěm.",
      "1. patro: Prostorný apartmán se dvěma ložnicemi (17 m² a 20 m²), kuchyní, koupelnou s WC a samostatným WC.",
      "Dům je aktivně využíván jako ubytovací zařízení s celkovou kapacitou 15 lůžek a průměrným hrubým ročním příjmem cca 1 200 000 Kč.",
      "Součástí prodeje je garáž a pozemek o celkové výměře 527 m² s pěknou udržovanou zahradou a krytou terasou s posezením.",
      "Lokalita nabízí ideální kombinaci klidu venkova a dostupnosti – Poděbrady 8 km, skvělé dopravní spojení směr Kolín, Praha.",
    ],
  },
  {
    id: 30,
    slug: "dum-kolovraty-kposte",
    image: kolovraty2Images[0],
    images: kolovraty2Images,
    floorPlans: kolovraty2FloorPlans,
    videos: [
      { youtubeId: "21ytFpKQqCg", title: "Video-prohlídka" },
    ],
    title: "Prodej RD 4+1 s balkónem, pozemek 428 m², ul. K Poště, Praha 10 – Kolovraty",
    location: "Praha 10 · Kolovraty",
    price: "9 990 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "110 m²",
    landSize: "428 m²",
    disposition: "4+1",
    sold: true,
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "30. léta 20. století",
    zakázka: "ID 205-NP11543",
    mapCoords: { lat: 50.0139, lng: 14.6286 },
    description: [
      "Exkluzivně nabízíme k prodeji samostatně stojící rodinný dům o dispozici 4+1 s užitnou plochou 110 m², situovaný v klidné a vyhledávané části Prahy 10 – Kolovraty, na adrese K poště 241/15.",
      "Dům se nachází na rovinatém pozemku o celkové výměře 428 m² a je ideální volbou pro klienty hledající nemovitost s potenciálem vlastního bydlení, podnikání nebo kombinace obojího.",
      "Dům byl postaven ve 30. letech 20. století, nachází se v udržovaném původním stavu a je určený ke kompletní rekonstrukci. Součástí nabídky je kompletní projektová dokumentace a platné stavební povolení na přístavbu a změnu užívání části domu na kavárnu.",
      "Přízemí tvoří vchod s předsíní 13 m², obývací pokoj 20,27 m², pokoj 15,78 m², kuchyně 4,64 m², koupelna, technická místnost a schodiště – 59 m².",
      "Patro domu tvoří pokoje 17,18 m² a 14,3 m², komora, chodba se vstupem na balkón 9,45 m² – 41 m².",
      "Kolovraty jsou známé svou rodinnou atmosférou. V místě je základní občanská vybavenost – MŠ, ZŠ, pošta, lékaři, restaurace, obchod, knihovna, letní koupaliště.",
      "Vynikající dopravní dostupnost – vlak 23 min. Hlavní nádraží, BUS 17 min. M Háje, nájezd na D1 – 10 minut.",
    ],
  },
  {
    id: 31,
    slug: "byt-soukalova-modrany",
    image: soukalImages[0],
    images: soukalImages,
    floorPlans: soukalFloorPlans,
    videos: [
      { youtubeId: "DXgq1uibLCk", title: "Video-prohlídka" },
    ],
    title: "Prodej světlého bytu 3+kk s prostornou lodžií, ul. Soukalova, Praha 4 – Modřany",
    location: "Praha 4 · Modřany",
    price: "10 490 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "69,6 m²",
    disposition: "3+kk",
    sold: true,
    features: ["Video-prohlídka"],
    type: "Byt",
    yearBuilt: "2016",
    zakázka: "ID 205-NP11981",
    mapCoords: { lat: 50.0037, lng: 14.4151 },
    description: [
      "Dovoluji si vám nabídnout velmi příjemný byt o dispozici 3+kk s prostornou lodžií (12,7 m²), nacházející se ve 3. NP moderního bytového domu z roku 2016, na adrese Soukalova 2180/2, Praha 4 – Modřany.",
      "Byt tvoří obývací pokoj s plně vybaveným kuchyňským koutem (22,6 m²) s přímým vstupem na zasklenou lodžii, dvě samostatné ložnice (14,1 m² a 11,0 m²), koupelna s vanou a samostatná toaleta.",
      "Plocha bytu činí 69,6 m² + lodžie 12,7 m². Byt je ve výborném technickém stavu a připraven k okamžitému nastěhování.",
      "Měsíční provozní náklady činí cca 5 400 Kč včetně příspěvku do fondu oprav + zálohy na internet 350 Kč a elektřinu cca 1 300 Kč.",
      "Lokalita nabízí vynikající občanskou vybavenost i dopravní dostupnost – MHD (tramvaj a autobus), MŠ, ZŠ, zdravotnická zařízení, obchody, restaurace a cyklostezka podél Vltavy.",
    ],
  },
  {
    id: 32,
    slug: "byt-na-chobote-repy",
    image: nachobotImages[0],
    images: nachobotImages,
    floorPlans: nachobotFloorPlans,
    videos: [
      { youtubeId: "L1eRffnniME", title: "Video-prohlídka" },
    ],
    title: "Prodej bytu 2+kk s lodžií, ul. Na Chobotě, Praha 6 – Řepy",
    location: "Praha 6 · Řepy",
    price: "6 390 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "45,9 m²",
    disposition: "2+kk",
    sold: true,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Byt",
    zakázka: "ID 205-NP12401",
    mapCoords: { lat: 50.0662, lng: 14.2971 },
    description: [
      "Nabízíme k prodeji byt v osobním vlastnictví o dispozici 2+kk s lodžií, v 1. NP panelového domu s výtahem, na adrese Na Chobotě 1347/12, Praha 6 – Řepy.",
      "Plocha bytu činí 45,9 m², k bytu náleží lodžie o výměře cca 6 m² a sklepní kóje 1,8 m².",
      "Byt tvoří obývací pokoj s kuchyňským koutem a vstupem na lodžii, samostatná ložnice, koupelna s toaletou a vstupní předsíň s úložným prostorem.",
      "Dům je panelový, vybavený výtahem a prošel revitalizací – plastová okna, nová střecha a zateplená fasáda.",
      "Měsíční náklady cca 6 500 Kč.",
      "Lokalita nabízí velmi dobrou dopravní dostupnost – konečná tramvajová zastávka Sídliště Řepy s přímým spojením do centra Prahy. Kompletní občanská vybavenost v místě.",
    ],
  },
  {
    id: 33,
    slug: "pozemek-zdiby-brnky",
    image: zdibyImages[0],
    images: zdibyImages,
    floorPlans: [],
    videos: [
      { youtubeId: "aFpZYt3khw0", title: "Video-prohlídka" },
    ],
    title: "Prodej stavebního pozemku 1 537 m², Zdiby – Brnky",
    location: "Zdiby · Brnky",
    price: "6 701 320 Kč",
    priceNote: "za nemovitost",
    size: "1 537 m²",
    landSize: "1 537 m²",
    disposition: "Stavební pozemek",
    sold: false,
    reserved: false,
    hidden: true,
    features: ["Video-prohlídka"],
    type: "Pozemek",
    zakázka: "",
    mapCoords: { lat: 50.1534, lng: 14.4170 },
    description: [
      "Nabízíme k prodeji stavební pozemek o rozloze 1 537 m², který se nachází v oblíbené lokalitě Zdiby – Brnky, v těsné blízkosti Prahy.",
      "Pozemek je svažitý, rozdělený do několika teras, osázený vzrostlými ovocnými stromy (třešně, jabloně, ořešák). V dolní části protéká potůček a nachází se zde i menší jezírko.",
      "Součástí prodeje je projektová dokumentace na výstavbu moderního nízkoenergetického rodinného domu (energetická třída A) včetně platného stavebního povolení. Dům je navržen jako přízemní s podkrovím, dvěma parkovacími místy a možností umístění bazénu.",
      "Inženýrské sítě (elektřina, vodovod, kanalizace) jsou přivedeny na pozemek. K dispozici je také vlastní studna.",
      "Po dostavbě sousedovi stavby bude vybudována nová cesta se závorou pouze pro tyto dva pozemky. Příspěvek obci na vybudování této cesty ve výši 700 000 Kč byl již uhrazen.",
      "Lokalita Brnky nabízí příjemné bydlení na klidném místě – autem za 25 minut v centru Prahy. Autobusová zastávka PID kousek od pozemku, v Kobylisích za 20 minut. V budoucnu plánované prodloužení tramvajové tratě až do Zdib.",
      "Ideální místo pro rodinné bydlení s klidem přírody a výbornou dostupností do města.",
    ],
  },
  {
    id: 34,
    slug: "pozemek-panenske-brezany",
    image: brezanyImages[0],
    images: brezanyImages,
    floorPlans: [],
    videos: [
      { youtubeId: "FTrY21-FqTw", title: "Video-prohlídka" },
    ],
    title: "Prodej rohového pozemku 800 m², Panenské Břežany",
    location: "Panenské Břežany",
    price: "8 500 000 Kč",
    priceNote: "za nemovitost",
    size: "800 m²",
    landSize: "800 m²",
    disposition: "Stavební pozemek",
    sold: false,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Pozemek",
    zakázka: "",
    mapCoords: { lat: 50.2171, lng: 14.4441 },
    description: [
      "V Panenských Břežanech nabízíme k prodeji stavební pozemek o výměře 800 m². Nachází se v klidné části obce, mimo hlavní silnice, v sousedství zeleně.",
      "Součástí prodeje je stavební povolení i projektová dokumentace na moderní zajímavou stavbu domu.",
      "Pozemek je rohový, mírně svažitý, ale díky již provedeným terénním úpravám je připravený k okamžité výstavbě. Na severní části pozemku jsou vzrostlé stromy, které vytváří příjemné soukromí.",
      "Inženýrské sítě – elektřina, vodovod a kanalizace – jsou v dosahu u pozemku.",
      "Panenské Břežany jsou atraktivní lokalitou spojující přírodu, historii a pohodlnou dostupnost do Prahy. Obec je známá díky baroknímu zámku a krásnému zámeckému parku. V obci najdete MŠ, ZŠ, obchod, restauraci, kavárnu a sportovní hřiště.",
      "Do centra Prahy se dostanete autem přibližně za 20 minut. Autobusová zastávka s přímým spojením na metro C (Letňany) je v docházkové vzdálenosti. Rychlé napojení na dálnici D8.",
    ],
  },
  {
    id: 35,
    slug: "vila-rotenska-kyje",
    image: rotenskaImages[0],
    images: rotenskaImages,
    floorPlans: [],
    videos: [
      { youtubeId: "G5VTGnzvlyY", title: "Video-prohlídka" },
    ],
    title: "Prodej prostorného luxusního domu s vnitřním atriem, Praha 9 – Kyje",
    location: "Praha 9 · Kyje",
    price: "59 950 000 Kč",
    priceNote: "za nemovitost",
    size: "360 m²",
    disposition: "Atypický RD",
    sold: false,
    reserved: false,
    features: ["Video-prohlídka", "3D Scan"],
    type: "Dům",
    zakázka: "",
    mapCoords: { lat: 50.0756, lng: 14.5256 },
    matterportUrl: "https://my.matterport.com/show/?m=xoNNkdtwtNM&vr=0&play=1&search=0&mt=1&title=0",
    description: [
      "Nabízíme prodej prostorného atypického rodinného domu na adrese Rotenská 540, Praha 9 – Kyje.",
      "Stavba z roku 2012 nabízí přes 360 m² užitné plochy a vnitřní zatravněné atrium téměř 130 m². Důmyslně promyšlené provedení a použití kvalitních materiálů nabízí mimořádný pocit bydlení.",
      "Interiér byl kompletně vyroben na zakázku a je vybaven moderními technologiemi – chytrá domácnost Crestron, centrální lux HUSKY, kamerový systém uvnitř atria včetně laserových závor kolem domu.",
      "Kuchyňská linka vybavena spotřebiči Miele, obývací stěna na dálkové ovládání, mramorový elektrický krb. Dominantou ložnice je hvězdné nebe z optických vláken + koupelna Swarovski.",
      "Ve wellness části je bazén s tryskami a masážním vodopádem, sauna s dvojsystémem (pára a suchá), muzikoterapie a bar s lednicí.",
      "Podlahy z italského mramoru s podlahovým vytápěním, rekuperace s chladící jednotkou, topení 3 stometrovými vrty tepelného čerpadla Viessmann.",
      "Tento dům vyniká svou unikátností a luxusním charakterem, které osloví i ty nejnáročnější kupující.",
    ],
  },
  {
    id: 36,
    slug: "dum-drnovska-ruzyne",
    image: drnovskaImages[0],
    images: drnovskaImages,
    floorPlans: [],
    videos: [
      { youtubeId: "vV1UYtjOxZw", title: "Video-prohlídka" },
    ],
    title: "Prodej rozestavěného domu, ul. Drnovská, Praha 6 – Ruzyně",
    location: "Praha 6 · Ruzyně",
    price: "22 200 000 Kč",
    showPrice: true,
    priceNote: "",
    size: "665 m²",
    landSize: "671 m²",
    disposition: "Atypický",
    sold: true,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Dům",
    zakázka: "",
    mapCoords: { lat: 50.0822, lng: 14.3104 },
    description: [
      "Prodej rozestavěného domu určeného k bydlení s možností přestavby na ubytovací zařízení, penzion či komerční zaměření (projekt k dispozici).",
      "Nachází se na adrese Drnovská 12/51, Praha 6 – Ruzyně. Přízemí, postavené v kombinaci kámen a cihla, je 136 m² velké a garáž pro 3 vozy 56 m². Zbylá část domu je postavena z prefabrikovaného konstrukčního panelu systémem K-KONTROL.",
      "2. NP má 243 m² a 3. NP 174 m². Užitná plocha celkem 665 m². Celková výměra pozemku 671 m². Možnost nástavby 4. NP.",
      "Velký prostor nabízí několik variant k budoucímu využití, včetně dvora a zahrady.",
      "V okolí veškerá občanská vybavenost včetně školek, škol, do jednoho kilometru obora Hvězda + Bílá hora.",
      "MHD: bus přímo naproti, 150 m vlaková zastávka (bude spojení přímo na letiště), 400 m tramvaj.",
    ],
  },
  {
    id: 37,
    slug: "dum-dobrejovice",
    image: dobrejoviceImages[0],
    images: dobrejoviceImages,
    floorPlans: [],
    videos: [
      { youtubeId: "PP1az-ndslE", title: "Video-prohlídka" },
    ],
    title: "Prodej RD 3+1 s pozemkem 692 m², Dobřejovice, ul. Čestlická",
    location: "Dobřejovice",
    price: "5 990 000 Kč",
    priceNote: "za nemovitost",
    size: "100 m²",
    landSize: "692 m²",
    disposition: "3+1",
    sold: true,
    reserved: false,
    soldAt: "2025-05-20",
    features: ["Video-prohlídka"],
    type: "Dům",
    zakázka: "",
    mapCoords: { lat: 49.9936, lng: 14.5342 },
    description: [
      "Rodinný dům 3+1 s pozemkem 692 m² v atraktivní lokalitě na hranici Prahy – Dobřejovice, ul. Čestlická 57.",
      "Nemovitost bude prodána metodou realitní aukce RE/MAX a majitel má výhradní právo si budoucího kupujícího vybrat.",
      "Stavba z konce 19. století je postavena z cihel a břidlice. V současném stavu je určena ke kompletní rekonstrukci či demolici.",
      "Dům disponuje přibližnou obytnou plochou 100 m². Dispozice zahrnuje obytný prostor, kuchyni, ložnici, pokoj, koupelnu s vanou a toaletou, chodbu a dvě komory. Součástí je volný půdní prostor vhodný k vestavbě. Na dům navazuje původní stodola.",
      "Nemovitost je napojena na elektřinu, veřejný vodovod, kanalizaci, plyn a internet. K dispozici je vlastní kopaná studna (hloubka cca 4 m).",
      "Dobřejovice jsou vyhledávanou lokalitou v těsné blízkosti Prahy. Do centra Prahy dojedete během několika minut autem. Autobusové zastávky se spojením do Říčan, Průhonic nebo na metro C – Opatov.",
    ],
  },
  // --- Jelence ---
  {
    id: 38,
    slug: "chata-jelence",
    image: jelenceImages[0],
    images: jelenceImages,
    floorPlans: [],
    videos: [
      { youtubeId: "9dQD1t-kUp4", title: "Video-prohlídka" },
    ],
    title: "Prodej chaty 1+1 s pozemky 805 m², Jelence – Dolní Hbity",
    location: "Jelence – Dolní Hbity",
    price: "3 000 000 Kč",
    priceNote: "za nemovitost",
    size: "28 m²",
    landSize: "805 m²",
    disposition: "1+1",
    sold: true,
    soldAt: "2026-07-14",
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Chata",
    zakázka: "",
    mapCoords: { lat: 49.7142, lng: 14.2158 },
    description: [
      "Útulná podsklepená chata 1+1 s terasou, postavená v roce 1986, v oblíbené rekreační lokalitě Jelence č.ev. 7 – Dolní Hbity, jen pár minut od Orlické přehrady.",
      "Zastavěná plocha chaty činí 28 m² na pozemku 375 m². Součástí prodeje je sousedící samostatný stavební pozemek o výměře 402 m². Celková plocha obou pozemků činí 805 m².",
      "V chatě je kuchyňský kout s umyvadlem a průtokovým ohřívačem vody. Obytná místnost s krbovými kamny a doplňkovým topením. Koupelna s toaletou přístupná z terasy. V suterénu sklad, posezení a letní kuchyně.",
      "Na pozemku venkovní dílna a zahradní domek s technickým zázemím. Elektřina 220/380 V, voda z kopané studny i vrtu napojeného na obecní vodovod, obecní kanalizace.",
      "Klidná lokalita u lesa, možnost výstavby další chaty na stavebním pozemku. Výborná dostupnost z Prahy – dálnice D4 asi 15 minut jízdy. Blízkost Orlické přehrady – ideální pro rybáře, vodní sporty i rodinnou rekreaci.",
    ],
  },
  // --- U Kubínů ---
  {
    id: 40,
    slug: "penzion-u-kubinu",
    image: ukubinu1,
    images: ukubinuImages,
    floorPlans: ukubinuFloorPlans,
    videos: [
      { youtubeId: "Lk0Wp1_iows", title: "Video-prohlídka" },
    ],
    title: "Prodej penzionu U Kubínů, Přibyslav \u2013 15 pokojů, restaurace, bazén",
    location: "Přibyslav",
    price: "25 750 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "960 m²",
    landSize: "698 m²",
    disposition: "15 pokojů + restaurace + 2 byty",
    sold: false,
    reserved: false,
    hidden: true,
    features: ["Video-prohlídka"],
    type: "Komerční",
    yearBuilt: "14. století / rekonstrukce 1993\u20132008",
    zakázka: "ID 205-NP12429",
    mapCoords: { lat: 49.5825, lng: 15.7461 },
    description: [
      "Dovoluji si Vám nabídnout prodej zavedeného a vyhlášeného penzionu U Kubínů v Přibyslavi. Základní kámen ve 14. století, restaurace je v domě dle dohledaných dokumentů od roku 1823.",
      "Penzion disponuje užitnou plochou 960 m², zahrnuje 15 pokojů s koupelnami, restaurací s kuchyní, zahradní restaurací se samostatným výčepem, dostatečným zázemím (sklady, sklepy na víno i pivo) + garáží. Dále dvěma byty 2+1 a 3+1, ke kterým patří zimní zateplená zahrada (pavlač) a terasa o výměře 67 m² s bazénem s technologií na slanou vodu.",
      "K penzionu náleží pozemek o celkové rozloze 698 m². Dům prošel rekonstrukcí od roku 1993 až po nástavbu v roce 2008 včetně nové kanalizace 2021. Příprava, včetně povolení památkářů, na výtah.",
      "Suterén: 3x sklep (pivní pro restauraci, vinný a pro zahrádku s výtahem) + vlastní studna i vodárna + garáž 5x7 m s výjezdem na ulici Vyšehrad (střecha z mědi).",
      "1. patro: restaurace s 65 místy k sezení, barem z dubu. Kuchyně čistá, špinavá + suchý sklad a chladící box. Zastřešená zahrádka s výčepem pro 30 lidí a volným prostorem pro 50 lidí.",
      "2. patro: byt 3+1, byt 2+1. Obývací pavlač, terasa s bazénem a sklad pro čisté prádlo a dva dvoulůžkové pokoje.",
      "3. patro: luxusní pokoj s barokním nábytkem, vanou a výhledem do údolí Sázavy. 4x mezonet (1x pro invalidy) 4-5 lůžkový. Na tomto patře se nachází i sál pro 70 lidí.",
      "Nedaleko domu cyklostezka nedávno oceněna jako nejlepší v EU. Turistická sezóna běží i přes zimu (Nové Město na Moravě 30 minut autem).",
    ],
  },
  // --- Mirotín ---
  {
    id: 41,
    slug: "dum-mirotin",
    image: mirotin1,
    images: mirotinImages,
    floorPlans: mirotinFloorPlans,
    videos: [
      { youtubeId: "vb7x4AQmabk", title: "Video-prohlídka" },
    ],
    title: "Prodej domu 5+1, Mirotín \u2013 pozemek 6 133 m\u00B2",
    location: "Mirotín · okr. Pelhřimov",
    price: "3 500 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "170 m\u00B2",
    landSize: "6 133 m\u00B2",
    disposition: "5+1",
    sold: true,
    reserved: false,
    features: ["Video-prohlídka"],
    type: "Dům",
    yearBuilt: "1970",
    zakázka: "ID 205-NP10567",
    mapCoords: { lat: 49.3089, lng: 14.9859 },
    description: [
      "Prostorný dům 5+1 s pozemkem 6 133 m\u00B2 v obci Mirotín, okr. Pelhřimov, v krásné přírodě kraje Vysočina.",
      "Dům tvoří obytné přízemí a v patře je prostorná půda k dalšímu využití. Dispozice zahrnuje 3 ložnice, kuchyni, komoru, obytný prostor s jídelnou, koupelnu se sprchovým koutem, toaletu, kotelnu a sklad \u2013 celkem 170 m\u00B2.",
      "Původní stavba z roku 1970 byla v průběhu let částečně rekonstruována. V roce 2014 plastová okna (cca 3/4 domu), v roce 2020 kuchyně, koupelna, obytný prostor a vstupní dveře.",
      "Topení zajišťuje kotel na tuhá paliva, radiátory ve všech místnostech. IS: elektřina, voda (studna i obecní vodovod), kanalizace (jímka i obecní), plyn.",
      "U domu krásná udržovaná zahrada se vzrostlými stromy. Součástí prodeje jsou pozemky o výměře 6 133 m\u00B2, z čehož cca 5 000 m\u00B2 louky.",
      "Základní občanská vybavenost ve 2 km vzdálené obci Mnich. Kompletní služby v 7 km vzdálené Kamenici nad Lipou. Ideální pro trvalé i rekreační bydlení v přírodě.",
    ],
  },
  // --- Rabyně ---
  {
    id: 43,
    slug: "pozemek-rabyne-louti",
    image: rabyneImages[0],
    images: rabyneImages,
    floorPlans: [],
    videos: [
      { youtubeId: "VvYdqBVZg-k", title: "Video-prohl\u00EDdka" },
    ],
    title: "Stavebn\u00ED pozemek 2 512 m\u00B2 \u2013 Rabyn\u011B, Lout\u00ED, u Slapsk\u00E9 p\u0159ehrady",
    location: "Rabyn\u011B \u2013 Lout\u00ED",
    price: "2 900 K\u010D/m\u00B2",
    priceNote: "v\u010D. provize a pr\u00E1vn\u00EDch slu\u017Eeb",
    size: "2 512 m\u00B2",
    disposition: "stavebn\u00ED pozemek",
    sold: false,
    reserved: false,
    features: ["Video-prohl\u00EDdka"],
    type: "Pozemek",
    zak\u00E1zka: "ID 205-NP11735",
    mapCoords: { lat: 49.7970, lng: 14.4550 },
    description: [
      "Hledáte místo, které spojuje klid venkova s blízkostí přírody a zároveň nabízí skvělou investiční příležitost? Dovoluji si vám nabídnout výjimečný stavební pozemek o rozloze 2 512 m² v atraktivní lokalitě Rabyně – Loutí, jen pár minut od Slapské přehrady.",
      "Pozemek je kompletně připraven k výstavbě. K dispozici je vlastní vrtaná studna a rozvody elektřiny jsou navrženy pro dva samostatné domy. Zastavitelnost při rozdělení pozemku činí 20 procent, což umožňuje komfortní a prostornou výstavbu.",
      "## Občanská vybavenost a služby",
      "V okolí najdete základní občanskou vybavenost – mateřská a základní škola v Rabyni a nedalekých Netvořicích, obchody, pošta, lékárna a restaurace. Větší nabídku služeb poskytuje Neveklov nebo Nový Knín, vzdálené do 15 minut jízdy. V letní sezóně je oblast velmi živá, s možnostmi občerstvení, kempování a využitím přístaviště.",
      "## Dopravní dostupnost",
      "Dojezd do Prahy je zhruba 45 minut autem. V blízkosti je rychlé napojení na dálnici D4. V obci se nachází autobusová zastávka s přímými spoji do Neveklova a Benešova. Lokalita je také dostupná lodní dopravou z přehrady.",
      "## Život v přírodě s pohodlím",
      "Pozemek se nachází v klidné části Loutí, obklopený lesy a jen pár minut pěšky od pláží Slapské přehrady. Milovníci přírody, turistiky, cyklistiky, rybaření a vodních sportů zde najdou ideální podmínky. Ticho, čistý vzduch a krásné výhledy do krajiny vytváří prostředí, které si zamilujete.",
      "## Ideální pro trvalé bydlení, rekreaci i investici",
      "Tato nemovitost je vhodná jak pro výstavbu rodinného domu k trvalému bydlení, tak pro víkendové útočiště. Díky svému umístění a připravenosti k výstavbě je to i velmi zajímavá investice do budoucnosti.",
      "Neváhejte mě kontaktovat a domluvit si osobní prohlídku. Rád vám tuto jedinečnou lokalitu představím osobně.",
      "Prodávající si vyhrazuje právo vybrat kupujícího na základě jím zvolených kritérií.",
    ],
  },
  // --- Odolena Voda ---
  {
    id: 44,
    slug: "pozemek-odolena-voda",
    image: odolenaVodaImages[0],
    images: odolenaVodaImages,
    floorPlans: [],
    videos: [],
    title: "Prodej pozemku 10 874 m\u00B2, Odolena Voda, Praha \u2013 v\u00FDchod",
    location: "Odolena Voda \u00B7 Praha-v\u00FDchod",
    price: "990 K\u010D/m\u00B2",
    priceNote: "v\u010D. provize a pr\u00E1vn\u00EDch slu\u017Eeb",
    size: "10 874 m\u00B2",
    disposition: "pozemek",
    sold: false,
    reserved: false,
    features: [],
    type: "Pozemek",
    zak\u00E1zka: "ID 205-NP08211",
    mapCoords: { lat: 50.2345, lng: 14.4112 },
    description: [
      "Pozemek o rozloze 10 874 m\u00B2 v obci Odolena Voda, Praha \u2013 v\u00FDchod.",
      "Pozemek se nach\u00E1z\u00ED vedle tenisov\u00FDch kurt\u016F a soubor\u016F gar\u00E1\u017E\u00ED, mezi ulicemi Kv\u011Btnov\u00E1 \u2013 U Kurt\u016F \u2013 Ke Stadionu.",
      "Moment\u00E1ln\u011B v \u00FAzemn\u00EDm pl\u00E1nu OS 2 \u2013 ob\u010Dansk\u00E9 vybaven\u00ED \u2013 sport. Vhodn\u00E9 jako investice.",
    ],
  },
  // --- Točná ---
  {
    id: 45,
    slug: "pozemek-praha-4-tocna",
    image: tocnaImages[0],
    images: tocnaImages,
    floorPlans: [],
    videos: [
      { youtubeId: "JZ8J9u-xvAs", title: "Video-prohl\u00EDdka" },
    ],
    title: "Prodej pozemku 5 652 m\u00B2, Praha 4 \u2013 To\u010Dn\u00E1",
    location: "Praha 4 \u00B7 To\u010Dn\u00E1",
    price: "330 K\u010D/m\u00B2",
    priceNote: "v\u010D. provize a pr\u00E1vn\u00EDch slu\u017Eeb",
    size: "5 652 m\u00B2",
    disposition: "orn\u00E1 p\u016Fda",
    sold: false,
    reserved: false,
    features: ["Video-prohl\u00EDdka"],
    type: "Pozemek",
    zak\u00E1zka: "ID 205-NP09731",
    mapCoords: { lat: 49.9784, lng: 14.4332 },
    description: [
      "Jedine\u010Dn\u00E1 p\u0159\u00EDle\u017Eitost st\u00E1t se vlastn\u00EDkem 5 652 m\u00B2 kvalitn\u00ED orn\u00E9 p\u016Fdy na Praze 4 \u2013 To\u010Dn\u00E9.",
      "Mo\u017Enost p\u0159ikoupen\u00ED nedal\u00E9k\u00E9ho pozemku o rozloze 16 858 m\u00B2 (460 K\u010D/m\u00B2), k.\u00FA. Cholupice.",
      "Pozemek je ur\u010Den v\u00FDhradn\u011B pro zem\u011Bd\u011Blsk\u00E9 vyu\u017Eit\u00ED a p\u0159edstavuje ide\u00E1ln\u00ED investici. Jedn\u00E1 se o ucelen\u00FD soubor navazuj\u00EDc\u00ED na nezpevn\u011Bnou komunikaci, nedal\u00E9ko Pra\u017Esk\u00E9ho okruhu.",
    ],
  },
  // --- Jizbice ---
  {
    id: 46,
    slug: "pozemek-jizbice",
    image: jizbiceImages[0],
    images: jizbiceImages,
    floorPlans: [],
    videos: [
      { youtubeId: "zhyzpAkEOJg", title: "Video-prohlídka" },
    ],
    title: "Prodej pozemku 3 036 m², Jizbice u Nymburka",
    location: "Jizbice u Nymburka",
    price: "4 000 000 Kč",
    priceNote: "vč. provize a právních služeb",
    size: "3 036 m²",
    disposition: "stavební pozemek",
    sold: false,
    reserved: false,
    hidden: true,
    features: ["Video-prohlídka"],
    type: "Pozemek",
    zakázka: "ID 205-NP11181",
    mapCoords: { lat: 50.2577, lng: 14.9939 },
    description: [
      "Prodej zasíťovaného stavebního pozemku 3 036 m² v obci Jizbice u Nymburka.",
      "Pozemek je kompletně zasíťovaný (mimo plynu), určený k zástavbě rodinným domem. K dispozici je vypracovaný projekt domu včetně kompletní dokumentace.",
      "Nachází se v klidné části obce a jeho rozloha zajišťuje budoucím majitelům dostatek soukromí.",
      "Kompletní občanská vybavenost je v nedalekém, 9 km vzdáleném, městě Nymburk. Dopravní dostupnost – 15 minut bus Nymburk, napojení na D10 – 15 minut (Praha, Mladá Boleslav).",
      "Příjemným zpestřením jsou i okolní lesy, které nabízí možnost procházek či sportu. Pozemek je ideální pro rodinu, která upřednostňuje bydlení v klidné lokalitě, v soukromí a s rozumnou dostupností.",
    ],
  },
  // --- Průhonice (prodáno) ---
  {
    id: 145,
    slug: "pozemek-pruhonice-ricanska",
    image: pruhonicePozemekImages[0],
    images: pruhonicePozemekImages,
    floorPlans: [],
    title: "Prodej pozemku 1 648 m², Průhonice",
    location: "Průhonice · Říčanská",
    price: "26 000 000 Kč",
    size: "1 648 m²",
    disposition: "pozemek se stavbou",
    sold: true,
    soldAt: "2026-10-21",
    reserved: false,
    showPrice: true,
    features: ["Video-prohlídka"],
    videos: [{ youtubeId: "yqjNST7mX2Y", title: "Video-prohlídka" }],
    type: "Pozemek",
    mapCoords: { lat: 49.9995, lng: 14.5545 },
    description: [
      "Dovoluji si Vám nabídnout jedinečnou příležitost k pořízení pozemku 1 648 m² v centru Průhonic, na adrese Říčanská 450, pouhých 15 km od centra Prahy.",
      "Na pozemku stojí dvoupatrová zděná stavba s č.p. z roku 1994 s podlahovou plochou 176 m² a zahradní domek, přístup ke stavbě je zpevněný dlažebními kostkami. Zahrada je příjemně vzrostlá, z části i ovocnými stromy.",
      "Dle platného územního plánu obce se pozemek nachází v území BI-1, které umožňuje výstavbu dvoupatrového rodinného domu či bytového domu o třech bytových jednotkách, se zastavitelností 20 % pro hlavní stavbu a 4 % pro stavbu doplňkovou (např. bazén, zahradní posezení).",
      "Díky velikosti tohoto pozemku je zde velký prostor pro realizaci Vašeho vysněného bydlení.",
      "Průhonice jsou oblíbenou rezidenční oblastí proslulou krásnou přírodou, historickým zámkem a zámeckým parkem, zapsaným na seznamu světového dědictví UNESCO. Nabízí tak ideální prostředí pro klidné a harmonické bydlení v blízkosti veškeré občanské vybavenosti. Obchodní zóna, která nabízí kompletní služby, se nachází v sousedních Čestlicích.",
      "Vynikající dopravní spojení – nájezd na D1, bus „M“ C – Opatov – 15 minut.",
    ],
  },
];

export const getPropertyBySlug = (slug: string) => properties.find(p => p.slug === slug);
